/*! bluemoon-periods - v12.0.1 - 2025-03-11 - Copyright 2018 Thomson Reuters™. All rights reserved. */(function(angular) {
    'use strict';
    angular.module('bluemoon.periods', [
            'bm.periods.component.templates',
            'bento.modern',
            'ui.bootstrap',
            'pascalprecht.translate',
            'bluemoon.components'
        ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.periods')
        .factory('httpRequestManager', httpRequestManager);

    httpRequestManager.$inject = ['$q', '$http', 'HttpResponseData'];

    function httpRequestManager($q, $http, HttpResponseData) {
        var factory = {
            getAnonymousHttpPostConfig: getAnonymousHttpPostConfig,
            getAnonymousHttpDeleteConfig: getAnonymousHttpDeleteConfig,
            getAnonymousHttpPutConfig: getAnonymousHttpPutConfig,
            getAnonymousHttpGetConfig: getAnonymousHttpGetConfig,
            getAuthenticatedHttpPostConfig: getAuthenticatedHttpPostConfig,
            getAuthenticatedHttpDeleteConfig: getAuthenticatedHttpDeleteConfig,
            getAuthenticatedHttpPutConfig: getAuthenticatedHttpPutConfig,
            getAuthenticatedHttpGetConfig: getAuthenticatedHttpGetConfig,
            makeHttpRequest: makeHttpRequest,
            getBaseServiceUri: getBaseServiceUri
        };

        return factory;

        function getBaseServiceUri(){
            //return 'http://localhost:2014/wp/api/workpapers/v1/';
            var accountingApi = '/api/accounting/v1/';
            return accountingApi;
        }

        // Provide an anonymous $http generic config
        function getBaseAnonymousRequestConfig(restServiceMethod, requestData, requestType){
            if(restServiceMethod === null || angular.isUndefined(restServiceMethod)){
                return null;
            }

            var config = {};
            config.method = requestType.toUpperCase();
            config.url = getBaseServiceUri() + restServiceMethod;

            if (requestData !== null && angular.isDefined(requestData)){
                config.data = requestData;
            }

            config.cache = false;
            return config;
        }

        ////////// Anonymous

        function getAnonymousHttpPostConfig(restServiceMethod, requestData) {
            return getBaseAnonymousRequestConfig(restServiceMethod, requestData, 'POST');
        }

        function getAnonymousHttpDeleteConfig(restServiceMethod, requestData) {
            var config = getBaseAnonymousRequestConfig(restServiceMethod, requestData, 'DELETE');

            if(config === null){
                return null;
            }

            config.headers = {
                'Content-Type': 'application/json; charset=utf-8',
                'Compress-Data': 'true'
            };

            return config;
        }

        function getAnonymousHttpPutConfig(restServiceMethod, requestData) {
            var config = getBaseAnonymousRequestConfig(restServiceMethod, requestData, 'PUT');

            if(config === null){
                return null;
            }

            config.headers = {
                'Content-Type': 'application/json; charset=utf-8',
                'Compress-Data': 'true'
            };

            return config;
        }

        function getAnonymousHttpGetConfig(restServiceMethod) {
            var config = getBaseAnonymousRequestConfig(restServiceMethod, null, 'GET');

            if(config === null){
                return config;
            }

            config.headers = {
                'Content-Type': 'application/json; charset=utf-8',
                'Compress-Data': 'true',
                'Accept': 'application/json'
            };

            return config;
        }

        ////////// Authenticated

        function getBaseAuthenticatedRequestConfig(restServiceMethod, requestData, requestType){
            var config = getBaseAnonymousRequestConfig(restServiceMethod, requestData, requestType);

            if(config === null){
                return null;
            }

            config.headers = {
                'Content-Type': 'application/json; charset=utf-8',
                'Compress-Data': 'true',
                'Accept': 'application/json'
            };

            return config;
        }

        function getAuthenticatedHttpPostConfig(restServiceMethod, requestData) {
            return getBaseAuthenticatedRequestConfig(restServiceMethod, requestData, 'POST');
        }

        function getAuthenticatedHttpDeleteConfig(restServiceMethod, requestData) {
            return getBaseAuthenticatedRequestConfig(restServiceMethod, requestData, 'DELETE');
        }

        function getAuthenticatedHttpPutConfig(restServiceMethod, requestData) {
            return getBaseAuthenticatedRequestConfig(restServiceMethod, requestData, 'PUT');
        }

        function getAuthenticatedHttpGetConfig(restServiceMethod) {
            return getBaseAuthenticatedRequestConfig(restServiceMethod, null, 'GET');
        }

        // Make an asynchronous rest service call
        function makeHttpRequest(httpConfig) {
            var deferred = $q.defer();

            if(httpConfig === null || angular.isUndefined(httpConfig)){
//TODO: Trans - use "bmpp.httpRequestFactory.invalidRequest"
                deferred.reject(new HttpResponseData('error', 'WP.ERROR.INVALID_REQUEST', null, 'Invalid Request'));
                return deferred.promise;
            }

            $http(httpConfig).then(
                function(response) {
                    var status = angular.isUndefined(response) ? undefined : response.status;

                    // Make sure the status returned is successful
                    if(angular.isUndefined(status) || status < 200 || status > 299){
                        deferred.reject(new HttpResponseData('error', status, response.data, response.statusText));
                    } else {
                        deferred.resolve(new HttpResponseData('success', status, response.data, response.statusText));
                    }
                }, // TODO: UPDATE THIS WITH CORRECT ERROR FORMAT AND TRANSLATIONS
                function(response) {
                    deferred.reject(new HttpResponseData('error', response.status, response.data, response.statusText));
                }
            );

            return deferred.promise;
        }
    }
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.periods')
        .factory('HttpResponseData', httpResponseData);

    httpResponseData.$inject = [];

    function httpResponseData() {
        function HttpResponseData(result, status, data, message) {
            this.result = result;
            this.status = status;

            if (data !== null && angular.isObject(data) && angular.isDefined(data.data)) {
                this.data = data.data;
            } else {
                this.data = data;
            }

            this.message = message;
        }

        return HttpResponseData;
    }
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.periods')
        .factory('NotesClientManager', NotesClientManager);

    NotesClientManager.$inject = ['$q', 'httpRequestManager', 'AuthenticatedSessionData'];

    function NotesClientManager($q, httpRequestManager, AuthenticatedSessionData) {
        var factory = {
            getBindings: getBindings
        };
        return factory;

        function getBindings() {
            return AuthenticatedSessionData.getBindings();
        }
    }
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.periods').factory('bmppDataService', periodService);
    periodService.$inject = ['$q', 'httpRequestManager', 'AuthenticatedSessionData'];

    function periodService($q, httpRequestManager, AuthenticatedSessionData) {
        var accountingApi = '/api/accounting/v1/';
        var accountingApiV2 = '/api/accounting/v2/';
        var accountingApiV3 = '/api/accounting/v3/';

        var factory = {
            getAllPeriods: getAllPeriods,
            getAllFiscalYears: getAllFiscalYears,
            addNewFiscalYear: addNewFiscalYear,
            updateFiscalYear: updateFiscalYear,
            updatePeriods: updatePeriods,
            getAllAccounts: getAllAccounts,
            getTaxYears: getTaxYears,
            getCompanyId: getCompanyId,
            getRelatedContacts: getRelatedContacts,
            getTransactionCount: getTransactionCount,
            mapEditedPeriods: mapEditedPeriods
        };

        //run all requests through this method
        var handlePeriodRequest = function (config) {
            return httpRequestManager.makeHttpRequest(config).then(function (responseData) {
                return responseData;
            });
        };
        return factory;

        function addNewFiscalYear(ownerId, fiscalYear) {
            var config = httpRequestManager.getAuthenticatedHttpPostConfig('', fiscalYear);
            config.url = accountingApiV2 + ownerId + '/fiscalYear';
            return handlePeriodRequest(config);
        }

        function getAllFiscalYears(ownerId, suppressError) {
            //TODO: TEMPORARY HACK TO CLEAR fiscal years
            // bmppFiscalYearService.clearFiscalYears();
            var config = httpRequestManager.getAuthenticatedHttpGetConfig('');
            config.url = accountingApiV2 + ownerId + '/fiscalYear?includePeriods=true';
            if (suppressError) {
                config.global = false;
            }
            return handlePeriodRequest(config);
        }

        //gets all periods for a specific owner
        function getAllPeriods(ownerId, suppressError) {
            var config = httpRequestManager.getAuthenticatedHttpGetConfig('');
            config.url = accountingApi + ownerId + '/period';
            if (suppressError) {
                config.global = false;
            }
            return handlePeriodRequest(config);
        }

        //update/edit the fiscal year and its periods
        function updateFiscalYear(ownerId, fiscalYear, editPeriods, yearEndCloseOptions) {
            //if we are editing periods then use the edit periods end point
            if(editPeriods){
                var editConfig = httpRequestManager.getAuthenticatedHttpPutConfig('', fiscalYear);
                //time out is set to 5 minutes for this request
                editConfig.timeout = 300000;
                editConfig.url = accountingApiV2 + ownerId + '/fiscalYear/' + fiscalYear.id + '/periods';
                return handlePeriodRequest(editConfig);

            } else {
                var updateDto = {
                    fiscalYear: fiscalYear,
                    yearEndCloseSetting: yearEndCloseOptions
                };

                var config = httpRequestManager.getAuthenticatedHttpPutConfig('', updateDto);
                config.url = accountingApiV3 + ownerId + '/fiscalYear/' + fiscalYear.id;
                return handlePeriodRequest(config);
            }
        }

        //gets all periods for a specific owner
        function updatePeriods(ownerId, period) {
            var config = httpRequestManager.getAuthenticatedHttpPutConfig('', period);
            config.url = accountingApi + ownerId + '/period/' + period.id;
            return handlePeriodRequest(config);
        }

        //returns all of the accounts fro a given owner
        function getAllAccounts(ownerId, suppressError) {
            var config = httpRequestManager.getAuthenticatedHttpGetConfig('');
            config.url = accountingApi + ownerId + '/account/all';
            if (suppressError) {
                config.global = false;
            }
            return handlePeriodRequest(config);
        }

        //returns a list of tax schedules for the given owner id
        function getTaxYears(ownerId) {
            var config = httpRequestManager.getAuthenticatedHttpGetConfig('');
            config.url = accountingApi + ownerId + '/taxSchedule/vendor';
            return handlePeriodRequest(config);
        }

        //returns the company id from the session bindings
        function getCompanyId() {
            // TODO: THROW EXCEPTION WHEN NO BINDINGS OR COMPANYID
            return AuthenticatedSessionData.getBindings().then(function (bindings) {
                return bindings.ApplicationConfiguration.CompanyId;
            });
        }

        //returns a list of related contacts given a company id and contact id
        function getRelatedContacts(companyId, contactId) {
            var config = httpRequestManager.getAuthenticatedHttpGetConfig('');
            config.url = '/api/core/v7/companies/' + companyId + '/contacts/' + contactId + '/related-contacts?pagingInfo.itemsPerPage=10000&directionOf=false&orderBy=displayAs&restrictForDirection=false';
            return handlePeriodRequest(config);
        }

        function getTransactionCount(ownerId) {
            var config = httpRequestManager.getAuthenticatedHttpGetConfig('');
            config.url = accountingApi + ownerId + '/transactionCount';
            return handlePeriodRequest(config);
        }
        //map the periods
        function mapEditedPeriods(ownerId, fiscalYearDto){
            var config = httpRequestManager.getAuthenticatedHttpPutConfig('', fiscalYearDto);
            config.url = accountingApiV2 + ownerId + '/fiscalYear/' + fiscalYearDto.id + '/periods';
            //time out is set to 5 minutes for this request
            config.timeout = 300000;
            return handlePeriodRequest(config);
        }
    }
})(window.angular);

(function(angular) {
    'use strict';
    angular.module('bluemoon.periods').factory('bmppOwnerService', bmppOwnerService);
    bmppOwnerService.$inject = [];

    function bmppOwnerService() {
        var _ownerId = '';

        return {
            setOwnerId: setOwnerId,
            getOwnerId: getOwnerId,
        };

        //sets the ownerId
        function setOwnerId(ownerId) {
            _ownerId = ownerId;
        }

        //returns the ownerId
        function getOwnerId() {
            return _ownerId;
        }
    }
})(window.angular);

(function (angular, _, moment) {
    'use strict';
    angular.module('bluemoon.periods').factory('bmppFiscalYearService', bmppFiscalYearService);
    bmppFiscalYearService.$inject = ['$rootScope', 'bmppEvents', 'bmppTaxYearService', 'bmppApplicationTypeService'];

    function bmppFiscalYearService($rootScope, bmppEvents, bmppTaxYearService, bmppApplicationTypeService) {
        var _fiscalYears = [];
        var _selectedFiscalYear = {};
        var _fiscalYearWithCurrentPeriod;

        return {
            setFiscalYears: setFiscalYears,
            getFiscalYears: getFiscalYears,
            setSelectedFiscalYear: setSelectedFiscalYear,
            getSelectedFiscalYear: getSelectedFiscalYear,
            addFiscalYear: addFiscalYear,
            getNextFiscalYearBeginDate: getNextFiscalYearBeginDate,
            createFiscalYearDto: createFiscalYearDto,
            getLastFiscalYear: getLastFiscalYear,
            getFirstFiscalYear: getFirstFiscalYear,
            clearFiscalYears: clearFiscalYears,
            getSavedCurrentPeriod: getSavedCurrentPeriod,
            getFiscalYearById: getFiscalYearById
        };

        //sets the fical years
        //options parameter to set the selected fiscal year to a particular sequence number
        function setFiscalYears(fiscalYears, selectedSequenceNumber) {
            //iterate over the fiscal years and initialize the year end labels
            _.forEach(fiscalYears, function (fiscalYear) {
                //get the periods for the fiscal year
                fiscalYear.periods = _.sortBy(fiscalYear.periods, 'sequenceNumber');

                //get the first period for this fiscal year, so we can set the start date
                var firstPeriod = getFirstPeriod(fiscalYear.periods);
                if (angular.isDefined(firstPeriod)) {
                    fiscalYear.startDate = firstPeriod.startDate;
                }

                //iterate over the periods and initialize their labels
                _.forEach(fiscalYear.periods, function (period) {
                    initializePeriodLabels(period);
                });

                //after we load we want to setup the current periods
                _.forEach(fiscalYear.periods, function (period) {
                    if (period.isCurrentPeriod && period.periodType === 1) {
                        _fiscalYearWithCurrentPeriod = period.fiscalYearId;
                    }
                });

                //not that we have the start date, we can set the labels for the fiscal year
                initializeFiscalYearLabel(fiscalYear);
            });

            _fiscalYears = orderYearsBySequenceNumber(fiscalYears);

            //if the sequence number was provided, use that to set the selected sequence
            if (angular.isDefined(selectedSequenceNumber)) {
                setSelectedFiscalYear(_.find(fiscalYears, {
                    'sequenceNumber': selectedSequenceNumber
                }));
                //set the selected fiscal year to be the one with current period
            } else if (angular.isDefined(_fiscalYearWithCurrentPeriod)) {
                setSelectedFiscalYear(_.find(fiscalYears, {
                    'id': _fiscalYearWithCurrentPeriod
                }));
            } else {
                //set the selected fiscal year to the one with the minimum sequenceNumber
                setSelectedFiscalYear(_.max(fiscalYears, 'sequenceNumber'));
            }

            //now we need to set the tax years
            //now lets grab just the year from these UTC dates
            var years = [];
            _.forEach(fiscalYears, function (fiscalYear) {
                years.push(moment(fiscalYear.endDate).year());
            });

            var uniqueFiscalYears = _.uniq(years);
            bmppTaxYearService.setTaxYears(uniqueFiscalYears);

            $rootScope.$broadcast(bmppEvents.BMPP_FISCAL_YEARS_CHANGED);
        }

        //returns the fiscal years array
        function getFiscalYears() {
            return _fiscalYears;
        }

        //sets the selected fiscal year
        function setSelectedFiscalYear(selectedFiscalYear) {
            _selectedFiscalYear = selectedFiscalYear;
            $rootScope.$broadcast(bmppEvents.BMPP_SELECTED_FISCAL_YEAR_CHANGED);
        }

        //returns the selected fiscal year
        function getSelectedFiscalYear() {
            return _selectedFiscalYear;
        }

        //get a fiscal year by its ID
        function getFiscalYearById(fiscalYearId) {
            return _fiscalYears.find(function(year) {
                return year.id === fiscalYearId;
            });
        }

        //add a new fiscal year to the array
        function addFiscalYear(fiscalYear) {
            //set the start date for the new fiscal year
            //get the first period for this fiscal year, so we can set the start date
            var firstPeriod = getFirstPeriod(fiscalYear.periods);
            if (angular.isDefined(firstPeriod)) {
                fiscalYear.startDate = firstPeriod.startDate;
            }

            //initialize the labels for the new fiscal year's periods
            _.forEach(fiscalYear.periods, function (period) {
                initializePeriodLabels(period);
            });

            initializeFiscalYearLabel(fiscalYear);

            setSelectedFiscalYear(fiscalYear);

            _fiscalYears.push(fiscalYear);
            $rootScope.$broadcast(bmppEvents.BMPP_FISCAL_YEARS_CHANGED);
        }

        //gets the lastest date from a collection
        //returns a js date object
        function getNextFiscalYearBeginDate() {
            //grab the dates from the fiscal years array
            var lastFiscalYear = _.max(_fiscalYears, 'sequenceNumber');

            return moment(lastFiscalYear.endDate).add(1, 'days').toDate();
        }

        //creates a fiscal year dto, and initializes periods array
        function createFiscalYearDto(beginDate, endDate, sequenceNumber) {
            return {
                beginDate: beginDate,
                endDate: endDate,
                periods: [],
                sequenceNumber: sequenceNumber
            };
        }

        //adds a year end label property to the fiscal year
        //formats it using the moment library
        function initializeFiscalYearLabel(fiscalYear) {
            fiscalYear.yearBeginLabel = moment(fiscalYear.startDate).format('L');
            fiscalYear.yearEndLabel = moment(fiscalYear.endDate).format('L');
        }

        //initialize the period labels
        function initializePeriodLabels(period) {
            period.startDateLabel = moment(period.startDate).format('L');
            period.endDateLabel = moment(period.endDate).format('L');
            period.startDate = moment(period.startDate).toDate();
            period.endDate = moment(period.endDate).toDate();
        }

        //orders an array of fical years by their sequence number
        function orderYearsBySequenceNumber(fiscalYears) {
            return _.sortBy(fiscalYears, 'sequenceNumber');
        }

        //returns the first period in the collection
        function getFirstPeriod(periods) {
            //if there is only one period, return the period
            if (periods.length === 1) {
                return _.first(periods);
            } else { //otherwise return the lowest sequence number
                return _.min(periods, 'sequenceNumber');
            }
        }

        //returns the first fiscal year
        function getFirstFiscalYear() {
            return _.find(_fiscalYears, {
                'sequenceNumber': 1
            });
        }

        //returns the last fiscal year
        function getLastFiscalYear() {
            return _.max(_fiscalYears, 'sequenceNumber');
        }

        //clears the fiscal year array
        function clearFiscalYears() {
            _fiscalYears = [];
        }

        //Returns the current period saved in the back end
        function getSavedCurrentPeriod(useAccountingOnly) {
            //Checking against undefined check
            var useAccounting = useAccountingOnly || false;
            var currentPeriod;
            var applicationTypes = bmppApplicationTypeService.getApplicationTypes();

            if (angular.isDefined(_fiscalYearWithCurrentPeriod)) {
                var fiscalYearWithCp = _fiscalYears.find(function (year) {
                    return year.id === _fiscalYearWithCurrentPeriod;
                });

                //If we want to useAccounting, just set it to that. Otherwise use selected application
                var selectedApplication = useAccounting ?
                    applicationTypes.Accounting : bmppApplicationTypeService.getSelectedApplication();

                currentPeriod = fiscalYearWithCp.periods.find(function (period) {
                    return period.isCurrentPeriod && period.periodType === selectedApplication;
                });
            }

            return currentPeriod;
        }
    }
})(window.angular, window._, window.moment);

(function (angular) {
    'use strict';
    angular.module('bluemoon.periods').factory('bmppLocaleService', bmppLocaleService);

    bmppLocaleService.$inject = ['$q', 'bmEnvironment'];

    function bmppLocaleService($q, bmEnvironment) {

        var _countries = {
            argentina: {
                countryCode: 'AR',
                localeCode: 'es-AR'
            }
        };
        var _grantedCountry = {};

        return {
            loadEnviornments: loadEnviornments,
            isArgentina: isArgentina
        };

        //call get to get the user's current environment
        function loadEnviornments() {
            return bmEnvironment.getEnvironmentAsync().then(function (response) {
                angular.forEach(_countries, function (country) {
                    if (country.countryCode === response.countryCode) {
                        _grantedCountry = country;
                    }
                });

                return _grantedCountry;
            });
        }

        //is the user currently in argentina
        function isArgentina() {
            return _grantedCountry.countryCode === _countries.argentina.countryCode;
        }
    }
})(window.angular);

(function(angular) {
    'use strict';
    angular.module('bluemoon.periods').factory('bmppAccountsService', bmppAccountsService);
    bmppAccountsService.$inject = [];

    function bmppAccountsService() {
        var _accounts = '';

        return {
            setAccounts: setAccounts,
            getAccounts: getAccounts,
            hasAccounts: hasAccounts
        };

        //sets the accounts
        function setAccounts(accounts) {
            if (angular.isArray(accounts)) {
                _accounts = accounts;
            } else {
                _accounts = [];
            }
        }

        //returns the accounts
        function getAccounts() {
            return _accounts;
        }

        //returns true if they have accounts
        function hasAccounts() {
            return _accounts.length > 0;
        }
    }
})(window.angular);

(function(angular, _, moment) {
    'use strict';
    angular.module('bluemoon.periods').factory('bmppPeriodService', bmppPeriodService);
    bmppPeriodService.$inject = ['bmppApplicationTypeService'];

    function bmppPeriodService(bmppApplicationTypeService) {
        var _periods = [];
        var _currentPeriod = {};
        var _applicationTypes = bmppApplicationTypeService.getApplicationTypes();

        return {
            setPeriods: setPeriods,
            getPeriods: getPeriods,
            setCurrentPeriod: setCurrentPeriod,
            getCurrentPeriod: getCurrentPeriod,
            validatePeriodDate: validatePeriodDate,
            replacePeriodsForCurrentApplication: replacePeriodsForCurrentApplication,
            updatePeriodDate: updatePeriodDate,
            createPeriodDto: createPeriodDto,
            isAccountingPeriod: isAccountingPeriod,
            isFixedAssetsPeriod: isFixedAssetsPeriod,
            isFirmPeriod: isFirmPeriod,
        };

        //sets the periods
        function setPeriods(periods) {
            //grab the period with the isCurrentPeriod flag
            //TODO: UPDATE CURRENT PERIOD CODE
            // var currentPeriod = _.find(periods, {
            //     'isCurrentPeriod': true
            // });
            //
            // if (angular.isDefined(currentPeriod)) {
            //     setCurrentPeriod(currentPeriod);
            // } else {
            //     //if we have no current period, initialize to a blank period
            //     setCurrentPeriod({
            //         id: ''
            //     });
            // }
            _periods = periods;
        }

        //returns the period array
        function getPeriods() {
            return _periods;
        }

        //sets the current period
        function setCurrentPeriod(period) {
            _currentPeriod = period;
        }

        //returns the current period
        function getCurrentPeriod() {
            return _currentPeriod;
        }

        //function that takes in the period to edit and checks to make sure that the start date
        //does not exceed the next period's end date
        function validatePeriodDate(period, nextPeriod, fiscalYearBegin, fiscalYearEnd, isFirstPeriod, isLastPeriod) {
            var returnObject = {
                isValid: true,
                errors: {}
            };

            //if it is the first period, it cannot end before the fiscal year begin date
            if (isFirstPeriod && !angular.isUndefined(fiscalYearBegin)) {
                var isFirstPeriodEndDateBeforeFiscalYearBegin = moment(period.endDate).isBefore(fiscalYearBegin);
                if (isFirstPeriodEndDateBeforeFiscalYearBegin) {
                    returnObject.isValid = false;
                    //TODO: Trans - use "bmpp.bmppUiService.errorBeforeBegin"
                    // returnObject.errors.push('The first period\'s end date is before the fiscal year begin');
                    returnObject.errors.yearBeginError = true;
                }
            }

            //if its the last period, it has to equal the fiscal year end
            if (isLastPeriod && !angular.isUndefined(fiscalYearEnd)) {
                var isLastPeriodAfterFiscalYearEnd = moment(period.endDate).isAfter(fiscalYearEnd);
                if (isLastPeriodAfterFiscalYearEnd) {
                    returnObject.isValid = false;
                    //TODO: Trans - "bmpp.bmppUiService.errorAfterEnd"
                    // returnObject.errors.push('The last period\'s end date must not be after the fiscal year end');
                    returnObject.errors.yearEndError = true;
                }
            }

            //make sure next period is defined
            //if its not, any period is valid
            if (!angular.isUndefined(nextPeriod)) {
                var isPeriodEndDateBeforeNextPeriodEndDate = moment(period.endDate).isBefore(nextPeriod.endDate);
                if (!isPeriodEndDateBeforeNextPeriodEndDate) {
                    returnObject.isValid = false;
                    //TODO: Trans - "bmpp.bmppUiService.errorUnique"
                    // returnObject.errors.push('The period end date cannot exceeed the next period\'s end date');
                    returnObject.errors.overlapError = true;
                }
            }

            return returnObject;
        }

        //replaces the periods with an updated set of periods
        //for the currently selected application
        function replacePeriodsForCurrentApplication(updatedPeriods) {
            //first lets grab the currently selected application
            var selectedApplication = bmppApplicationTypeService.getSelectedApplication();

            //now we want to remove all periods for the selected application
            _.remove(_periods, function(period) {
                return period.periodType === selectedApplication;
            });

            //now we want to give the updated periods the selected application as their period type
            _.forEach(updatedPeriods, function(updatedPeriod) {
                updatedPeriod.periodType = selectedApplication;
            });

            //now add the updated periods to _periods
            _periods = _periods.concat(updatedPeriods);
        }

        //updates the next periods start date to 1 day after the current periods end date
        function updatePeriodDate(period, nextPeriod) {
            if (!angular.isUndefined(nextPeriod)) {
                nextPeriod.startDate = moment(period.endDate).add(1, 'days').toDate();
            }
        }

        //creates a period dto with a begin and end date
        function createPeriodDto(beginDate, endDate, sequenceNumber) {
            return {
                startDate: beginDate,
                endDate: endDate,
                sequenceNumber: sequenceNumber,
                endDateLabel:  moment(endDate).format('L')
            };
        }

        function isAccountingPeriod(period) {
            return period.periodType === _applicationTypes.Accounting;
        }

        function isFirmPeriod(period) {
            return period.periodType === _applicationTypes.Firm;
        }

        function isFixedAssetsPeriod(period) {
            return period.periodType === _applicationTypes.FixedAssets;
        }
    }
})(window.angular, window._, window.moment);

(function(angular, _) {
    'use strict';
    angular.module('bluemoon.periods').factory('bmppFrequencyService', bmppFrequencyService);
    bmppFrequencyService.$inject = ['$translate', '$q', 'bmppApplicationTypeService'];

    function bmppFrequencyService($translate, $q, bmppApplicationTypeService) {
        var applicationTypes = bmppApplicationTypeService.getApplicationTypes();

        //TODO: Trans - use bmpp.commonFrequency.XXX for these.
        var _frequencies = [{
            Display: 'Annual',
            Value: 1,
            Type: 1,
            Applications: [applicationTypes.Accounting, applicationTypes.Firm, applicationTypes.FixedAssets]
        }, {
            Display: 'Monthly',
            Value: 12,
            Type: 4,
            Applications: [applicationTypes.Accounting, applicationTypes.Firm]
        }, {
            Display: 'Quarterly',
            Value: 4,
            Type: 3,
            Applications: [applicationTypes.Accounting, applicationTypes.Firm]
        }, {
            Display: 'Weekly',
            Value: 52,
            Type: 5,
            Applications: [applicationTypes.Accounting, applicationTypes.Firm]
        }, {
            Display: '13 Periods',
            Value: 13,
            Type: 6,
            Applications: [applicationTypes.Accounting, applicationTypes.Firm]
        }, {
            Display: 'Semi-Annual',
            Value: 2,
            Type: 2,
            Applications: [applicationTypes.Accounting, applicationTypes.Firm]
        }, {
            Display: 'Custom',
            Value: 0,
            Type: 7,
            Applications: [applicationTypes.Accounting, applicationTypes.Firm]
        }];

        return {
            getFrequencies: getFrequencies,
            getFrequenciesForAccounting: getFrequenciesForAccounting,
            getFrequencyByValue: getFrequencyByValue,
            isCustomFrequency: isCustomFrequency,
            loadFrequencyTranslationStrings : loadFrequencyTranslationStrings
        };

        //returns the frequencies
        function getFrequencies() {
            return _frequencies.filter(function (f) {
                return _.contains(f.Applications, bmppApplicationTypeService.getSelectedApplication());
            });
        }

        //returns the frequencies for accounting specifically
        function getFrequenciesForAccounting() {
            return _frequencies.filter(function (f) {
                return _.contains(f.Applications, applicationTypes.Accounting);
            });
        }

        //returns true if the frequency has a display value of Custom
        function isCustomFrequency(frequency) {
            return frequency.Type === 7;
        }

        //returns the frequency given a Value
        function getFrequencyByValue(value) {
            var frequency = _.find(_frequencies, {
                'Value': value
            });
            if (angular.isDefined(frequency)) {
                return frequency;
            } else { //if we don't get a match, return Custom for the frequency
                //TODO: Trans - use bmpp.commonFrequency.custom,  or the value of _frequencies.custom for this.
                return _.find(_frequencies, {
                    'Display': 'Custom'
                });
            }
        }

        //loads the translation strings for the frequency dropdown
        function loadFrequencyTranslationStrings() {
            return $q.all([
                $translate('bmpp.commonFrequency.annual'),
                $translate('bmpp.commonFrequency.monthly'),
                $translate('bmpp.commonFrequency.quarterly'),
                $translate('bmpp.commonFrequency.weekly'),
                $translate('bmpp.commonFrequency.thirteen'),
                $translate('bmpp.commonFrequency.semiAnnual'),
                $translate('bmpp.commonFrequency.custom')
            ]).then(function(frequencyTranslations) {
                _frequencies[0].Display = frequencyTranslations[0];
                _frequencies[1].Display = frequencyTranslations[1];
                _frequencies[2].Display = frequencyTranslations[2];
                _frequencies[3].Display = frequencyTranslations[3];
                _frequencies[4].Display = frequencyTranslations[4];
                _frequencies[5].Display = frequencyTranslations[5];
                _frequencies[6].Display = frequencyTranslations[6];
            });
        }
    }
})(window.angular, window._);

(function(angular) {
    'use strict';
    angular.module('bluemoon.periods').factory('bmppApplicationTypeService', bmppApplicationTypeService);
    bmppApplicationTypeService.$inject = ['$rootScope', 'bmppEvents'];

    function bmppApplicationTypeService($rootScope, bmppEvents) {
        //enumeration for the different application types
        var _applicationTypes = {
            Accounting: 1,
            Firm: 2,
            FixedAssets : 3
        };
        var _selectedApplication = 0;

        return {
            getApplicationTypes: getApplicationTypes,
            setSelectedApplication: setSelectedApplication,
            getSelectedApplication: getSelectedApplication
        };

        //returns the applicationType
        function getApplicationTypes() {
            return _applicationTypes;
        }

        //sets the selected application
        function setSelectedApplication(application) {
            if (application !== _selectedApplication) {
                _selectedApplication = application;
                $rootScope.$broadcast(bmppEvents.BMPP_SELECTED_APPLICATION_CHANGED);
            }
        }

        //returns the selected application
        function getSelectedApplication() {
            return _selectedApplication;
        }
    }
})(window.angular);

(function(angular) {
    'use strict';
    angular.module('bluemoon.periods').factory('bmppBusyLoaderService', bmppBusyLoaderService);
    bmppBusyLoaderService.$inject = [];

    function bmppBusyLoaderService() {
      //because multiple places may turn on the busy loader at the same time
      //we want to keep an integer of the number of watchers
      //the loader is considered busy if the watchers is greater than 0
      var _watchers = 0;
      return {
          turnOnBusyLoader: turnOnBusyLoader,
          turnOffBusyLoader: turnOffBusyLoader,
          isLoaderBusy: isLoaderBusy
      };

      //increments the watchers value
      function turnOnBusyLoader() {
          _watchers += 1;
      }

      //decrements the watchers value
      function turnOffBusyLoader() {
          _watchers -= 1;
      }

      //returns true if there are any active watchers
      function isLoaderBusy() {
          return _watchers > 0;
      }
    }
})(window.angular);

(function (angular, moment, _) {
    'use strict';
    angular.module('bluemoon.periods').factory('bmppCreateFiscalYearService', bmppCreateFiscalYearService);
    bmppCreateFiscalYearService.$inject = ['bmppDateManipulatorService', 'bmppPeriodService', 'bmppFiscalYearService'];

    function bmppCreateFiscalYearService(bmppDateManipulatorService, bmppPeriodService, bmppFiscalYearService) {

        return {
            createFiscalYear: createFiscalYear,
            initializeEmptyFiscalYear: initializeEmptyFiscalYear
        };

        //returns an empty fiscal year object
        function initializeEmptyFiscalYear() {
            return {
                periods: []
            };
        }

        //set up a new year with periods
        function createFiscalYear(beginDate, endDate, frequency, sequenceNumber) {
            var newYear = bmppFiscalYearService.createFiscalYearDto(beginDate, endDate, sequenceNumber);
            switch (frequency.Value) {

                case 1:
                    createAnnualYear(newYear);
                    break;
                case 2:
                    createSemiAnnualYear(newYear);
                    break;
                case 4:
                    createQuarterlyYear(newYear);
                    break;
                case 12:
                    createMonthlyYear(newYear);
                    break;
                case 52:
                    create52WeekYear(newYear);
                    break;
                case 13:
                    create13Year(newYear);
                    break;
                case 0:
                    createCustomYear(newYear, frequency.customFrequency);
                    break;
                default:
                    createCustomYear(newYear, frequency.Value);
                    break;
            }

            return newYear;
        }

        //creates a fiscal year dto with custom periods
        function createCustomYear(newCustomYear, customFrequency) {
            createYearWithVariablePeriods(newCustomYear, customFrequency);
            return newCustomYear;
        }

        //creates a fiscal year dto with 1 period
        function createAnnualYear(newAnnualYear) {
            newAnnualYear.periods.push(bmppPeriodService.createPeriodDto(newAnnualYear.beginDate, moment(newAnnualYear.endDate).toDate(), 1));
        }

        //creates a fiscal year dto with 2 periods
        function createSemiAnnualYear(newSemiAnnualYear) {
            //how many months are
            var dateRangeInMonths = bmppDateManipulatorService.numberOfMonthsInRange(newSemiAnnualYear.beginDate, newSemiAnnualYear.endDate);
            var firstPeriodEndDate = bmppDateManipulatorService.addMonths(newSemiAnnualYear.beginDate, (dateRangeInMonths / 2));
            firstPeriodEndDate = bmppDateManipulatorService.addDays(firstPeriodEndDate, -1);
            var secondPeriodBeginDate = bmppDateManipulatorService.addDays(firstPeriodEndDate, 1);
            newSemiAnnualYear.periods.push(bmppPeriodService.createPeriodDto(newSemiAnnualYear.beginDate, firstPeriodEndDate, 1));
            newSemiAnnualYear.periods.push(bmppPeriodService.createPeriodDto(secondPeriodBeginDate, moment(newSemiAnnualYear.endDate).toDate(), 2));
        }

        //creates a fiscal year dto with 12 periods
        function createMonthlyYear(newMonthlyYear) {
            var dateRange = moment().range(newMonthlyYear.beginDate, newMonthlyYear.endDate);
            var periodBegin;
            var sequenceNumber = 1;
            dateRange.by('months', function (moment) {
                if (angular.isUndefined(periodBegin)) {
                    periodBegin = moment.toDate();
                } else {
                    var periodEnd = moment.subtract(1, 'days').toDate();
                    newMonthlyYear.periods.push(bmppPeriodService.createPeriodDto(periodBegin, periodEnd, sequenceNumber));
                    periodBegin = moment.toDate();
                    sequenceNumber++;
                }
            });

            //add in the final period
            newMonthlyYear.periods.push(bmppPeriodService.createPeriodDto(bmppDateManipulatorService.addDays(periodBegin, 1), moment(newMonthlyYear.endDate).toDate(), sequenceNumber));

            return newMonthlyYear;
        }

        //creates a fiscal year dto with 4 periods
        function createQuarterlyYear(newQuarterlyYear) {
            var dateRangeInDays = bmppDateManipulatorService.numberOfDaysInRange(newQuarterlyYear.beginDate, newQuarterlyYear.endDate);
            //if they are using a full fiscal year, then we want to use the last day of every three months for their periods
            if (dateRangeInDays === 364 || dateRangeInDays === 365) {
                var dateRange = moment().range(newQuarterlyYear.beginDate, newQuarterlyYear.endDate);
                var periodBegin;
                var sequenceNumber = 1;
                var iterationNumber = 1; //we want to create a period every three months
                dateRange.by('months', function (moment) {
                    if (angular.isUndefined(periodBegin)) {
                        periodBegin = moment.toDate();
                        iterationNumber--; //this is the first time through so we want to decrement down to zero, as it will be incremented back to 1 below
                    } else if (iterationNumber === 3) {
                        var periodEnd = moment.subtract(1, 'days').toDate();
                        newQuarterlyYear.periods.push(bmppPeriodService.createPeriodDto(periodBegin, periodEnd, sequenceNumber));
                        periodBegin = moment.toDate();
                        sequenceNumber++;
                        iterationNumber = 0; //reset the iteration number back to 1
                    }

                    iterationNumber++;
                });

                //add in the final period
                newQuarterlyYear.periods.push(bmppPeriodService.createPeriodDto(bmppDateManipulatorService.addDays(periodBegin, 1), moment(newQuarterlyYear.endDate).toDate(), sequenceNumber));
            } else { //otherwise take your best guess
                createYearWithVariablePeriods(newQuarterlyYear, 4);
            }
            return newQuarterlyYear;
        }

        //creates a fiscal year dto with 52 periods
        function create52WeekYear(new52WeekYear) {
            var dateRange = moment().range(new52WeekYear.beginDate, new52WeekYear.endDate);
            var periodBegin;
            var sequenceNumber = 1;
            dateRange.by('weeks', function (week) {
                if (angular.isUndefined(periodBegin)) {
                    periodBegin = week.toDate();
                } else {
                    if (sequenceNumber === 52) {
                        new52WeekYear.periods.push(bmppPeriodService.createPeriodDto(periodBegin, moment(new52WeekYear.endDate).toDate(), sequenceNumber));
                    } else {
                        var periodEnd = week.subtract(1, 'days').toDate();
                        new52WeekYear.periods.push(bmppPeriodService.createPeriodDto(periodBegin, periodEnd, sequenceNumber));
                        periodBegin = bmppDateManipulatorService.addDays(week.toDate(), 1);
                        sequenceNumber++;
                    }
                }
            });

            //there are cases (in short years) where this iteration will not include the last week of the year
            //check to see if the last period is before the fiscal year endDate
            //if it is, add another period with the fiscal year end
            //add in the final period
            var lastPeriod = _.last(new52WeekYear.periods);
            if (bmppDateManipulatorService.isBefore(lastPeriod.endDate, new52WeekYear.endDate)) {
                new52WeekYear.periods.push(bmppPeriodService.createPeriodDto(periodBegin, moment(new52WeekYear.endDate).toDate(), sequenceNumber));
            } else if (new52WeekYear.periods.length > 52) {
                //When a fiscal year extends more than 52 weeks, we end up with multiple copies of the last period on the array
                //In this case, we want to just use the first 52 elements
                new52WeekYear.periods = new52WeekYear.periods.slice(0, 52);
            }
            return new52WeekYear;
        }

        //creates a fiscal year dto with 13 periods
        function create13Year(new13Year) {
            //  var dateRange = moment().range(new13Year.beginDate, new13Year.endDate);
            var daysPerPeriod = 28;
            var sequenceNumber = 1;
            var periodBegin = new13Year.beginDate;
            for (sequenceNumber = 1; sequenceNumber <= 13; sequenceNumber++) {
                var periodEnd;
                //if we're on the last period, use the fiscal year end date as the period end
                if (sequenceNumber === 13) {
                    periodEnd = moment(new13Year.endDate).toDate();
                } else {
                    periodEnd = bmppDateManipulatorService.addDays(periodBegin, daysPerPeriod - 1);
                }

                //for the last period use the fiscal year end date
                if (sequenceNumber === 13) {
                    //add a period for the last date
                    new13Year.periods.push(bmppPeriodService.createPeriodDto(periodBegin, moment(new13Year.endDate).toDate(), sequenceNumber));
                } else { //otherwise use the calculated period end
                    new13Year.periods.push(bmppPeriodService.createPeriodDto(periodBegin, periodEnd, sequenceNumber));
                }
                periodBegin = bmppDateManipulatorService.addDays(periodEnd, 1);
            }

            return new13Year;
        }

        //creates a fiscal year with the given number of periods
        function createYearWithVariablePeriods(fiscalYear, numberOfPeriods) {
            numberOfPeriods = Number(numberOfPeriods);
            if (numberOfPeriods === 0) {
                return fiscalYear;
            }

            var daysInRange = bmppDateManipulatorService.numberOfDaysInRange(fiscalYear.beginDate, fiscalYear.endDate);
            var daysPerPeriod = Math.floor(daysInRange / numberOfPeriods);
            var periodBegin = fiscalYear.beginDate;

            //iterate over the number of periods, and add a new period of each interval
            for (var sequenceNumber = 1; sequenceNumber <= numberOfPeriods; sequenceNumber++) {
                var periodEnd;
                //if we're on the last period, use the fiscal year end date as the period end
                if (sequenceNumber === numberOfPeriods) {
                    periodEnd = fiscalYear.endDate;
                } else {
                    periodEnd = bmppDateManipulatorService.addDays(periodBegin, daysPerPeriod - 1);
                }

                //for the last period use the fiscal year end date
                if (sequenceNumber === numberOfPeriods) {
                    //add a period for the last date
                    fiscalYear.periods.push(bmppPeriodService.createPeriodDto(periodBegin, moment(fiscalYear.endDate).toDate(), sequenceNumber));
                } else { //otherwise use the calculated period end
                    fiscalYear.periods.push(bmppPeriodService.createPeriodDto(periodBegin, periodEnd, sequenceNumber));
                }
                periodBegin = bmppDateManipulatorService.addDays(periodEnd, 1);
            }
        }
    }
})(window.angular, window.moment, window._);

(function(angular, _, moment) {
    'use strict';

    angular.module('bluemoon.periods').factory('bmppDateManipulatorService', bmppDateManipulatorService);
    bmppDateManipulatorService.$inject = [];

    function bmppDateManipulatorService() {
        var factory = {
            addDays: addDays,
            addYears: addYears,
            addMonths: addMonths,
            numberOfMonthsInRange: numberOfMonthsInRange,
            numberOfDaysInRange: numberOfDaysInRange,
            isBefore: isBefore,
            isAfter: isAfter,
            formatDateForDto: formatDateForDto
        };
        return factory;

        //add a given number of days to the date object
        function addDays(date, numberOfDays) {
            return moment(date).add(numberOfDays, 'days').toDate();
        }

        //add a given number of years to the date object, then subtract 1 day for the end of year
        function addYears(date, numberOfYears) {
            return moment(date).add(numberOfYears, 'years').subtract(1, 'days').toDate();
        }

        //add a given number of months to the date object
        function addMonths(date, numberOfMonths) {
            return moment(date).add(numberOfMonths, 'months').toDate();
        }

        //gets the number of months in a date range
        function numberOfMonthsInRange(beginDate, endDate) {
            var begin = moment(beginDate);
            var end = moment(endDate);
            var months = Math.round(moment.duration(end.diff(begin)).asMonths());
            return months;
            // var dateRange = moment.range(begin, end);
            // return Math.abs(dateRange.diff('months'));
            // var dateRange = moment().range(begin, end);
            // return Math.abs(dateRange.diff('months'));
        }

        //gets the number of days in a date range
        function numberOfDaysInRange(beginDate, endDate) {
            var begin = moment(beginDate);
            var end = moment(endDate);
            var dateRange = moment().range(begin, end);
            return Math.abs(dateRange.diff('days'));
        }

        //returns true if the begin date is before the end date
        function isBefore(beginDate, endDate) {
            return moment(beginDate).isBefore(endDate, 'day');
        }

        //return true if the begin date is after the end date
        function isAfter(beginDate, endDate) {
            return moment(beginDate).isAfter(endDate, 'day');
        }

        //returns just the date part of a date time in utc format
        function formatDateForDto(date) {
            return _.first(moment(date).format().split('T'));
        }
    }
})(window.angular, window._, window.moment);

(function (angular) {
    'use strict';
    angular.module('bluemoon.periods').factory('bmppModalService', bmppModalService);
    bmppModalService.$inject = ['$uibModal'];

    function bmppModalService($uibModal) {
        return {
            openAddFiscalYearModal: openAddFiscalYearModal,
            openAddFiscalYearModalWithPeriods: openAddFiscalYearModalWithPeriods,
            openEditFiscalYearModal: openEditFiscalYearModal,
            openEditPeriodsWizard: openEditPeriodsWizard
        };

        //opens the add fiscal year modal
        function openAddFiscalYearModal() {
            $uibModal.open({
                templateUrl: 'components/periods-refactored/bmpp-add-fiscal-year-modal/bmpp-add-fiscal-year-modal.2js.html',
                controller: 'bmppAddFiscalYearModal',
                resolve: {}
            });
        }

        //opens the add fiscal year modal with periods
        function openAddFiscalYearModalWithPeriods(){
            $uibModal.open({
                backdrop: 'static',
                size: 'full',
                windowClass: 'bmpp-workspace-modal',
                templateUrl: 'components/periods-refactored/bmpp-add-fiscal-year-modal-with-periods/bmpp-add-fiscal-year-modal-with-periods.2js.html',
                controller: 'bmppAddFiscalYearModalWithPeriods',
                resolve: {}
            });
        }

        //opens the edit fiscal year modal
        function openEditFiscalYearModal() {
            $uibModal.open({
                templateUrl: 'components/periods-refactored/bmpp-edit-fiscal-year-modal/bmpp-edit-fiscal-year-modal.2js.html',
                controller: 'bmppEditFiscalYearModal',
                resolve: {}
            });
        }

        //open the edit period wizard this should open like the workspace mode
        //Param: reloadYear tells the modal whether or not to reset the year when opening
        //Param: useAccountingPeriods tells the modal to only look at the accounting periods
        function openEditPeriodsWizard(reloadYear, useAccountingPeriods) {
            var options = {
                backdrop: 'static',
                size: 'full',
                windowClass: 'bmpp-workspace-modal',
                templateUrl: 'components/edit-periods/bmpp-edit-periods/bmpp-edit-periods.2js.html',
                controller: 'EditPeriodsCtrl as Vm',
                resolve: {
                    frp: ['bmppFrpService', function (bmppFrpService) {
                        return bmppFrpService.loadFrps();
                    }],
                    reloadYear: [function() {
                        return reloadYear;
                    }],
                    useAccountingPeriods: [function() {
                        return useAccountingPeriods;
                    }]
                }
            };
            //open the modal
            $uibModal.open(options);

        }
    }
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.periods').factory('bmppDateFormatService', bmppDateFormatService);
    bmppDateFormatService.$inject = [];

    function bmppDateFormatService() {
        var _formats = {
          'en-us': 'M!/d!/y', //found this from the bootstrap date format to use the ! which will allow and optional leading zero
          'en-uk': 'd!/M!/y',
          'en-ca': 'd!/M!/y',
          'es-ar': 'd!/M!/y',
          'nl-nl': 'd!/M!/y'
        };

        return {
            getDateFormat: getDateFormat
        };

        function getDateFormat(locale) {
          return angular.isDefined(_formats[locale]) ? _formats[locale] : 'd!/M!/y';
        }
    }
})(window.angular);

(function (angular) {
    'use strict';
    angular.module('bluemoon.periods').factory('bmppFrpService', bmppFrpService);
    bmppFrpService.$inject = ['$q', 'bmPermission'];

    function bmppFrpService($q, bmPermission) {
        var _hasAccounting = false;
        var _hasFixedAssets = false;
        var _hasFirm = false;
        var _hasVat = false;
        var _hasUKTax = false;
        var _hasCurrentDev = false;
        return {
            loadFrps: loadFrps,
            hasAccounting: hasAccounting,
            hasFixedAssets: hasFixedAssets,
            setHasFirm: setHasFirm,
            hasFirm: hasFirm,
            fiscalYearsOnly: fiscalYearsOnly,
            hasVat: hasVat,
            hasUKTax: hasUKTax,
            hasCurrentDev: hasCurrentDev
        };

        function hasAccounting() {
            return _hasAccounting;
        }

        function hasFixedAssets() {
            return _hasFixedAssets;
        }

        function hasFirm() {
            return _hasFirm;
        }

        function hasVat() {
            return _hasVat;
        }

        function hasUKTax() {
            return _hasUKTax;
        }

        function hasCurrentDev() {
            return _hasCurrentDev;
        }

        //firm is not driven off of an frp like the other types
        //it is a value passed into the period-main directive and then set here
        function setHasFirm(value) {
            _hasFirm = value;
        }

        //returns true if the firm does not have license for any applications that require periods
        //in this case they will see an altered screen that only has fiscal years
        function fiscalYearsOnly() {
            return !_hasAccounting && !_hasFixedAssets && !_hasFirm;
        }

        function loadFrps() {
            var accountingProm = bmPermission.isGranted('OnvioSetup.AccountingPeriods');
            var fixedAssetsProm = bmPermission.isGranted('USFixedAssets.FixedAssetsPeriods');
            var vatProm = bmPermission.isGranted('Applications.UKVAT');
            var UKTaxProm = bmPermission.isGranted('Applications.UKTax');
            var hasCurrentDev = bmPermission.isGranted('Internal.CurrentDevelopment');
            return $q.all([accountingProm, fixedAssetsProm, vatProm, UKTaxProm, hasCurrentDev]).then(function (results) {
                _hasAccounting = results[0];
                _hasFixedAssets = results[1];
                _hasVat = results[2];
                _hasUKTax = results[3];
                _hasCurrentDev = results[4];
            });
        }
    }
})(window.angular);

(function(angular) {
    'use strict';
    angular.module('bluemoon.periods').constant('bmppEvents', {
        BMPP_OWNER_CHANGED: 'BMPP_OWNER_CHANGED',
        BMPP_SELECTED_FISCAL_YEAR_CHANGED: 'BMPP_SELECTED_FISCAL_YEAR_CHANGED',
        BMPP_FISCAL_YEAR_ADDED: 'BMPP_FISCAL_YEAR_ADDED',
        BMPP_FISCAL_YEARS_CHANGED: 'BMPP_FISCAL_YEARS_CHANGED',
        BMPP_CURRENT_PERIOD_CHANGED: 'BMPP_CURRENT_PERIOD_CHANGED',
        BMPP_SELECTED_APPLICATION_CHANGED: 'BMPP_SELECTED_APPLICATION_CHANGED',
        BMPP_INCREMENT_PERIOD_ERROR_COUNT: 'BMPP_INCREMENT_PERIOD_ERROR_COUNT',
        BMPP_DECREMENT_PERIOD_ERROR_COUNT: 'BMPP_DECREMENT_PERIOD_ERROR_COUNT',
        BMPP_ADD_MODE_CHANGED: 'BMPP_ADD_MODE_CHANGED',
        BMPP_ADD_YEAR_SAVE_CLICKED: 'BMPP_ADD_YEAR_SAVE_CLICKED',
        BMPP_ADD_YEAR_CANCEL_CLICKED: 'BMPP_ADD_YEAR_CANCEL_CLICKED',
        BMPP_ADD_YEAR_END_DATE_CHANGED: 'BMPP_ADD_YEAR_END_DATE_CHANGED',
        BMPP_REFRESH_IS_SAVED: 'BMPP_REFRESH_IS_SAVED',
        BMPP_CLEAR_FISCAL_YEARS: 'BMPP_CLEAR_FISCAL_YEARS',
        BMPP_FISCAL_YEAR_FAILED_SAVE: 'BMPP_FISCAL_YEAR_FAILED_SAVE',
        BMPP_EDIT_PERIOD_FREQUENCY_CHANGED: 'BMPP_EDIT_PERIOD_FREQUENCY_CHANGED',
        BMPP_EDIT_PERIOD_END_DATE_CHANGED: 'BMPP_EDIT_PERIOD_END_DATE_CHANGED',
        BMPP_EDIT_PERIOD_NOT_MAPPED_ALERT: 'BMPP_EDIT_PERIOD_NOT_MAPPED_ALERT',
        BMPP_EDIT_PERIOD_NOT_VALID_ALERT : 'BMPP_EDIT_PERIOD_NOT_VALID_ALERT',
        BMPP_EDIT_FREQUENCY_CHANGED: 'BMPP_EDIT_FREQUENCY_CHANGED',
        BMPP_ADD_FISCAL_YEAR_FREQUENCY_CHANGED: 'BMPP_ADD_FISCAL_YEAR_FREQUENCY_CHANGED',
        BMPP_EDIT_PERIOD_YEAR_BEGIN_YEAR_END_CHANGED: 'BMPP_EDIT_PERIOD_YEAR_BEGIN_YEAR_END_CHANGED',
        BMPP_EDIT_PERIOD_CUSTOM_FREQUENCY_CHANGED: 'BMPP_EDIT_PERIOD_CUSTOM_FREQUENCY_CHANGED',
        BMPP_EDIT_FISCAL_YEAR_CANCEL_CLICKED: 'BMPP_EDIT_FISCAL_YEAR_CANCEL_CLICKED',
        BMPP_EDIT_PERIOD_TAX_YEAR_INVALID: 'BMPP_EDIT_PERIOD_TAX_YEAR_INVALID',
        BMPP_EDIT_PERIODS_TAX_YEAR_CHANGED: 'BMPP_EDIT_PERIODS_TAX_YEAR_CHANGED',
        BMPP_YEAR_END_CLOSE_NEEDED: 'BMPP_YEAR_END_CLOSE_NEEDED',
        BMPP_YEAR_END_CLOSE_SUCCEEDED: 'BMPP_YEAR_END_CLOSE_SUCCEEDED',
        BMPP_YEAR_END_CLOSE_FAILED: 'BMPP_YEAR_END_CLOSE_FAILED'
    });
})(window.angular);

(function (angular, _) {
    'use strict';
    angular.module('bluemoon.periods').factory('bmppTaxYearService', bmppTaxYearService);
    bmppTaxYearService.$inject = ['bmppDataService', '$q', '$rootScope', 'bmppEvents'];

    function bmppTaxYearService(bmppDataService, $q, $rootScope, bmppEvents) {
        var _taxYears = [];
        var _currentTaxYear = '';
        var _currentTaxYearChanged = false;
        var _isCurrentTaxYearSaved = false;
        return {
            isCurrentTaxYearSaved: isCurrentTaxYearSaved,
            setTaxYears: setTaxYears,
            getTaxYears: getTaxYears,
            setCurrentTaxYear: setCurrentTaxYear,
            getCurrentTaxYear: getCurrentTaxYear,
            initializeCurrentTaxYear: initializeCurrentTaxYear,
            isCurrentTaxYearValid: isCurrentTaxYearValid,
            isCurrentTaxYearChanged: isCurrentTaxYearChanged,
            loadTaxYears: loadTaxYears,
            getUnusedTaxYears: getUnusedTaxYears,
            isTaxYearUsed: isTaxYearUsed
        };

        //returns true if the tax year has been saved down
        function isCurrentTaxYearSaved() {
            return _isCurrentTaxYearSaved;
        }

        //sets the taxYears
        function setTaxYears(taxYears) {
            _taxYears = taxYears;
        }

        //returns the taxYears
        function getTaxYears() {
            return _taxYears.sort(function (left, right) {
                return left - right;
            });
        }

        //sets the current taxYear
        function setCurrentTaxYear(taxYear) {
            _currentTaxYear = taxYear;
            _currentTaxYearChanged = true;
        }

        //returns the current taxYear
        function getCurrentTaxYear() {
            return _currentTaxYear;
        }

        //sets the current tax year, but does not set the changed flag
        function initializeCurrentTaxYear(taxYear) {
            _currentTaxYear = taxYear;
            _isCurrentTaxYearSaved = isCurrentTaxYearValid();
        }

        //returns true if the current tax year is valid
        function isCurrentTaxYearValid() {
            return angular.isDefined(_currentTaxYear) && _currentTaxYear !== '';
        }

        //is current tax year changed
        function isCurrentTaxYearChanged() {
            return _currentTaxYearChanged;
        }

        //load the taxYears
        function loadTaxYears(ownerId) {
            //reset the changed flag to false
            _currentTaxYearChanged = false;
            //reset the is current tax year saved flag
            _isCurrentTaxYearSaved = false;
            var deferred = $q.defer();
            //run the promise to get taxYears
            deferred.resolve(bmppDataService.getTaxYears(ownerId));
            deferred.promise.then(function (periodsResult) {
                if (periodsResult.result === 'success') {
                    //set the taxYears variable to the return
                    setTaxYears(periodsResult.data);
                    //broadcast an Is Saved Refresh
                    $rootScope.$broadcast(bmppEvents.BMPP_REFRESH_IS_SAVED);
                }
            });
            return deferred.promise;
        }

        function getUnusedTaxYears(fiscalYears) {
            var usedTaxYears = _.pluck(fiscalYears, 'taxCodeYear');
            var unusedTaxYears = getTaxYears();
            _.forEach(usedTaxYears, function (year) {
                unusedTaxYears = _.without(unusedTaxYears, year);
            });
            if (angular.isDefined(_currentTaxYear) && _currentTaxYear !== '') {
                unusedTaxYears.push(parseInt(_currentTaxYear));
            }
            unusedTaxYears = _.uniq(unusedTaxYears);
            return unusedTaxYears.sort(function (left, right) {
                return left - right;
            });
        }

        //takes in a tax year string and returns true if its been used
        function isTaxYearUsed(fiscalYears, taxYear, editFiscalYearId) {
            return angular.isDefined(fiscalYears.find(function (fiscalYear) {
                return fiscalYear.taxCodeYear === taxYear && fiscalYear.id !== editFiscalYearId;
            }));
        }
    }
})(window.angular, window._);

(function (angular) {
    'use strict';
    angular.module('bluemoon.periods').factory('bmppContactService', bmppContactService);
    bmppContactService.$inject = ['bmppDataService'];

    function bmppContactService(bmppDataService) {
        var _contacts = [];
        var _contact = {};
        return {
            getContacts: getContacts,
            loadRelatedContacts: loadRelatedContacts,
            setSelectedContact: setSelectedContact,
            getSelectedContact: getSelectedContact
        };

        //returns the contact array
        function getContacts() {
            return _contacts;
        }

        //returns the Contact
        function getSelectedContact() {
            return _contact;
        }

        //sets the contact
        function setSelectedContact(contact) {
            _contact = contact;
        }

        //returns a promise for the contacts endpoint
        function loadRelatedContacts(contactId) {

            return bmppDataService.getCompanyId().then(function (companyId) {
                return bmppDataService.getRelatedContacts(companyId, contactId);
            }).then(function (relatedContactResult) {
                _contacts = relatedContactResult.data.items;
                _contacts.find(function(contact){
                    if(contact.id === contactId){
                        setSelectedContact(contact);
                    }
                });

            });
        }
    }
})(window.angular);

(function (angular) {
    'use strict';
    angular.module('bluemoon.periods').factory('bmppTransactionCountService', bmppTransactionCountService);
    bmppTransactionCountService.$inject = ['bmppDataService', '$q', '$rootScope', 'bmppEvents'];

    function bmppTransactionCountService() {
        var _transactionCount = 0;

        return {
            hasTransactions: hasTransactions,
            setTransactionCount: setTransactionCount
        };

        function hasTransactions() {
            return _transactionCount > 0;
        }

        function setTransactionCount(transactionCount) {
            _transactionCount = transactionCount;
        }

    }
})(window.angular);

(function(angular) {
    'use strict';
    angular.module('bluemoon.periods').factory('bmppYearEndCloseService', bmppYearEndCloseService);
    bmppYearEndCloseService.$inject = [];

    function bmppYearEndCloseService() {
        var _needsYearEndClose = false;
        var _fiscalYearToClose = void 0;

        return {
            reset: reset,
            setNeedsYearEndClose: setNeedsYearEndClose,
            getNeedsYearEndClose: getNeedsYearEndClose,
            setFiscalYearToClose : setFiscalYearToClose,
            getFiscalYearToClose : getFiscalYearToClose
        };

        //resets the member variables
        function reset(){
            _needsYearEndClose = false;
            _fiscalYearToClose = void 0;
        }

        //sets the ownerId
        function setNeedsYearEndClose(ownerId) {
            _needsYearEndClose = ownerId;
        }

        //returns the ownerId
        function getNeedsYearEndClose() {
            return _needsYearEndClose;
        }

        //sets the fiscal year to close
        function setFiscalYearToClose(fiscalYear){
            _fiscalYearToClose = fiscalYear;
        }

        //gets the fiscal year to close
        function getFiscalYearToClose(){
            return _fiscalYearToClose;
        }
    }
})(window.angular);

(function (angular, moment) {
    'use strict';
    angular.module('bluemoon.periods').directive('bmppPeriodMain', ['bmppIacService', 'bmppOwnerService', 'bmppFiscalYearService', 'bmppAccountsService', 'bmppBusyLoaderService', 'bmppFrpService', 'bmppContactService', 'bmppDataService', 'bmppEvents', 'bmppLocaleService', 'bmppTransactionCountService', '$translate',
        function (bmppIacService, bmppOwnerService, bmppFiscalYearService, bmppAccountsService, bmppBusyLoaderService, bmppFrpService, bmppContactService, bmppDataService, bmppEvents, bmppLocaleService, bmppTransactionCountService, $translate) {
            return {
                restrict: 'AE',
                scope: {
                    showRelatedContacts: '=',
                    ownerId: '@',
                    isFirmClient: '='
                },
                templateUrl: 'components/periods-refactored/bmpp-period-main/bmpp-period-main.2js.html',
                link: function (scope) {
                    init();

                    //returns true if the busy loader is busy
                    scope.isLoaderBusy = function () {
                        return bmppBusyLoaderService.isLoaderBusy();
                    };

                    //returns true if this client only needs fiscal years functionality
                    //and none of the period functionality
                    scope.fiscalYearsOnly = function () {
                        return bmppFrpService.fiscalYearsOnly();
                    };

                    //returns true if this client has vat
                    scope.hasVat = function () {
                        return bmppFrpService.hasVat();
                    };

                    //listen for changes to the owner and reload the years and accounts if they change
                    scope.$on(bmppEvents.BMPP_OWNER_CHANGED, function () {
                        scope.ownerId = bmppOwnerService.getOwnerId();

                        loadYearsAndAccounts();
                    });

                    //Returns the fiscal year failed error
                    function getFiscalYearSaveFailedAlert() {
                        return {
                            type: 'danger',
                            msg: $translate.instant('bmpp.fiscalYearError.failedToSave'),
                            closeable: true
                        };
                    }

                    //Returns the year end close succeeded alert
                    function getYearEndCloseSucceededAlert(endDate) {
                        return {
                            type: 'success',
                            msg: $translate.instant('bmpp.period.yearEndClose.success', { endDate: moment(endDate).format('L') }),
                            closeable: true,
                            timeout: 20000
                        };
                    }

                    //Returns the year end close failed error
                    function getYearEndCloseFailedAlert(endDate) {
                        return {
                            type: 'danger',
                            msg: $translate.instant('bmpp.period.yearEndClose.failure', { endDate: moment(endDate).format('L') }),
                            closeable: true
                        };
                    }

                    //Displays an error when an edited fiscal year fails to save
                    scope.$on(bmppEvents.BMPP_FISCAL_YEAR_FAILED_SAVE, function () {
                        scope.alerts.push(getFiscalYearSaveFailedAlert());
                    });

                    //Displays an alert when year end close succeeds
                    scope.$on(bmppEvents.BMPP_YEAR_END_CLOSE_SUCCEEDED, function (event, endDate) {
                        scope.alerts.push(getYearEndCloseSucceededAlert(endDate));
                    });

                    //Displays an error when year end close fails
                    scope.$on(bmppEvents.BMPP_YEAR_END_CLOSE_FAILED, function (event, endDate) {
                        scope.alerts.push(getYearEndCloseFailedAlert(endDate));
                    });

                    //loads the fiscal Years and accounts
                    function loadYearsAndAccounts() {
                        //load the fiscal years
                        scope.fiscalYearsLoaded = false;
                        bmppDataService.getAllFiscalYears(scope.ownerId).then(function (result) {
                            bmppFiscalYearService.setFiscalYears(result.data);

                            scope.fiscalYearsLoaded = true;
                        });
                        scope.accountsLoaded = false;
                        scope.transactionCountLoaded = false;

                        if (bmppFrpService.hasAccounting()) {
                            //load the accounts
                            bmppDataService.getAllAccounts(scope.ownerId, true).then(function (result) {
                                bmppAccountsService.setAccounts(result.data);
                                scope.accountsLoaded = true;
                            }, function () {
                                scope.accountsLoaded = true;
                            });

                            //Load the transaction count
                            bmppDataService.getTransactionCount(scope.ownerId).then(function (result) {
                                scope.transactionCountLoaded = true;
                                bmppTransactionCountService.setTransactionCount(result.data.transactionCount);
                            }, function () {
                                scope.transactionCountLoaded = true;
                            });
                        } else {
                            scope.accountsLoaded = true;
                            scope.transactionCountLoaded = true;
                        }
                    }

                    //initialize the periods
                    function init() {
                        //Initialize alerts
                        scope.alerts = [];

                        bmppOwnerService.setOwnerId(scope.ownerId);

                        //the consumer of this component can pass in either a contact or a client id
                        //either of these will ulitmately be the owner
                        scope.contactsLoaded = false;
                        bmppContactService.loadRelatedContacts(scope.ownerId).then(function () {
                            scope.contactsLoaded = true;
                        });

                        bmppFrpService.setHasFirm(scope.isFirmClient);

                        //load IAC for the year end close
                        bmppIacService.loadIacs();

                        //We need to get the FRPs before the years/accounts because
                        //the function relies on the FRPs being loaded
                        bmppFrpService.loadFrps().then(function () {
                            loadYearsAndAccounts();
                        });

                        //Load the country specific
                        bmppLocaleService.loadEnviornments();
                    }
                }
            };
        }
    ]);
})(window.angular, window.moment);

(function (angular) {
    'use strict';
    angular.module('bluemoon.periods').directive('bmppFiscalYearCombo', ['bmppFiscalYearService', 'bmppEvents', 'bmppModalService', '$rootScope',
        function (bmppFiscalYearService, bmppEvents, bmppModalService, $rootScope) {
            return {
                restrict: 'AE',
                scope: {},
                templateUrl: 'components/periods-refactored/bmpp-fiscal-year-combo/bmpp-fiscal-year-combo.2js.html',
                link: function (scope) {
                    init();

                    //returns the collection of fiscal years for the combobox
                    scope.getFiscalYears = function () {
                        return bmppFiscalYearService.getFiscalYears();
                    };

                    //add year is clicked, lets go into add mode
                    scope.addYearClick = function () {
                        bmppModalService.openAddFiscalYearModalWithPeriods();
                    };

                    //after a new fiscal year is added we need to reinitialize the grid
                    scope.$on(bmppEvents.BMPP_FISCAL_YEAR_ADDED, function () {
                        //get the selected fiscal year from the fiscal year service
                        scope.selectedFiscalYear = bmppFiscalYearService.getSelectedFiscalYear();
                        //scope.cbCurrentYearController.reload();
                    });

                    //update the dropdown when fiscal years are changed
                    $rootScope.$on(bmppEvents.BMPP_FISCAL_YEARS_CHANGED, function () {
                        //get the selected fiscal year from the fiscal year service
                        scope.selectedFiscalYear = bmppFiscalYearService.getSelectedFiscalYear();
                        scope.cbCurrentYearController.reload();
                    });

                    //set the selected fiscal year and notify everyone
                    scope.fiscalYearChanged = function (item) {
                        bmppFiscalYearService.setSelectedFiscalYear(item);
                    };

                    //initialize the dropdown
                    function init() {
                        //get the selected fiscal year from the fiscal year service
                        scope.selectedFiscalYear = bmppFiscalYearService.getSelectedFiscalYear();

                        // if (angular.isDefined(scope.cbCurrentYearController)) {
                        //     scope.cbCurrentYearController.reload();
                        // }
                    }
                }
            };
        }
    ]);
})(window.angular);

(function (angular, _, moment) {
    'use strict';
    angular.module('bluemoon.periods').directive('bmppEditFiscalYear', ['bmppContactService', 'bmppOwnerService', 'bmppEditFiscalYearService', 'bmppApplicationTypeService', 'bmppEvents', 'bmppFrequencyService', 'bmppModalService', '$translate', 'bmppTaxYearService', 'bmppFiscalYearService', 'bmppLocaleService', 'bmppTransactionCountService', 'bmppYearEndCloseService',
        function (bmppContactService, bmppOwnerService, bmppEditFiscalYearService, bmppApplicationTypeService, bmppEvents, bmppFrequencyService, bmppModalService, $translate, bmppTaxYearService, bmppFiscalYearService, bmppLocaleService, bmppTransactionCountService, bmppYearEndCloseService) {
            return {
                restrict: 'AE',
                scope: {},
                templateUrl: 'components/periods-refactored/bmpp-edit-fiscal-year/bmpp-edit-fiscal-year.2js.html',
                link: function (scope) {
                    //the different application types
                    var applicationTypes = bmppApplicationTypeService.getApplicationTypes();
                    var periodsLoaded = false;

                    init();

                    //reinitialize this directive when add mode changes
                    scope.$on(bmppEvents.BMPP_ADD_MODE_CHANGED, function () {
                        init();
                    });

                    //re initialize after the fiscal year is changed
                    scope.$on(bmppEvents.BMPP_SELECTED_FISCAL_YEAR_CHANGED, function () {
                        init();
                    });

                    //need to change the period grid when the application type changes
                    scope.$on(bmppEvents.BMPP_SELECTED_APPLICATION_CHANGED, function () {
                        refreshFrequencies();
                        updatePeriods();
                        updateFrequency();
                    });

                    //stripe out the non numbers
                    scope.$watch('customFrequency', function (newVal, oldVal) {
                        if (angular.isUndefined(newVal) || newVal === null) {
                            scope.customFrequency = oldVal;
                        } else if (angular.isString(newVal)) {
                            //only run the validation if they've added characters and the new value comes from the textbox
                            if (angular.isUndefined(oldVal) || newVal.length > oldVal.length) {
                                scope.customFrequency = newVal.replace(/\D/g, '');
                                scope.customFrequency.trim();
                            }
                        }
                    });

                    //Returns the year number from the fiscal year id
                    scope.getYearByFiscalYearId = function (fiscalYearId) {
                        var fiscalYear = bmppFiscalYearService.getFiscalYearById(fiscalYearId);
                        return moment(fiscalYear.endDate).year();
                    };

                    //the user has clicked the save button
                    scope.saveClick = function () {
                        //if the fiscal year is not valid we want to show the validtion messages
                        if (!bmppEditFiscalYearService.isFiscalYearValid()) {
                            scope.showValidationMessage = true;
                            //If the start or end date is changed and there's activity
                        } else if ((bmppEditFiscalYearService.isStartDateChanged() ||
                                bmppEditFiscalYearService.isEndDateChanged()) &&
                            bmppTransactionCountService.hasTransactions()) {
                            //Send the user through edit periods for the mapping
                            bmppModalService.openEditPeriodsWizard(false, true);
                        } else if (bmppYearEndCloseService.getNeedsYearEndClose() && bmppApplicationTypeService.getSelectedApplication() === applicationTypes.Accounting) {
                            scope.fiscalYearToClose = bmppYearEndCloseService.getFiscalYearToClose();
                            scope.fiscalYearToCloseString = moment(scope.fiscalYearToClose.endDate).year();
                            scope.startYearEndCloseProcess = true;
                        } else { //otherwise we can save it down
                            bmppEditFiscalYearService.saveFiscalYear();
                        }
                    };

                    //the user has clicked the cancel button

                    scope.cancelClick = function () {
                        init();
                        scope.$broadcast(bmppEvents.BMPP_EDIT_FISCAL_YEAR_CANCEL_CLICKED);
                    };

                    //the frequency combobox has changed,
                    //need to go to the service and update the year
                    scope.onFrequencyChanged = function () {
                        var frequency = bmppFrequencyService.getFrequencyByValue(parseInt(scope.selectedFrequency));
                        //call the edit year service to update the frequency
                        bmppEditFiscalYearService.updateFrequency(frequency);
                        //update the periods
                        updatePeriods();
                    };

                    //the user has changed the fiscal year end field
                    scope.endDateChanged = function () {
                        bmppEditFiscalYearService.updateEndDate(scope.endDate);
                        //update the periods
                        updatePeriods();

                        //if they have fixed a previously invalid lets turn off the validation message
                        if (bmppEditFiscalYearService.isFiscalYearValid()) {
                            scope.showValidationMessage = false;
                        }
                    };

                    //the user has changed the fiscal year begin field
                    scope.startDateChanged = function () {
                        bmppEditFiscalYearService.updateStartDate(scope.startDate);
                        //update the periods
                        updatePeriods();

                        //if they have fixed a previously invalid lets turn off the validation message
                        if (bmppEditFiscalYearService.isFiscalYearValid()) {
                            scope.showValidationMessage = false;
                        }
                    };

                    //returns true if the start date is editable
                    scope.isStartDateEditable = function () {
                        return bmppEditFiscalYearService.isStartDateEditable();
                    };

                    scope.isStartEndDateVisible = function () {
                        var selectedApplication = bmppApplicationTypeService.getSelectedApplication();
                        //only show this for non accounting applications
                        return selectedApplication !== applicationTypes.Accounting;
                    };

                    //returns true if the end date is editable
                    scope.isEndDateEditable = function () {
                        return bmppEditFiscalYearService.isEndDateEditable();
                    };

                    //the user has entered a new custom frequency
                    scope.customFrequencyChanged = function () {
                        //first we need to make sure the input is valid
                        if (_.isFinite(scope.customFrequency)) {
                            var frequency = {
                                Value: 0,
                                customFrequency: parseInt(scope.customFrequency)
                            };
                            //call the add year service to update the frequency
                            bmppEditFiscalYearService.updateFrequency(frequency);
                            //update the periods
                            updatePeriods();
                        }
                    };
                    //only enable this button for the accounting application and when they have transactions
                    scope.canEditPeriods = function () {
                        var selectedApplication = bmppApplicationTypeService.getSelectedApplication();
                        //only show this for accounting application
                        var canEditPeriods = (selectedApplication === applicationTypes.Accounting);
                        return canEditPeriods;
                    };

                    //returns true if the user should be allowed to edit the periods
                    //this should be disable for the accounting. Accounting application will use the edit periods to make any changes
                    scope.isEditable = function () {
                        var selectedApplication = bmppApplicationTypeService.getSelectedApplication();
                        return selectedApplication === applicationTypes.FixedAssets || selectedApplication === applicationTypes.Firm;
                    };

                    //returns the currently selected application
                    scope.getSelectedApplication = function () {
                        return bmppApplicationTypeService.getSelectedApplication();
                    };

                    //returns true if the fiscal year is safe to save down
                    scope.isValid = function () {
                        return bmppEditFiscalYearService.isFiscalYearValid();
                    };

                    //get the country specific
                    //disable the frequency combo for the accounting application
                    //Accounting will use the edit periods button to change the frequency
                    scope.isFrequencyEnabled = function () {
                        return !bmppLocaleService.isArgentina() && bmppApplicationTypeService.getSelectedApplication() !== applicationTypes.Accounting;
                    };

                    //edit period clicked
                    scope.editPeriodsClicked = function () {
                        //When opening edit periods from the accounting tab
                        //We want to refresh the year's data and only look at Accounting
                        bmppModalService.openEditPeriodsWizard(true, true);
                    };

                    //get the contact name for the year end close dialog
                    scope.getContactName = function () {
                        return bmppContactService.getSelectedContact().name;
                    };

                    //When close year successfully runs in year end close and the modal has been closed
                    scope.onYearEndClose = function (options) {
                        scope.startYearEndCloseProcess = false;
                        bmppEditFiscalYearService.saveFiscalYear(false, options);
                    };

                    //When cancel has been clicked in year end close modal
                    scope.onYearEndCancel = function () {
                        scope.startYearEndCloseProcess = false;
                    };

                    //get selected contact name
                    scope.getContactName = function () {
                        return bmppContactService.getSelectedContact().fullName;
                    };

                    //update the periods that are currently displayed to the user
                    function updatePeriods() {
                        scope.periods = bmppEditFiscalYearService.getPeriodsForCurrentApplication();
                        periodsLoaded = true;
                    }

                    //update the frequency based on the number of periods
                    //update the selected frequency based on the number of periods
                    function updateFrequency() {
                        if (scope.periods.length > 0) {
                            var frequency = bmppEditFiscalYearService.getFrequencyForCurrentApplication();
                            scope.selectedFrequency = frequency.Value.toString();

                            //if we have a custom frequency, then we need to update that value
                            if (bmppFrequencyService.isCustomFrequency(frequency)) {
                                scope.customFrequency = scope.periods.length;
                            }
                        } else if (periodsLoaded) { //if we don't have any periods reset the selected frequency, and custom frequency
                            scope.selectedFrequency = '';
                            scope.customFrequency = undefined;
                        }
                    }

                    function refreshFrequencies() {
                        scope.frequencies = bmppFrequencyService.getFrequencies();
                    }

                    //initialization code
                    function init() {
                        scope.ownerId = bmppOwnerService.getOwnerId();
                        bmppEditFiscalYearService.loadFiscalYear();
                        var fiscalYear = bmppEditFiscalYearService.getFiscalYear();
                        bmppTaxYearService.setCurrentTaxYear(fiscalYear.taxCodeYear);
                        scope.startDate = new Date(fiscalYear.startDate);
                        scope.endDate = new Date(fiscalYear.endDate);
                        scope.hasTransactions = bmppTransactionCountService.hasTransactions();
                        scope.showValidationMessage = false;

                        //we need to setup the x to y periods title
                        scope.editFiscalYearTitle = '';
                        $translate('bmpp.bmppPeriodEditYear.xToYPeriods').then(function (editFiscalYearTranslation) {
                            var title = editFiscalYearTranslation.replace('{0}', fiscalYear.yearBeginLabel);
                            title = title.replace('{1}', fiscalYear.yearEndLabel);
                            scope.editFiscalYearTitle = title;
                        });

                        //load the translation strings for the frequency dropdown
                        bmppFrequencyService.loadFrequencyTranslationStrings().then(function () {
                            scope.frequencies = bmppFrequencyService.getFrequencies();
                        });

                        updatePeriods();
                        updateFrequency();

                    }
                }
            };
        }
    ]);
})(window.angular, window._, window.moment);

(function (angular, _, moment) {
    'use strict';
    angular.module('bluemoon.periods').factory('bmppEditFiscalYearService', bmppEditFiscalYearService);
    bmppEditFiscalYearService.$inject = ['bmppFiscalYearService', 'bmppApplicationTypeService', 'bmppCreateFiscalYearService', 'bmppDataService', 'bmppOwnerService', 'bmppBusyLoaderService', 'bmppFrequencyService', 'bmppDateManipulatorService', 'bmppTaxYearService', '$rootScope', 'bmppEvents'];

    function bmppEditFiscalYearService(bmppFiscalYearService, bmppApplicationTypeService, bmppCreateFiscalYearService, bmppDataService, bmppOwnerService, bmppBusyLoaderService, bmppFrequencyService, bmppDateManipulatorService, bmppTaxYearService, $rootScope, bmppEvents) {
        var _fiscalYear = {};
        var _currentPeriods = {};
        var _startDate = {};
        var _endDate = {};
        var _startDateChanged = false;
        var _endDateChanged = false;
        var _frequencies = {};

        //To prevent the call from being made several times
        var applicationTypes = bmppApplicationTypeService.getApplicationTypes();
        return {
            reset: reset,
            loadFiscalYear: loadFiscalYear,
            getFiscalYear: getFiscalYear,
            getCurrentPeriod: getCurrentPeriod,
            getCurrentPeriodForAccounting: getCurrentPeriodForAccounting,
            setCurrentPeriod: setCurrentPeriod,
            updatePeriod: updatePeriod,
            updateStartDate: updateStartDate,
            updateEndDate: updateEndDate,
            getPeriodsForCurrentApplication: getPeriodsForCurrentApplication,
            getPeriodsForAccounting: getPeriodsForAccounting,
            getFrequencyForCurrentApplication: getFrequencyForCurrentApplication,
            getFrequencyForAccounting: getFrequencyForAccounting,
            setPeriodValidity: setPeriodValidity,
            isFiscalYearValid: isFiscalYearValid,
            isStartDateEditable: isStartDateEditable,
            isEndDateEditable: isEndDateEditable,
            updateFrequency: updateFrequency,
            updatePeriodsForSelectedApplication: updatePeriodsForSelectedApplication,
            saveFiscalYear: saveFiscalYear,
            updateMappingForEditedPeriods: updateMappingForEditedPeriods,
            isStartDateChanged: isStartDateChanged,
            isEndDateChanged: isEndDateChanged,
        };

        function reset() {
             _fiscalYear = {};
             _currentPeriods = {};
             _startDate = {};
             _endDate = {};
             _startDateChanged = false;
             _endDateChanged = false;
             _frequencies = {};
        }

        //load the currently selected fiscal year into the application
        function loadFiscalYear() {
            _fiscalYear = angular.copy(bmppFiscalYearService.getSelectedFiscalYear());
            //convert the start and end date to js dates
            _startDate = moment(_fiscalYear.startDate).toDate();
            _startDateChanged = false;
            _endDate = moment(_fiscalYear.endDate).toDate();
            _endDateChanged = false;

            _currentPeriods = {};

            //after we load we want to setup the current periods
            _.forEach(_fiscalYear.periods, function (period) {
                if (period.isCurrentPeriod) {
                    _currentPeriods[period.periodType] = period.sequenceNumber;
                }
            });

            //now we want to load the frequencies
            _frequencies = {};
            _.forEach(applicationTypes, function (appType) {
                //get the periods for the application type
                var periodsForApplicationType = _.filter(_fiscalYear.periods, function (period) {
                    return period.periodType === appType;
                });

                //get the frequency for the periods in this application type
                var frequency = bmppFrequencyService.getFrequencyByValue(periodsForApplicationType.length);
                if(periodsForApplicationType.length === applicationTypes.Accounting){
                    _fiscalYear.frequencyType = frequency.Type;
                }

                //if we have a custom frequency, then we need to update that value
                if (bmppFrequencyService.isCustomFrequency(frequency)) {
                    frequency.customFrequency = periodsForApplicationType.length;
                }

                //assign the frequency value for this application type
                _frequencies[appType] = frequency;
            });
        }

        //returns the fiscal year
        function getFiscalYear() {
            var fiscalYear = angular.copy(_fiscalYear);
            if (_startDateChanged) {
                fiscalYear.startDate = _startDate;
            }
            if (_endDateChanged) {
                fiscalYear.endDate = _endDate;
            }
            return fiscalYear;
        }

        //return the sequenceNumber for the current period for the currently selected application
        function getCurrentPeriod() {
            var selectedApplication = bmppApplicationTypeService.getSelectedApplication();
            return _currentPeriods[selectedApplication];
        }

        function getCurrentPeriodForAccounting() {
            return _currentPeriods[applicationTypes.Accounting];
        }

        //sets the sequence number for the current period
        function setCurrentPeriod(sequenceNumber) {
            var selectedApplication = bmppApplicationTypeService.getSelectedApplication();
            _currentPeriods[selectedApplication] = sequenceNumber;
        }

        //update the end date of period
        //Param: useAccounting tells the function to only get the accounting info
        function updatePeriod(sequenceNumber, endDate, useAccounting) {
            var selectAccounting = useAccounting || false;
            var selectedApplication = selectAccounting ? applicationTypes.Accounting : bmppApplicationTypeService.getSelectedApplication();
            var periodToUpdate = _.find(_fiscalYear.periods, function (period) {
                return period.sequenceNumber === sequenceNumber && period.periodType === selectedApplication && !period.isDeleted;
            });

            if (angular.isDefined(periodToUpdate)) {
                periodToUpdate.endDate = endDate;
            }
        }

        //updates the fiscal year begin date
        //Para
        function updateStartDate(startDate) {
            //make sure that the day has actually changed before running update
            if (!moment(startDate).isSame(moment(_startDate), 'day')) {
                _startDate = startDate;
                _startDateChanged = true;
                updatePeriodsForAllApplications();
            }
        }

        //updates the fiscal year end date
        function updateEndDate(endDate) {
            if (!moment(endDate).isSame(moment(_endDate), 'day')) {
                _endDate = endDate;
                _endDateChanged = true;
                updatePeriodsForAllApplications();
            }
        }

        //if the start or end dates are  changed, we want to update periods for both sets of applications
        function updatePeriodsForAllApplications() {
            //first lets find out which applications already have periods set
            var applicationsWithPeriods = _.pluck(_.uniq(_fiscalYear.periods, 'periodType'), 'periodType');

            //now lets iterate over the applications that need to be updated
            _.forEach(applicationsWithPeriods, function (applicatonType) {
                //keep the frequency the same as the previous
                var frequency = _frequencies[applicatonType];

                //and we want to create  a new set of periods with the same frequency
                var periods = bmppCreateFiscalYearService.createFiscalYear(_startDate, _endDate, frequency, _fiscalYear.sequenceNumber).periods;

                //first lets select the existing periods for this application and mark them as deleted
                var existingPeriods = _.filter(_fiscalYear.periods, function (period) {
                    return angular.isDefined(period.id) && period.periodType === applicatonType;
                });

                //mark the is deleted flag
                _.forEach(existingPeriods, function (existingPeriod) {
                    existingPeriod.isDeleted = true;
                });

                //now we want to remove any periods that we may have added during a previous update
                _fiscalYear.periods = _.filter(_fiscalYear.periods, function (period) {
                    return period.periodType !== applicatonType || angular.isDefined(period.id);
                });

                //now we want to give the updated periods the selected application as their period type
                _.forEach(periods, function (updatedPeriod) {
                    updatedPeriod.periodType = applicatonType;
                });

                //now add the updated periods to _periods
                _fiscalYear.periods = _fiscalYear.periods.concat(periods);
            });
        }

        //return the periods for the currently selected application
        function getPeriodsForCurrentApplication() {
            var selectedApplication = bmppApplicationTypeService.getSelectedApplication();
            //LODASH VERSION
            return _.filter(_fiscalYear.periods, function (period) {
                return period.periodType === selectedApplication && !period.isDeleted;
            });
        }

        //return the periods for Accounting only
        function getPeriodsForAccounting() {
            //LODASH VERSION
            return _.filter(_fiscalYear.periods, function (period) {
                return period.periodType === applicationTypes.Accounting && !period.isDeleted;
            });
        }

        //returns the frequency for the current application
        function getFrequencyForCurrentApplication() {
            return _frequencies[bmppApplicationTypeService.getSelectedApplication()];
        }

        //returns the frequency for the current application
        function getFrequencyForAccounting() {
            return _frequencies[applicationTypes.Accounting];
        }

        //this will set the period with the given sequence number for the selected application
        //to the boolean parameter
        function setPeriodValidity(sequenceNumber, isValid) {
            var selectedApplication = bmppApplicationTypeService.getSelectedApplication();
            var matchingPeriod = _.find(_fiscalYear.periods, function (period) {
                return !period.isDeleted && period.sequenceNumber === sequenceNumber && period.periodType === selectedApplication;
            });

            if (angular.isDefined(matchingPeriod)) {
                matchingPeriod.isValid = isValid;
            }
        }

        //this function returns true if the fiscal year is save to save down
        function isFiscalYearValid() {
            var startDate = _startDateChanged ? _startDate : _fiscalYear.startDate;
            var endDate = _endDateChanged ? _endDate : _fiscalYear.endDate;
            //first check to make sure our start date is before the end date
            var isEndDateAfterStartDate = bmppDateManipulatorService.isAfter(endDate, startDate);

            return isEndDateAfterStartDate && arePeriodsValid();
        }

        //are there any periods with isValid flag set to false?
        function arePeriodsValid() {
            var invalidPeriods = _.filter(_fiscalYear.periods, function (period) {
                return !period.isDeleted && period.isValid === false;
            });

            return invalidPeriods.length === 0;
        }

        //returns true if the start date is editable
        //only allow if it is the first fiscal year
        function isStartDateEditable() {
            return angular.isDefined(bmppFiscalYearService.getFirstFiscalYear()) ? bmppFiscalYearService.getFirstFiscalYear().id === _fiscalYear.id : false;
        }

        //returns true if the end date is editable
        //only allow if this is the last fiscal year
        function isEndDateEditable() {
            return bmppFiscalYearService.getLastFiscalYear().id === _fiscalYear.id;
        }

        //updates the frequency for the currently selected application's periods
        //Param updateAccountingOnly: update Accounting frequency instead of selected application
        function updateFrequency(frequency, updateAccountingOnly) {
            var updateAccountingFrequency = updateAccountingOnly || false;
            var selectedApplication = updateAccountingFrequency ?
                applicationTypes.Accounting : bmppApplicationTypeService.getSelectedApplication();
            //update the frequency value
            _frequencies[selectedApplication] = frequency;
            _fiscalYear.frequencyType = frequency.Type;

            //create a new fiscal year with the updated frequency
            var startDate = _startDateChanged ? _startDate : _fiscalYear.startDate;
            var endDate = _endDateChanged ? _endDate : _fiscalYear.endDate;
            var periods = bmppCreateFiscalYearService.createFiscalYear(startDate, endDate, frequency, _fiscalYear.sequenceNumber).periods;

            //update the periods for the currently selected application
            updatePeriodsForSelectedApplication(periods, updateAccountingOnly);

            //if the new frequency is smaller than the old
            //and the index of the current period is not valid
            //in the new set of periods, we need to reset the
            //current period's index
            if (getCurrentPeriod() > periods.length) {
                setCurrentPeriod(1);
            }
        }

        //update periods for selected application
        //Param updateAccountingPeriods: tells the function to update Accounting instead of selected application
        function updatePeriodsForSelectedApplication(periods, updateAccountingPeriods) {
            //Undefined prevention
            var updateAccounting = updateAccountingPeriods || false;

            //now we need to iterate over these periods and set their application type
            //first lets grab the currently selected application
            var selectedApplication = updateAccounting ?
                applicationTypes.Accounting : bmppApplicationTypeService.getSelectedApplication();

            //first lets select the existing periods for this application and mark them as deleted
            var existingPeriods = _.filter(_fiscalYear.periods, function (period) {
                return angular.isDefined(period.id) && period.periodType === selectedApplication;
            });

            //mark the is deleted flag
            _.forEach(existingPeriods, function (existingPeriod) {
                existingPeriod.isDeleted = true;
            });

            //now we want to remove any periods that we may have added during a previous update
            _fiscalYear.periods = _.filter(_fiscalYear.periods, function (period) {
                return period.periodType !== selectedApplication || angular.isDefined(period.id);
            });

            //now we want to give the updated periods the selected application as their period type
            _.forEach(periods, function (updatedPeriod) {
                updatedPeriod.periodType = selectedApplication;
            });

            //now add the updated periods to _periods
            _fiscalYear.periods = _fiscalYear.periods.concat(periods);
        }

        //update the current periods
        function updateCurrentPeriods() {
            //we want to update the isCurrentPeriod flag
            _.forEach(_fiscalYear.periods, function (period) {
                if (_currentPeriods[period.periodType] === period.sequenceNumber) {
                    period.isCurrentPeriod = true;
                } else {
                    period.isCurrentPeriod = false;
                }
            });
        }

         //update periods for selected application
         //Param useAccounting: tells the function to use Accounting instead of Selected Application
         function updateMappingForEditedPeriods(updatedPeriod, existingPeriod, useAccounting) {
            //Undefined prevention
            var updateAccountingMapping = useAccounting || false;
            var selectedApplication = updateAccountingMapping ? applicationTypes.Accounting : bmppApplicationTypeService.getSelectedApplication();
            //now update the mapping value in deleted periods
            var existingPeriodToUpdate = _.find(_fiscalYear.periods, function (period) {
                return period.id === existingPeriod.id && period.periodType === selectedApplication && period.isDeleted;
            });

            //just update the mapping id
            if (angular.isDefined(existingPeriodToUpdate)) {
                existingPeriodToUpdate.mappingId = updatedPeriod.sequenceNumber;
            }
         }
        //save the fiscal year down and update the fiscal year service default value for the edit periods is false
        function saveFiscalYear(isEditPeriods, yearEndCloseOptions) {
            //if we are editing periods then get the isEditPeriods value or set it to false which is default
            var editPeriods = isEditPeriods || false;
            bmppBusyLoaderService.turnOnBusyLoader();
            updateCurrentPeriods();
            _fiscalYear.startDate = _startDateChanged ? _startDate : _fiscalYear.startDate;
            _fiscalYear.endDate = _endDateChanged ? _endDate : _fiscalYear.endDate;

            //convert the end date to a string
            _fiscalYear.endDate = bmppDateManipulatorService.formatDateForDto(_fiscalYear.endDate);
            //iterate over the periods and convert their dates to strings
            _.forEach(_fiscalYear.periods, function (period) {
                period.startDate = bmppDateManipulatorService.formatDateForDto(period.startDate);
                period.endDate = bmppDateManipulatorService.formatDateForDto(period.endDate);
            });

            _fiscalYear.taxCodeYear = bmppTaxYearService.getCurrentTaxYear();

            //get the fiscal year to close if any
            if(angular.isDefined(yearEndCloseOptions)) {
                var fiscalYearToClose = bmppFiscalYearService.getFiscalYearById(yearEndCloseOptions.fiscalYearId);
            }
            //get the owner id and send the fiscal year to the server
            var ownerId = bmppOwnerService.getOwnerId();
            return bmppDataService.updateFiscalYear(ownerId, _fiscalYear, editPeriods, yearEndCloseOptions).then(function (updateFiscalYearResult) {
                //display year end close success indicator
                if(angular.isDefined(fiscalYearToClose)) {
                    $rootScope.$broadcast(bmppEvents.BMPP_YEAR_END_CLOSE_SUCCEEDED, fiscalYearToClose.endDate);
                }
                //we need to do a full refresh of the fiscal years
                //because we may have altered the changed time of a period
                //that is not returned with this fiscal year
                //Example/ We set the current period to one in the updated fiscal year
                //and it was previously set in a different fiscal year
                bmppFiscalYearService.clearFiscalYears();
                bmppDataService.getAllFiscalYears(ownerId).then(function (getFiscalYearsResult) {
                    bmppFiscalYearService.setFiscalYears(getFiscalYearsResult.data, updateFiscalYearResult.data.sequenceNumber);
                    bmppBusyLoaderService.turnOffBusyLoader();
                });
            }, function () {
                //failure
                //display year end close failure indicator
                if(angular.isDefined(fiscalYearToClose)) {
                    $rootScope.$broadcast(bmppEvents.BMPP_YEAR_END_CLOSE_FAILED, fiscalYearToClose.endDate);
                }
                //We're going to reset the data to what was previously there
                $rootScope.$broadcast(bmppEvents.BMPP_FISCAL_YEAR_FAILED_SAVE);
                bmppFiscalYearService.clearFiscalYears();
                bmppDataService.getAllFiscalYears(ownerId).then(function (getFiscalYearsResult) {
                    bmppFiscalYearService.setFiscalYears(getFiscalYearsResult.data, _fiscalYear.sequenceNumber);
                    bmppBusyLoaderService.turnOffBusyLoader();
                });
            });
        }

        //Returns true if the start date was changed on the year
        function isStartDateChanged() {
            return _startDateChanged;
        }

        //Returns true if the end date was changed on the year
        function isEndDateChanged() {
            return _endDateChanged;
        }
    }
})(window.angular, window._, window.moment);

(function (angular, _, moment) {
    'use strict';
    angular.module('bluemoon.periods').directive('bmppAddFiscalYear', ['$rootScope', 'bmppAddFiscalYearService', 'bmppFrequencyService', 'bmppEvents', 'bmppApplicationTypeService', 'bmppTaxYearService', 'bmppFiscalYearService', 'bmppLocaleService',
        function ($rootScope, bmppAddFiscalYearService, bmppFrequencyService, bmppEvents, bmppApplicationTypeService, bmppTaxYearService, bmppFiscalYearService, bmppLocaleService) {
            return {
                restrict: 'AE',
                scope: {},
                templateUrl: 'components/periods-refactored/bmpp-add-fiscal-year/bmpp-add-fiscal-year.2js.html',
                link: function (scope) {
                    init();

                    //reinitialize this directive when add mode changes
                    scope.$on(bmppEvents.BMPP_ADD_MODE_CHANGED, function () {
                        init();
                    });
                    //check if the frequency is changed then we need to broadcast and event to update the current period combo
                    function checkFrequencyChanged(newVal, oldVal) {
                        var isChanged = newVal !== oldVal;
                        $rootScope.$broadcast(bmppEvents.BMPP_ADD_FISCAL_YEAR_FREQUENCY_CHANGED, isChanged);
                    }

                    //watch for the selected frequency, we need to update the current period combo
                    scope.$watch('selectedFrequency', function (newVal, oldVal) {
                        checkFrequencyChanged(newVal, oldVal);
                    });

                    scope.$on(bmppEvents.BMPP_ADD_YEAR_SAVE_CLICKED, function() {
                        scope.saveClick();
                    });

                     //stripe out the non numbers
                     scope.$watch('customFrequency', function (newVal, oldVal){
                        if (angular.isUndefined(newVal) || newVal === null) {
                            scope.customFrequency = oldVal;
                        } else {
                            //only run the validation if they've added characters
                            if (angular.isUndefined(oldVal) || newVal.length > oldVal.length) {
                                scope.customFrequency = newVal.replace(/\D/g,'');
                                scope.customFrequency.trim();
                            }
                        }
                    });

                    //need to change the period grid when the application type changes
                    scope.$on(bmppEvents.BMPP_SELECTED_APPLICATION_CHANGED, function () {
                        refreshFrequencies();
                        updatePeriods();
                        updateFrequency();
                    });

                    //the frequency combobox has changed,
                    //need to go to the service and create a new year
                    scope.onFrequencyChanged = function () {
                        var frequency = bmppFrequencyService.getFrequencyByValue(parseInt(scope.selectedFrequency));
                        //call the add year service to update the frequency
                        bmppAddFiscalYearService.updateFrequency(frequency);
                        //update the periods
                        updatePeriods();
                    };

                    //update the periods when the start date changes
                    scope.startDateChanged = function () {
                        //call the add year service to update the begin date
                        bmppAddFiscalYearService.updateStartDate(scope.startDate);
                        //update the periods
                        updatePeriods();

                        scope.taxYears = getTaxYears();

                        //if they have fixed a previously invalid lets turn off the validation message
                        if (bmppAddFiscalYearService.isFiscalYearValid()) {
                            scope.showValidationMessage = false;
                        }
                    };

                    //update the periods when the end date changes
                    scope.endDateChanged = function () {
                        //call the add year service to update the end date
                        bmppAddFiscalYearService.updateEndDate(scope.endDate);
                        //update the periods
                        updatePeriods();

                        scope.taxYears = getTaxYears();

                        scope.$broadcast(bmppEvents.BMPP_ADD_YEAR_END_DATE_CHANGED);

                        //if they have fixed a previously invalid lets turn off the validation message
                        if (bmppAddFiscalYearService.isFiscalYearValid()) {
                            scope.showValidationMessage = false;
                        }
                    };

                    //the user has clicked the save button
                    scope.saveClick = function () {
                        //first we need to check if they have accounts
                        //clients with accounts need at least 1 accounting periods
                        if (bmppAddFiscalYearService.needsAccountingPeriods()) {
                            scope.showNeedsAccountingPeriodsMessage = true;
                        } else if (!bmppAddFiscalYearService.isFiscalYearValid()) {
                            //if the fiscal year is not valid we want to show the validtion messages
                            scope.showValidationMessage = true;
                        } else if (scope.showTaxYear() && !bmppTaxYearService.isCurrentTaxYearValid()) {
                            scope.showTaxYearWarning = true;
                        } else { //otherwise we can save it down
                            bmppAddFiscalYearService.saveFiscalYear();
                        }
                    };

                    //the user has cancelled the add process
                    scope.cancelClick = function () {
                        init();
                    };

                    //returns true if the
                    scope.isFiscalYearValid = function () {
                        return bmppAddFiscalYearService.isFiscalYearValid();
                    };

                    //the user has entered a new custom frequency
                    scope.customFrequencyChanged = function () {
                        //first we need to make sure the input is valid
                        if (_.isFinite(scope.customFrequency)) {
                            var frequency = {
                                Value: 0,
                                customFrequency: parseInt(scope.customFrequency)
                            };
                            //call the add year service to update the frequency
                            bmppAddFiscalYearService.updateFrequency(frequency);
                            //update the periods
                            updatePeriods();
                        }
                    };

                    //returns the currently selected application
                    scope.getSelectedApplication = function () {
                        return bmppApplicationTypeService.getSelectedApplication();
                    };

                    //returns true if this fiscal year still needs accounting periods to be valid
                    scope.needsAccountingPeriods = function () {
                        return bmppAddFiscalYearService.needsAccountingPeriods();
                    };

                    scope.showTaxYear = function () {
                        return bmppApplicationTypeService.getSelectedApplication() === scope.applicationTypes.Accounting;
                    };

                    //returns the tax years
                    function getTaxYears() {

                        //grab the fiscal years
                        var fiscalYears = bmppFiscalYearService.getFiscalYears();

                        //get the available years, that haven't been used
                        var years = bmppTaxYearService.getUnusedTaxYears(fiscalYears);

                        //check and make sure that the years we're adding are not used
                        var yearBegin = moment(scope.startDate).year();
                        var yearEnd = moment(scope.endDate).year();

                        if (!bmppTaxYearService.isTaxYearUsed(fiscalYears, yearBegin)){
                            years.push(yearBegin);
                        }

                        if (!bmppTaxYearService.isTaxYearUsed(fiscalYears, yearEnd)){
                            years.push(yearEnd);
                        }

                        years = _.uniq(years);
                        return years;
                    }
                    //update the periods that are currently displayed to the user
                    function updatePeriods() {
                        scope.periods = bmppAddFiscalYearService.getPeriodsForCurrentApplication();
                    }

                    //update the frequency based on the number of periods
                    //update the selected frequency based on the number of periods
                    function updateFrequency() {
                        if (scope.periods.length > 0) {
                            var frequency = bmppAddFiscalYearService.getFrequencyForCurrentApplication();
                            scope.selectedFrequency = frequency.Value.toString();

                            //if we have a custom frequency, then we need to update that value
                            if (bmppFrequencyService.isCustomFrequency(frequency)) {
                                scope.customFrequency = scope.periods.length;
                            }
                        } else { //if we don't have any periods reset the selected frequency, and custom frequency
                            scope.selectedFrequency = '';
                            scope.customFrequency = undefined;
                        }
                    }

                    function refreshFrequencies() {
                        scope.frequencies = bmppFrequencyService.getFrequencies();
                    }

                    //the user has changed the tax year...send it down to the tax year service and remove validation
                    scope.taxYearChanged = function () {
                        bmppTaxYearService.setCurrentTaxYear(scope.selectedTaxYear);
                        scope.showTaxYearWarning = !bmppTaxYearService.isCurrentTaxYearValid();
                    };

                    //intiailization code
                    function init() {
                        scope.frequencies = bmppFrequencyService.getFrequencies();
                        scope.showTaxYearWarning = false;

                        //use the service to create a new fiscal year
                        var fiscalYear = bmppAddFiscalYearService.initializeNewFiscalYear();
                        bmppTaxYearService.setCurrentTaxYear(fiscalYear.taxCodeYear);
                        scope.startDate = fiscalYear.startDate;
                        scope.endDate = fiscalYear.endDate;
                        scope.taxYears = getTaxYears();
                        scope.selectedFrequency = '';
                        scope.showValidationMessage = false;
                        scope.showNeedsAccountingPeriodsMessage = false;
                        scope.applicationTypes = bmppApplicationTypeService.getApplicationTypes();
                        updatePeriods();
                        updateFrequency();
                        //get the country specific
                        scope.isFrequencyEnabled = function () {
                            return bmppLocaleService.isArgentina();
                        };
                    }
                }
            };
        }
    ]);
})(window.angular, window._, window.moment);

(function(angular, _) {
    'use strict';
    angular.module('bluemoon.periods').factory('bmppAddFiscalYearService', bmppAddFiscalYearService);
    bmppAddFiscalYearService.$inject = ['bmppCreateFiscalYearService', 'bmppFiscalYearService', 'bmppDateManipulatorService', 'bmppApplicationTypeService', 'bmppDataService', 'bmppOwnerService', 'bmppBusyLoaderService', 'bmppFrequencyService', 'bmppAccountsService', 'bmppTaxYearService'];

    function bmppAddFiscalYearService(bmppCreateFiscalYearService, bmppFiscalYearService, bmppDateManipulatorService, bmppApplicationTypeService, bmppDataService, bmppOwnerService, bmppBusyLoaderService, bmppFrequencyService, bmppAccountsService, bmppTaxYearService) {
        var _fiscalYear = {};
        var _currentPeriods = {};
        var _frequencies = {};
        return {
            getFiscalYear: getFiscalYear,
            initializeNewFiscalYear: initializeNewFiscalYear,
            getPeriodsForCurrentApplication: getPeriodsForCurrentApplication,
            getFrequencyForCurrentApplication: getFrequencyForCurrentApplication,
            updateFrequency: updateFrequency,
            updateStartDate: updateStartDate,
            updateEndDate: updateEndDate,
            updatePeriod: updatePeriod,
            setPeriodValidity: setPeriodValidity,
            setCurrentPeriod: setCurrentPeriod,
            getCurrentPeriod: getCurrentPeriod,
            saveFiscalYear: saveFiscalYear,
            isValidPriorYear: isValidPriorYear,
            isValidNewYear: isValidNewYear,
            isFiscalYearValid: isFiscalYearValid,
            needsAccountingPeriods: needsAccountingPeriods
        };

        //returns the fiscal year
        function getFiscalYear() {
            return _fiscalYear;
        }

        //initialize a new fiscal year
        function initializeNewFiscalYear() {
            //initialize an empty fiscal year
            _fiscalYear = bmppCreateFiscalYearService.initializeEmptyFiscalYear();

            //grab the existing fiscal years
            var fiscalYears = bmppFiscalYearService.getFiscalYears();

            //initialize the sequence number to 1 more than the current fiscal years length
            _fiscalYear.sequenceNumber = fiscalYears.length + 1;

            //default the start to be 1 day after the last fiscal year's begin date
            _fiscalYear.startDate = bmppFiscalYearService.getNextFiscalYearBeginDate(fiscalYears);

            //default the end date to be 1 year after the start date
            _fiscalYear.endDate = bmppDateManipulatorService.addYears(_fiscalYear.startDate, 1);

            //set the current periods to empty
            _currentPeriods = {};

            //set the selected frequencies to empty
            _frequencies = {};

            //default accounting to an annual year
            var annualFrequency = bmppFrequencyService.getFrequencyByValue(1);
            updateFrequency(annualFrequency);

            //return the fiscal year
            return _fiscalYear;
        }

        //return the periods for the currently selected application
        function getPeriodsForCurrentApplication() {
            return _.filter(_fiscalYear.periods, {
                'periodType': bmppApplicationTypeService.getSelectedApplication()
            });
        }

        //return the peridos for Accounting
        function getPeriodsForAccounting() {
            return _.filter(_fiscalYear.periods, {
                'periodType': bmppApplicationTypeService.getApplicationTypes().Accounting
            });
        }

        //returns the frequency for the current application
        function getFrequencyForCurrentApplication() {
            return _frequencies[bmppApplicationTypeService.getSelectedApplication()];
        }

        //update the year begin of the fiscal year
        function updateStartDate(startDate) {
            _fiscalYear.startDate = startDate;
            updatePeriodsForAllApplications();
        }

        //update the year end of the fiscal year
        function updateEndDate(endDate) {
            _fiscalYear.endDate = endDate;
            updatePeriodsForAllApplications();
        }

        //update the end date of period
        function updatePeriod(sequenceNumber, endDate) {
            var selectedApplication = bmppApplicationTypeService.getSelectedApplication();
            var periodToUpdate = _.find(_fiscalYear.periods, function(period) {
                return period.sequenceNumber === sequenceNumber && period.periodType === selectedApplication && !period.isDeleted;
            });

            periodToUpdate.endDate = endDate;
        }

        //this will set the period with the given sequence number for the selected application
        //to the boolean parameter
        function setPeriodValidity(sequenceNumber, isValid) {
            var selectedApplication = bmppApplicationTypeService.getSelectedApplication();
            var matchingPeriod = _.find(_fiscalYear.periods, function(period) {
                return !period.isDeleted && period.sequenceNumber === sequenceNumber && period.periodType === selectedApplication;
            });

            matchingPeriod.isValid = isValid;
        }

        //updates the frequency for the currently selected application's periods
        function updateFrequency(frequency) {
            //update the frequency for the selected application
            var selectedApplication = bmppApplicationTypeService.getSelectedApplication();
            _frequencies[selectedApplication] = frequency;
            _fiscalYear.frequencyType = frequency.Value;

            //now update the periods
            updatePeriodsForSelectedApplication();
        }

        //sets the current period's sequence number for the currently selected application
        function setCurrentPeriod(sequenceNumber) {
            //get the currently selected application
            var currentApplication = bmppApplicationTypeService.getSelectedApplication();

            //set the index of the current period
            _currentPeriods[currentApplication] = sequenceNumber;
        }

        //returns the current period's index for the selected application
        function getCurrentPeriod() {
            //get the currently selected application
            var currentApplication = bmppApplicationTypeService.getSelectedApplication();

            //return the current period's index
            return _currentPeriods[currentApplication];
        }

        //if the start or end dates are  changed, we want to update periods for both sets of applications
        function updatePeriodsForAllApplications() {
            //first lets find out which applications already have periods set
            var applicationsWithPeriods = _.pluck(_.uniq(_fiscalYear.periods, 'periodType'), 'periodType');

            //now lets iterate over the applications that need to be updated
            _.forEach(applicationsWithPeriods, function(applicatonType) {
                //now we want to remove all periods for the selected application
                _fiscalYear.periods = _.filter(_fiscalYear.periods, function(period) {
                    return period.periodType !== applicatonType;
                });

                //keep the frequency the same as the previous
                var frequency = _frequencies[applicatonType];
                _fiscalYear.frequencyType = frequency.Value;

                //and we want to create  a new set of periods with the same frequency
                var periods = bmppCreateFiscalYearService.createFiscalYear(_fiscalYear.startDate, _fiscalYear.endDate, frequency, _fiscalYear.sequenceNumber).periods;

                //now we want to give the updated periods the selected application as their period type
                _.forEach(periods, function(updatedPeriod) {
                    updatedPeriod.periodType = applicatonType;
                });

                //now add the updated periods to _periods
                _fiscalYear.periods = _fiscalYear.periods.concat(periods);
            });
        }

        //update periods for selected application
        function updatePeriodsForSelectedApplication() {
            //now we need to iterate over these periods and set their application type
            //first lets grab the currently selected application
            var selectedApplication = bmppApplicationTypeService.getSelectedApplication();
            //then lets grab the selected frequency for this application
            var frequency = _frequencies[selectedApplication];

            var periods = bmppCreateFiscalYearService.createFiscalYear(_fiscalYear.startDate, _fiscalYear.endDate, frequency, _fiscalYear.sequenceNumber).periods;

            //now we want to remove all periods for the selected application
            //LODASH VERSION
            // _.remove(_fiscalYear.periods, function(period) {
            //     return period.periodType === selectedApplication;
            // });

            _fiscalYear.periods = _.filter(_fiscalYear.periods, function(period) {
                return period.periodType !== selectedApplication;
            });

            //now we want to give the updated periods the selected application as their period type
            _.forEach(periods, function(updatedPeriod) {
                updatedPeriod.periodType = selectedApplication;
            });

            //now add the updated periods to _periods
            _fiscalYear.periods = _fiscalYear.periods.concat(periods);
        }

        //is this a valid prior year
        function isValidPriorYear() {
            //first check to make sure our start date is before the end date
            var isEndDateAfterStartDate = bmppDateManipulatorService.isAfter(_fiscalYear.endDate, _fiscalYear.startDate);
            //grab the first fiscal year
            var firstFiscalYear = bmppFiscalYearService.getFirstFiscalYear();
            // is the end date exactly 1 day before the first fiscal year's begin
            var isEndDateOneDayBeforeFirstFiscalYearBeginDate = bmppDateManipulatorService.isBefore(_fiscalYear.endDate, firstFiscalYear.startDate) && bmppDateManipulatorService.numberOfDaysInRange(_fiscalYear.endDate, firstFiscalYear.startDate) === 1;

            return isEndDateAfterStartDate && isEndDateOneDayBeforeFirstFiscalYearBeginDate;
        }

        //is this a valid year that is after the last existing year
        function isValidNewYear() {
            //first check to make sure our start date is before the end date
            var isEndDateAfterStartDate = bmppDateManipulatorService.isAfter(_fiscalYear.endDate, _fiscalYear.startDate);
            //grab the last fiscal year
            var lastFiscalYear = bmppFiscalYearService.getLastFiscalYear();
            //is the begin date exactly 1 day after the last fiscal year's end date
            var isBeginDateOneDateAfterLastFiscalYearEndDate = bmppDateManipulatorService.isAfter(_fiscalYear.startDate, lastFiscalYear.endDate) && bmppDateManipulatorService.numberOfDaysInRange(_fiscalYear.startDate, lastFiscalYear.endDate) === 1;

            return isEndDateAfterStartDate && isBeginDateOneDateAfterLastFiscalYearEndDate;
        }

        //are there any periods with isValid flag set to false?
        function arePeriodsValid() {
            var invalidPeriods = _.filter(_fiscalYear.periods, function(period) {
                return !period.isDeleted && period.isValid === false;
            });

            return invalidPeriods.length === 0;
        }

        //returns true if this fiscal year needs accounting periods
        function needsAccountingPeriods() {
            return bmppAccountsService.hasAccounts() && getPeriodsForAccounting().length === 0;
        }

        //check if the the periods are all valid
        function isFiscalYearValid() {
            return (isValidPriorYear() || isValidNewYear()) && arePeriodsValid();
        }

        //update the current periods
        function updateCurrentPeriods() {
            //we want to update the isCurrentPeriod flag
            _.forEach(_fiscalYear.periods, function(period) {
                if (_currentPeriods[period.periodType] === period.sequenceNumber) {
                    period.isCurrentPeriod = true;
                } else {
                    period.isCurrentPeriod = false;
                }
            });
        }

        //save the fiscal year down to the db
        function saveFiscalYear() {
            bmppBusyLoaderService.turnOnBusyLoader();
            //if we are saving down a prior year, we want to set the sequence number to 1
            if (isValidPriorYear()) {
                _fiscalYear.sequenceNumber = 1;
            }

            //run the code to update the is current period flag
            updateCurrentPeriods();
            //convert the end date to a string
            _fiscalYear.endDate = bmppDateManipulatorService.formatDateForDto(_fiscalYear.endDate);
            //iterate over the periods and convert their dates to strings
            _.forEach(_fiscalYear.periods, function(period) {
                period.startDate = bmppDateManipulatorService.formatDateForDto(period.startDate);
                period.endDate = bmppDateManipulatorService.formatDateForDto(period.endDate);
            });

            _fiscalYear.taxCodeYear = bmppTaxYearService.getCurrentTaxYear();

            return bmppDataService.addNewFiscalYear(bmppOwnerService.getOwnerId(), _fiscalYear).then(function(addFiscalYearResult) {
                if (addFiscalYearResult.result === 'success') {
                    //we need to do a full refresh of the fiscal years
                    //because we may have altered the changed time of a period
                    //that is not returned with this fiscal year
                    //Example/ We set the current period to one in the updated fiscal year
                    //and it was previously set in a different fiscal year
                    bmppFiscalYearService.clearFiscalYears();
                    bmppDataService.getAllFiscalYears(bmppOwnerService.getOwnerId()).then(function(getFiscalYearsResult) {
                        if (getFiscalYearsResult.result === 'success') {
                            bmppFiscalYearService.setFiscalYears(getFiscalYearsResult.data, addFiscalYearResult.data.sequenceNumber);
                        }
                        bmppBusyLoaderService.turnOffBusyLoader();
                    });
                } else {
                    bmppBusyLoaderService.turnOffBusyLoader();
                }
            });
        }
    }
})(window.angular, window._);

(function(angular) {
    'use strict';
    angular.module('bluemoon.periods').controller('bmppAddFiscalYearModal', ['$scope', '$uibModalInstance', 'bmppAddFiscalYearService',
        function($scope, $uibModalInstance, bmppAddFiscalYearService) {
            //initialize the modal
            init();

            //close the modal and don't do anything with the data
            $scope.cancelClick = function() {
                $uibModalInstance.dismiss('cancel');
            };

            //the user has clicked the save button
            $scope.saveClick = function() {
                //if the fiscal year is not valid we want to show the validtion messages
                if (!bmppAddFiscalYearService.isFiscalYearValid()) {
                    $scope.showValidationMessage = true;
                } else { //otherwise we can save it down
                    bmppAddFiscalYearService.saveFiscalYear().then(function() {
                        $uibModalInstance.close();
                    });
                }
            };

            //update the periods when the start date changes
            $scope.startDateChanged = function() {
                //call the add year service to update the begin date
                bmppAddFiscalYearService.updateStartDate($scope.startDate);
                //if they have fixed a previously invalid lets turn off the validation message
                if (bmppAddFiscalYearService.isFiscalYearValid()) {
                    $scope.showValidationMessage = false;
                }
            };

            //update the periods when the end date changes
            $scope.endDateChanged = function() {
                //call the add year service to update the end date
                bmppAddFiscalYearService.updateEndDate($scope.endDate);
                //if they have fixed a previously invalid lets turn off the validation message
                if (bmppAddFiscalYearService.isFiscalYearValid()) {
                    $scope.showValidationMessage = false;
                }
            };

            //initialization code
            function init() {
                //use the service to create a new fiscal year
                var fiscalYear = bmppAddFiscalYearService.initializeNewFiscalYear();
                $scope.startDate = fiscalYear.startDate;
                $scope.endDate = fiscalYear.endDate;
                $scope.showValidationMessage = false;
            }
        }
    ]);
})(window.angular);

(function(angular) {
    'use strict';
    angular.module('bluemoon.periods').controller('bmppAddFiscalYearModalWithPeriods', ['$scope', '$uibModalInstance', 'bmppEvents', '$rootScope', 'bmppAddFiscalYearService', 'bmppTaxYearService', 'bmppApplicationTypeService',
        function($scope, $uibModalInstance, bmppEvents, $rootScope, bmppAddFiscalYearService, bmppTaxYearService, bmppApplicationTypeService) {
            //initialize the modal
            init();

            //close the modal and don't do anything with the data
            $scope.cancelClick = function() {
                $rootScope.$broadcast(bmppEvents.BMPP_ADD_YEAR_CANCEL_CLICKED);
                $uibModalInstance.dismiss('cancel');
            };

            //the user has clicked the save button
            $scope.saveClick = function() {
                //If the fiscal year can't be saved, we don't want to close the modal, but we
                //do want to trigger the save event to display validation errors
                var fiscalYearValid = !bmppAddFiscalYearService.needsAccountingPeriods() && bmppAddFiscalYearService.isFiscalYearValid();
                var accountingSelected = bmppApplicationTypeService.getSelectedApplication() === bmppApplicationTypeService.getApplicationTypes().Accounting;
                var taxYearValid = !accountingSelected || bmppTaxYearService.isCurrentTaxYearValid();
                $scope.$broadcast(bmppEvents.BMPP_ADD_YEAR_SAVE_CLICKED);
                if (fiscalYearValid && taxYearValid) {
                    $uibModalInstance.close();
                }
            };

            //initialization code
            function init() {}
        }
    ]);
})(window.angular);

(function(angular) {
    'use strict';
    angular.module('bluemoon.periods').controller('bmppEditFiscalYearModal', ['$scope', '$uibModalInstance', 'bmppEditFiscalYearService',
        function($scope, $uibModalInstance, bmppEditFiscalYearService) {
            //initialize the modal
            init();

            //close the modal and don't do anything with the data
            $scope.cancelClick = function() {
                $uibModalInstance.dismiss('cancel');
            };

            //the user has clicked the save button
            $scope.saveClick = function() {
                //if the fiscal year is not valid we want to show the validtion messages
                if (!bmppEditFiscalYearService.isFiscalYearValid()) {
                    $scope.showValidationMessage = true;
                } else { //otherwise we can save it down
                    bmppEditFiscalYearService.saveFiscalYear().then(function() {
                        $uibModalInstance.close();
                    });
                }
            };

            //returns true if the start date is editable
            $scope.isStartDateEditable = function() {
                return bmppEditFiscalYearService.isStartDateEditable();
            };

            //returns true if the end date is editable
            $scope.isEndDateEditable = function() {
                return bmppEditFiscalYearService.isEndDateEditable();
            };

            //update the periods when the start date changes
            $scope.startDateChanged = function() {
                //call the add year service to update the begin date
                bmppEditFiscalYearService.updateStartDate($scope.startDate);
                //if they have fixed a previously invalid lets turn off the validation message
                if (bmppEditFiscalYearService.isFiscalYearValid()) {
                    $scope.showValidationMessage = false;
                }
            };

            //update the periods when the end date changes
            $scope.endDateChanged = function() {
                //call the add year service to update the end date
                bmppEditFiscalYearService.updateEndDate($scope.endDate);
                //if they have fixed a previously invalid lets turn off the validation message
                if (bmppEditFiscalYearService.isFiscalYearValid()) {
                    $scope.showValidationMessage = false;
                }
            };

            //initialization code
            function init() {
                bmppEditFiscalYearService.loadFiscalYear();
                var fiscalYear = bmppEditFiscalYearService.getFiscalYear();
                $scope.startDate = new Date(fiscalYear.startDate);
                $scope.endDate = new Date(fiscalYear.endDate);
                $scope.showValidationMessage = false;
            }
        }
    ]);
})(window.angular);

(function(angular) {
    'use strict';
    angular.module('bluemoon.periods').directive('bmppPeriodGrid', [function() {
        return {
            restrict: 'AE',
            scope: {
              periods : '=',
              disabled : '=',
              fiscalYearBegin: '=',
              fiscalYearEnd: '=',
              addingFiscalYear: '=',
              useAccountingPeriods: '='
            },
            templateUrl: 'components/periods-refactored/bmpp-period-grid/bmpp-period-grid.2js.html',
            link: function() {}
        };
    }]);
})(window.angular);

(function (angular, moment) {
    'use strict';
    angular.module('bluemoon.periods').directive('bmppPeriodRow', ['bmppPeriodService', 'bmppDataService', 'bmppOwnerService', 'bmppEvents', '$rootScope', 'bmppAddFiscalYearService', 'bmppEditFiscalYearService',
        function (bmppPeriodService, bmppDataService, bmppOwnerService, bmppEvents, $rootScope, bmppAddFiscalYearService, bmppEditFiscalYearService) {
            return {
                restrict: 'AE',
                scope: {
                    period: '=',
                    nextPeriod: '=',
                    disabled: '=',
                    fiscalYearBegin: '=',
                    fiscalYearEnd: '=',
                    isFirstPeriod: '=',
                    isLastPeriod: '=',
                    datepickerWidth: '@',
                    topbarWidth: '@',
                    index: '@',
                    addingFiscalYear: '=',
                    useAccountingPeriods: '='
                },
                templateUrl: 'components/periods-refactored/bmpp-period-row/bmpp-period-row.2js.html',
                link: function (scope) {
                    init();

                    //if the next period's end date changes, we need to validate
                    scope.$watch('nextPeriod.endDate', function () {
                        updatePeriod();
                    });

                    //if our period end date is changed, we need to validate
                    scope.$watch('period.endDate', function (newVal, oldVal) {
                        //only broadcast if we change the date.  this also gets hit when we load the combo
                        //so unless the user changes the dates we dont want to broadcast.
                        //this needed for the edit period button when they only change the end date and not frequency
                        if(oldVal !== newVal){
                            scope.period.endDateLabel = moment(scope.period.endDate).format('L');
                            $rootScope.$broadcast(bmppEvents.BMPP_EDIT_PERIOD_END_DATE_CHANGED);
                        }
                        updatePeriod();
                    });

                    //iterate over the periods and hide all of the links
                    //then show the currently clicked period
                    scope.showCurrentLink = function () {
                        scope.period.showLink = true;
                    };

                    //don't show the set current period link unless the user is hovering over the row
                    scope.hideLink = function () {
                        scope.period.showLink = false;
                    };

                    //returns true if current link is visible
                    scope.isCurrenLinkVisible = function () {
                        return scope.period.showLink;
                    };

                    //returns true if this row is the current period
                    scope.isCurrentPeriod = function () {
                        scope.period.isCurrentPeriod = scope.addingFiscalYear ? scope.period.sequenceNumber === bmppAddFiscalYearService.getCurrentPeriod() : scope.period.sequenceNumber === bmppEditFiscalYearService.getCurrentPeriod();
                        return scope.period.isCurrentPeriod;
                    };

                    scope.setCurrentPeriod = function () {
                        //if we are in add mode, send the updated current period to
                        if (scope.addingFiscalYear) {
                            bmppAddFiscalYearService.setCurrentPeriod(scope.period.sequenceNumber);
                        } else {
                            bmppEditFiscalYearService.setCurrentPeriod(scope.period.sequenceNumber);
                        }
                    };

                    //function to update the period
                    function updatePeriod() {
                        scope.periodErrors = {};
                        var fiscalYear = scope.addingFiscalYear ? bmppAddFiscalYearService.getFiscalYear() : bmppEditFiscalYearService.getFiscalYear();
                        var periodValidation = bmppPeriodService.validatePeriodDate(scope.period, scope.nextPeriod, fiscalYear.startDate, fiscalYear.endDate, scope.isFirstPeriod, scope.isLastPeriod);
                        scope.periodHasError = !periodValidation.isValid;

                        //we need to tell either the add fiscal year service or edit fiscal year service about this period's validity
                        if (scope.addingFiscalYear) {
                            bmppAddFiscalYearService.setPeriodValidity(scope.period.sequenceNumber, periodValidation.isValid);
                            bmppAddFiscalYearService.updatePeriod(scope.period.sequenceNumber, scope.period.endDate);

                        } else {
                            bmppEditFiscalYearService.setPeriodValidity(scope.period.sequenceNumber, periodValidation.isValid);
                            bmppEditFiscalYearService.updatePeriod(scope.period.sequenceNumber, scope.period.endDate, scope.useAccountingPeriods);
                        }

                        //if the period has no validation issues, update it
                        if (!scope.periodHasError) {
                            bmppPeriodService.updatePeriodDate(scope.period, scope.nextPeriod);
                        } else {
                            scope.periodErrors = periodValidation.errors;
                        }
                    }

                    //intialize the row
                    function init() {
                        scope.periodHasError = false;
                        scope.periodErrors = {};
                    }
                }
            };
        }
    ]);
})(window.angular, window.moment);

(function(angular, moment) {
    'use strict';
    angular.module('bluemoon.periods').directive('bmppDatePicker', ['$locale', 'bmppDateFormatService', function($locale, bmppDateFormatService) {
        return {
            restrict: 'AE',
            scope: {
                selectedDate: '=',
                onChange: '&',
                disabled: '=',
                invalid: '=',
                width: '@'
            },
            templateUrl: 'components/periods-refactored/bmpp-date-picker/bmpp-date-picker.2js.html',
            link: function(scope) {
                init();

                //fires the onchange method that was passed in, when the component updates the selected date
                scope.$watch('selectedDate', function(oldVal, newVal) {
                    if (!moment(oldVal).isSame(newVal)) {
                        scope.onChange();
                    }
                });

                //opens the date picker
                scope.openDatePicker = function($event) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    scope.datePickerOpened = !scope.datePickerOpened;
                };

                //triggered when the user blurs off of the date input
                scope.datePickerBlur = function() {
                    var currentDate = moment(scope.selectedDate);
                    //get the value of the year
                    var year = currentDate.year();
                    //get the length;
                    var numberOfDigits = year.toString().length;
                    //if they entered a two digit year
                    //we need to convert it to a 4 digit
                    if (numberOfDigits === 2) {
                        //change the 2 digit year to a 4 digit year in the 2000s
                        var correctedYear = parseInt('20' + year.toString());
                        //update the current date
                        currentDate.year(correctedYear);
                        //and then change the scope variable
                        scope.selectedDate = currentDate.toDate();
                    }
                };

                //initialization code
                function init() {
                    //default the width to 70%
                    if (angular.isUndefined(scope.width)) {
                        scope.width = '70%';
                    }
                    scope.format = bmppDateFormatService.getDateFormat($locale.id);
                    scope.dateOptions = {
                        'showWeeks': false,
                        'showButtonBar': false,
                    };
                    scope.datePickerOpened = false;
                }
            }
        };
    }]);
})(window.angular, window.moment);

(function(angular, moment) {
    'use strict';
    angular.module('bluemoon.periods').directive('bmppFiscalYearRangeDisplay', ['bmppEvents', 'bmppFiscalYearService',
        function(bmppEvents, bmppFiscalYearService) {
        return {
            restrict: 'AE',
            scope: {},
            templateUrl: 'components/periods-refactored/bmpp-fiscal-year-range-display/bmpp-fiscal-year-range-display.2js.html',
            link: function(scope) {
                init();

                //the fiscal year has been changed, update the date pickers
                scope.$on(bmppEvents.BMPP_SELECTED_FISCAL_YEAR_CHANGED, function() {
                    updateFiscalYear();
                });

                //initialization code
                function init() {
                    updateFiscalYear();
                }

                //updates the fiscal year values
                function updateFiscalYear() {
                    var selectedFiscalYear = bmppFiscalYearService.getSelectedFiscalYear();

                    scope.startDate = moment(selectedFiscalYear.startDate).toDate();
                    scope.endDate = moment(selectedFiscalYear.endDate).toDate();
                    //always disable this fields as per JO
                    //Year Begin and Year End Date fields above application periods should always be disabled for all regions
                    scope.disableRangeOfDates = true;
                }
            }
        };
    }]);
})(window.angular, window.moment);

(function (angular) {
    'use strict';
    angular.module('bluemoon.periods').directive('bmppApplicationTabs', ['bmppApplicationTypeService', 'bmppFrpService', 'bmppEvents',
        function (bmppApplicationTypeService, bmppFrpService, bmppEvents) {
            return {
                restrict: 'AE',
                scope: {
                    isFirmClient: '='
                },
                templateUrl: 'components/periods-refactored/bmpp-application-tabs/bmpp-application-tabs.2js.html',
                link: function (scope) {
                    //the application types
                    var applicationTypes = bmppApplicationTypeService.getApplicationTypes();

                    init();

                    //the firm periods tab was clicked
                    scope.firmClick = function () {
                        bmppApplicationTypeService.setSelectedApplication(applicationTypes.Firm);
                        scope.activeTab = 2;
                    };

                    //the fixed assets tab was clicked
                    scope.fixedAssetsClick = function () {
                        bmppApplicationTypeService.setSelectedApplication(applicationTypes.FixedAssets);
                        scope.activeTab = 1;
                    };

                    //does this firm have firm periods enabled
                    scope.hasFixedAssets = function () {
                        return bmppFrpService.hasFixedAssets();
                    };

                    //the accounting periods tab was clicked
                    scope.accountingClick = function () {
                        bmppApplicationTypeService.setSelectedApplication(applicationTypes.Accounting);
                        scope.activeTab = 0;
                    };

                    //does this firm have accounting periods enabled
                    scope.hasAccounting = function () {
                        return bmppFrpService.hasAccounting();
                    };

                    //When we close out of the add fiscal year modal, persist the selected type
                    scope.$on(bmppEvents.BMPP_ADD_YEAR_CANCEL_CLICKED, function () {
                        var selectedApplication = bmppApplicationTypeService.getSelectedApplication();
                        if (selectedApplication === applicationTypes.Accounting) {
                            scope.activeTab = 0;
                        } else if (selectedApplication === applicationTypes.FixedAssets) {
                            scope.activeTab = 1;
                        } else if (selectedApplication === applicationTypes.Firm) {
                            scope.activeTab = 2;
                        }
                    });

                    //initialization code
                    function init() {
                        scope.activeTab = 0;
                        //if this firm has accounting, initialize accounting to selected
                        if (bmppFrpService.hasAccounting()) {
                            bmppApplicationTypeService.setSelectedApplication(applicationTypes.Accounting);
                            scope.activeTab = 0;
                        } else if (bmppFrpService.hasFixedAssets()) { //if they don't have accounting but have fixed assets, initialize fixed assets to selected
                            bmppApplicationTypeService.setSelectedApplication(applicationTypes.FixedAssets);
                            scope.activeTab = 1;
                        } else if (scope.isFirmClient) { //if this is the firm client and the above have failed...initialze to Firm
                            bmppApplicationTypeService.setSelectedApplication(applicationTypes.Firm);
                            scope.activeTab = 2;
                        }
                    }
                }
            };
        }
    ]);
})(window.angular);

(function (angular) {
    'use strict';
    angular.module('bluemoon.periods').directive('bmppApplicationPeriodsTabs', ['bmppBusyLoaderService', 'bmppFrpService', 'bmppEvents', 'bmppOwnerService',
        function (bmppBusyLoaderService, bmppFrpService, bmppEvents, bmppOwnerService) {
            return {
                restrict: 'AE',
                scope: {
                    isFirmClient: '='
                },
                templateUrl: 'components/periods-refactored/bmpp-application-periods-tabs/bmpp-application-periods-tabs.2js.html',
                link: function (scope) {

                    init();

                    //listen for changes to the owner so VAT periods will work properly
                    scope.$on(bmppEvents.BMPP_OWNER_CHANGED, function () {
                        scope.ownerId = bmppOwnerService.getOwnerId();
                    });

                    //returns true if the busy loader is busy
                    scope.isLoaderBusy = function () {
                        return bmppBusyLoaderService.isLoaderBusy();
                    };

                    //returns true if this client only needs fiscal years functionality
                    //and none of the period functionality
                    scope.fiscalYearsOnly = function () {
                        return bmppFrpService.fiscalYearsOnly();
                    };

                    //the vat tab was clicked
                    scope.vatClick = function () {
                        scope.activeTab = 1;
                    };

                    //the tax tab was clicked
                    scope.taxClick = function () {
                        scope.activeTab = scope.hasVat() ? 2 : 1;
                    };

                    //does this firm have vat enabled
                    scope.hasVat = function () {
                        return bmppFrpService.hasVat();
                    };

                    //does this firm have UK tax enabled
                    scope.hasUKTax = function () {
                        return bmppFrpService.hasUKTax();
                    };

                    //the financial periods tab was clicked
                    scope.financialClick = function () {
                        scope.activeTab = 0;
                    };

                    //When we close out of the add fiscal year modal, make sure we are on the first tab
                    scope.$on(bmppEvents.BMPP_ADD_YEAR_CANCEL_CLICKED, function () {
                        scope.activeTab = 0;
                    });

                    //initialization code
                    function init() {
                        scope.activeTab = 0;    // initialise to financial periods
                        scope.ownerId = bmppOwnerService.getOwnerId();
                    }
                }
            };
        }
    ]);
})(window.angular);

(function(angular) {
    'use strict';
    angular.module('bluemoon.periods').directive('bmppFiscalYearOnly', ['bmppApplicationTypeService', 'bmppFiscalYearService', '$translate', 'bmppModalService',

        function(bmppApplicationTypeService, bmppFiscalYearService, $translate, bmppModalService) {
            return {
                restrict: 'AE',
                scope: {},
                templateUrl: 'components/periods-refactored/bmpp-fiscal-year-only/bmpp-fiscal-year-only.2js.html',
                link: function(scope) {
                    //the application types
                    var applicationTypes = bmppApplicationTypeService.getApplicationTypes();

                    init();

                    //returns the collection of fiscal years for the combobox
                    scope.getFiscalYears = function() {
                        return bmppFiscalYearService.getFiscalYears();
                    };

                    //add year is clicked, lets go into add mode
                    scope.addYearClick = function() {
                        bmppModalService.openAddFiscalYearModal();
                    };

                    //the user has clicked the edit button on the fiscal year
                    scope.editFiscalYearClick = function(fiscalYear) {
                        bmppFiscalYearService.setSelectedFiscalYear(fiscalYear);
                        bmppModalService.openEditFiscalYearModal();
                    };

                    //initialization code
                    function init() {
                        //when a firm only uses the fiscal years (doesn't need period funcitonality)
                        //we will default them to the Firm period type
                        //because although they aren't using periods, the backend still requires at least 1 period in a fiscal year
                        bmppApplicationTypeService.setSelectedApplication(applicationTypes.Firm);
                        scope.editTooltip = $translate.instant('bmpp.common.edit');
                    }
                }
            };
        }
    ]);
})(window.angular);

(function (angular) {
    'use strict';
    angular.module('bluemoon.periods').directive('bmppContactCombo', ['bmppContactService', 'bmppOwnerService', '$rootScope', 'bmppEvents',
        function (bmppContactService, bmppOwnerService, $rootScope, bmppEvents) {
            return {
                restrict: 'AE',
                scope: {},
                templateUrl: 'components/periods-refactored/bmpp-contact-combo/bmpp-contact-combo.2js.html',
                link: function (scope) {
                    init();

                    //returns the contacts array from the contact service
                    scope.getContacts = function () {
                        return bmppContactService.getContacts();
                    };

                    //when the contact changes, notify the owner service
                    scope.onContactChanged = function (item) {
                        bmppOwnerService.setOwnerId(item.id);
                        bmppContactService.setSelectedContact(scope.selectedContact);
                        $rootScope.$broadcast(bmppEvents.BMPP_OWNER_CHANGED);
                    };

                    //initialize the dropdown
                    function init() {
                        //initialize to the owner id in the owner service
                        scope.selectedContact = bmppContactService.getContacts().find(function (contact) {
                            return contact.id === bmppOwnerService.getOwnerId();
                        });
                        bmppContactService.setSelectedContact(scope.selectedContact);
                    }
                }
            };
        }
    ]);
})(window.angular);

(function (angular) {
    'use strict';
    angular.module('bluemoon.periods').directive('bmppCurrentPeriodCombo', ['$rootScope', 'bmppIacService', 'bmppAddFiscalYearService', 'bmppEditFiscalYearService', 'bmppApplicationTypeService', 'bmppEvents', 'bmppFiscalYearService', 'bmppTransactionCountService', 'bmppYearEndCloseService', 'bmppPeriodService',
        function ($rootScope, bmppIacService, bmppAddFiscalYearService, bmppEditFiscalYearService, bmppApplicationTypeService, bmppEvents, bmppFiscalYearService, bmppTransactionCountService, bmppYearEndCloseService, bmppPeriodService) {
            return {
                restrict: 'AE',
                scope: {
                    periods: '&periods',
                    addingFiscalYear: '=',
                    editingPeriods: '=',
                    useAccountingPeriods: '='
                },
                templateUrl: 'components/periods-refactored/bmpp-current-period-combo/bmpp-current-period-combo.2js.html',
                link: function (scope) {
                    var applicationTypes = bmppApplicationTypeService.getApplicationTypes();

                    //re initialize after the fiscal year is changed
                    scope.$on(bmppEvents.BMPP_SELECTED_FISCAL_YEAR_CHANGED, function () {
                        init();
                        scope.cbCurrentPeriodController.reload();
                    });

                    //reinitialize this directive when add mode changes
                    scope.$on(bmppEvents.BMPP_ADD_MODE_CHANGED, function () {
                        init();
                        scope.cbCurrentPeriodController.reload();
                    });

                    //need to change the period combo when the application type changes
                    scope.$on(bmppEvents.BMPP_SELECTED_APPLICATION_CHANGED, function () {
                        init();
                        scope.cbCurrentPeriodController.reload();
                    });

                    //need to change the period combo when the application type changes
                    scope.$on(bmppEvents.BMPP_ADD_FISCAL_YEAR_FREQUENCY_CHANGED, function (event, isChanged) {
                        if (isChanged) {
                            init();
                            scope.cbCurrentPeriodController.reload();
                        }
                    });

                    //period frequency changed from edit periods wizard
                    scope.$on(bmppEvents.BMPP_EDIT_PERIOD_FREQUENCY_CHANGED, function (event, isChanged) {
                        if (isChanged) {
                            init();
                            scope.cbCurrentPeriodController.reload();
                        }
                    });
                    //custom frequency is changed reload the period combo
                    scope.$on(bmppEvents.BMPP_EDIT_PERIOD_CUSTOM_FREQUENCY_CHANGED, function (event, isChanged) {
                        if (isChanged) {
                            init();
                            scope.cbCurrentPeriodController.reload();
                        }
                    });

                    //If the user clicks cancel in edit fisca lyear, reset the combobox
                    scope.$on(bmppEvents.BMPP_EDIT_FISCAL_YEAR_CANCEL_CLICKED, function () {
                        init();
                        scope.cbCurrentPeriodController.reload();
                    });

                    //If the user changes a period end date, we want to update the combo to take it in
                    scope.$on(bmppEvents.BMPP_EDIT_PERIOD_END_DATE_CHANGED, function () {
                        if (scope.editingPeriods) {
                            init();
                            scope.cbCurrentPeriodController.reload();
                        }
                    });

                    //If the year end date is changed, we want to grab the new year end date for the combobox
                    scope.$on(bmppEvents.BMPP_ADD_YEAR_END_DATE_CHANGED, function () {
                        init();
                        scope.cbCurrentPeriodController.reload();
                    });

                    scope.$watch('periods()', function () {
                        init();
                        if (angular.isDefined(scope.cbCurrentPeriodController)) {
                            scope.cbCurrentPeriodController.reload();
                        }
                    });

                    //Limits periods by if their fiscal year is before or in the current fiscal year or one year after
                    function isAvailableCurrentPeriod(period) {
                        if (bmppPeriodService.isFirmPeriod(period) || bmppPeriodService.isFixedAssetsPeriod(period) || !bmppIacService.hasYearEndClose()) {
                            return true;
                        }
                        var fiscalYearForPeriod = bmppFiscalYearService.getFiscalYearById(period.fiscalYearId);
                        var currentFiscalYear = bmppFiscalYearService.getFiscalYearById(scope.selectedCurrentPeriod.fiscalYearId);

                        //If fiscal year for the period passed in is undefined, it cannot be selected
                        if (!fiscalYearForPeriod || !currentFiscalYear) {
                            return false;
                        }

                        return fiscalYearForPeriod.sequenceNumber <= currentFiscalYear.sequenceNumber + 1;
                    }

                    //get periods for the combo
                    scope.getPeriods = function () {
                        return scope.periods().filter(function (period) {
                            return isAvailableCurrentPeriod(period);
                        });
                    };

                    scope.periodsComboboxDisabled = function() {
                        return scope.getPeriods().length === 0;
                    };

                    //set the selected period as current period
                    scope.currentPeriodChanged = function (period) {
                        //current period is changed and broadcast and event if we need the year end close.
                        if (bmppIacService.hasYearEndClose() && bmppTransactionCountService.hasTransactions() && movingToNextYear(scope.selectedCurrentPeriod)) {
                            bmppYearEndCloseService.setNeedsYearEndClose(true);

                            var fiscalYearToClose = bmppFiscalYearService.getFiscalYearById(scope.initialCurrentPeriod.fiscalYearId);
                            bmppYearEndCloseService.setFiscalYearToClose(fiscalYearToClose);
                        } else {
                            bmppYearEndCloseService.setNeedsYearEndClose(false);
                        }
                        bmppEditFiscalYearService.setCurrentPeriod(period.sequenceNumber);
                        $rootScope.$broadcast(bmppEvents.BMPP_CURRENT_PERIOD_CHANGED, true);
                    };

                    init();

                    //Return true if the newCurrentPeriod is in the next fiscal year from the oldFiscalYear
                    function movingToNextYear(newCurrentPeriod) {
                        if (angular.isUndefined(newCurrentPeriod) || angular.isUndefined(scope.initialCurrentPeriod)) {
                            return false;
                        }
                        var newFiscalYear = bmppFiscalYearService.getFiscalYearById(newCurrentPeriod.fiscalYearId);
                        var oldFiscalYear = bmppFiscalYearService.getFiscalYearById(scope.initialCurrentPeriod.fiscalYearId);

                        return oldFiscalYear.sequenceNumber + 1 === newFiscalYear.sequenceNumber;
                    }

                    //initialize the selected current period value
                    function init() {
                        var getAccountingCurrentPeriod = scope.useAccountingPeriods || false;
                        //get the selected current period from the respective service
                        var selectedPeriod = scope.addingFiscalYear ? bmppAddFiscalYearService.getCurrentPeriod() :
                            //If we're told to get the accounting data specifically, get that
                            getAccountingCurrentPeriod ? bmppEditFiscalYearService.getCurrentPeriodForAccounting() : bmppEditFiscalYearService.getCurrentPeriod();
                        var selectedApplication = getAccountingCurrentPeriod ? applicationTypes.Accounting : bmppApplicationTypeService.getSelectedApplication();
                        var currentPeriod;
                        if (angular.isDefined(scope.periods())) {
                            currentPeriod = scope.periods().find(function (period) {
                                return period.sequenceNumber === selectedPeriod && period.periodType === selectedApplication && !period.isDeleted;
                            });
                        }

                        //set selected current period
                        scope.selectedCurrentPeriod = angular.isDefined(currentPeriod) ? currentPeriod : bmppFiscalYearService.getSavedCurrentPeriod(scope.useAccountingPeriods);
                        scope.initialCurrentPeriod = angular.copy(scope.selectedCurrentPeriod);
                    }
                }
            };
        }
    ]);
})(window.angular);

(function(angular){
    'use strict';
    angular.module('bluemoon.periods').factory('bmppIacService', bmppIacService);
    bmppIacService.$inject = ['bmAccess'];

    function bmppIacService(bmAccess) {
        var _hasYearEndClose = false;

        return {
            hasYearEndClose: hasYearEndClose,
            loadIacs: loadIacs,
        };

        function hasYearEndClose() {
            return _hasYearEndClose;
        }

        function loadIacs() {
            bmAccess.has('WorkpapersYearEndClose').then(function(result) {
                _hasYearEndClose = result;
            }, function() {
                _hasYearEndClose = false;
            });
        }
    }

})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.periods')
        .controller('EditPeriodsCtrl', EditPeriodsCtrl);

    EditPeriodsCtrl.$inject = ['$scope', '$uibModalInstance', '$rootScope', '$translate', 'bmppEvents', 'bmppEditFiscalYearService', 'bmppTaxYearService', 'reloadYear', 'useAccountingPeriods'];

    function EditPeriodsCtrl($scope, $uibModalInstance, $rootScope, $translate, bmppEvents, bmppEditFiscalYearService, bmppTaxYearService, reloadYear, useAccountingPeriods) {
        init();

        //period end date changed
        $scope.$on(bmppEvents.BMPP_EDIT_PERIOD_END_DATE_CHANGED, function () {
            $scope.periodEndDateChanged = true;
        });

        //period frequency changed
        $scope.$on(bmppEvents.BMPP_EDIT_PERIOD_FREQUENCY_CHANGED, function (event, isChanged) {
            $scope.periodFrequencyChanged = isChanged;
        });

        //Tax year changed
        $scope.$on(bmppEvents.BMPP_EDIT_PERIODS_TAX_YEAR_CHANGED, function(event, isChanged) {
            $scope.taxYearChanged = isChanged;
        });

        //period frequency changed
        $scope.$on(bmppEvents.BMPP_CURRENT_PERIOD_CHANGED, function (event, isChanged) {
            $scope.currentPeriodChanged = isChanged;
        });

        //year begin or year end date is changed
        $scope.$on(bmppEvents.BMPP_EDIT_PERIOD_YEAR_BEGIN_YEAR_END_CHANGED, function (event, isChanged) {
            $scope.yearBeginOrEndChanged = isChanged;
        });

        //show the alert message if there are no changes for first wizard page
        $scope.$on(bmppEvents.BMPP_EDIT_PERIOD_NOT_MAPPED_ALERT, function () {
            $scope.alerts = [getMappingWarningAlert()];
        });

        //show the alert message if the periods are not valid
        $scope.$on(bmppEvents.BMPP_EDIT_PERIOD_NOT_VALID_ALERT, function () {
            $scope.alerts = [getInvalidPeriodsAlert()];
        });

        //if we have invalid periods
        $scope.isPeriodsValid = function () {
            return bmppEditFiscalYearService.getPeriodsForCurrentApplication().length !== 0;
        };

        //the user clicked the close button, call the onCancel method
        $scope.close = function () {
            onEditPeriodsExit();
        };

        //period frequency is changed enable the done button
        $scope.isMappingEnable = function () {
            return canSave();
        };

        //returns true if mapping is selected
        $scope.mappingStepSelected = function () {
            return ($scope.step === 1);
        };

        //fires whenever the current step is changed
        $scope.onWizardChange = function () {
            //if they click on the 2nd step without selecting anyting on first step/
            //we need to show the alert saying they need to make the changes in order to move to the
            //2nd step
            if ($scope.mappingStepSelected()) {
                //if the periods are invalid return false
                if (!$scope.isPeriodsValid()) {
                    $rootScope.$broadcast(bmppEvents.BMPP_EDIT_PERIOD_NOT_VALID_ALERT);
                    return false;
                } else if (!$scope.isMappingEnable()) {
                    $rootScope.$broadcast(bmppEvents.BMPP_EDIT_PERIOD_NOT_MAPPED_ALERT);
                    return false;
                } else if (!bmppTaxYearService.isCurrentTaxYearValid()) {
                    //The tax year field is empty or invalid
                    $rootScope.$broadcast(bmppEvents.BMPP_EDIT_PERIOD_TAX_YEAR_INVALID);
                    return false;
                }
            }
        };

        //the user has clicked the done button,
        //lets tell the edit period service to start
        $scope.doneClicked = function () {
            var editingPeriods = true;
            //do we have any changes then only save it down
            if (canSave()) {
                bmppEditFiscalYearService.saveFiscalYear(editingPeriods);
            }
            //fire the save event
            onEditPeriodsExit();
        };
        //if we have any changes on the screen then only save it down
        function canSave() {
            //if anything is changed on this screen we can enable the next button and save it down
            var canSave = $scope.periodFrequencyChanged || $scope.periodEndDateChanged ||
            $scope.currentPeriodChanged || $scope.yearBeginOrEndChanged || $scope.taxYearChanged;
            return canSave;
        }

        //Returns the fiscal year failed error
        function getMappingWarningAlert() {
            return {
                type: 'warning',
                msg: $translate.instant('bmpp.mappingWizard.Alert'),
                closeable: true
            };
        }

        //Returns the invalid periods error
        function getInvalidPeriodsAlert() {
            return {
                type: 'warning',
                msg: $translate.instant('bmpp.mappingWizard.Alert.custom.frequency'),
                closeable: true
            };
        }

        //initialization code
        function init() {
            //initialize step to 0
            $scope.step = 0;
            $scope.periodEndDateChanged = false;
            $scope.periodFrequencyChanged = false;
            $scope.yearBeginOrEndChanged = false;
            $scope.currentPeriodChanged = false;
            $scope.taxYearChanged = false;
            $scope.reloadYear = reloadYear;
            $scope.useAccountingPeriods = useAccountingPeriods;
        }
        //go back to the previous route we came from
        function onEditPeriodsExit() {
            $uibModalInstance.close();
        }
    }
})(window.angular);

(function (angular, _, moment) {
    'use strict';
    angular.module('bluemoon.periods').directive('bmppEditPeriodsNewFrequency', ['$rootScope', 'bmppEditFiscalYearService', 'bmppFrequencyService', 'bmppFiscalYearService', 'bmppApplicationTypeService', 'bmppEvents', 'bmppTaxYearService', 'bmppLocaleService',
        function ($rootScope, bmppEditFiscalYearService, bmppFrequencyService, bmppFiscalYearService, bmppApplicationTypeService, bmppEvents, bmppTaxYearService, bmppLocaleService) {
            return {
                restrict: 'AE',
                scope: {
                    reloadYear: '&',
                    useAccountingPeriods: '='
                },
                templateUrl: 'components/edit-periods/bmpp-edit-periods-new-frequency/bmpp-edit-periods-new-frequency.2js.html',
                link: function (scope) {
                    //the different application types
                    var applicationTypes = bmppApplicationTypeService.getApplicationTypes();

                    function checkFrequencyChanged(newVal, oldVal) {
                        //broadcast the boolean is changed with true or false.
                        //we want to set this to false if they go back and change the previous selection
                        //and the frequency is set to the older value.
                        //in this case we have to show the alert again
                        var isChanged = newVal !== oldVal && newVal !== scope.existingFrequency;
                        $rootScope.$broadcast(bmppEvents.BMPP_EDIT_PERIOD_FREQUENCY_CHANGED, isChanged);
                    }

                    //watch for the selected frequency, we need to call a different endpoint if the selected frequency is not
                    //changed and just the end date is changed
                    scope.$watch('selectedFrequency', function (newVal, oldVal) {
                        checkFrequencyChanged(newVal, oldVal);
                    });

                    scope.$watch('selectedTaxYear', function(newVal, oldVal) {
                        //broadcast the boolean is changed with true or false.
                        //we want to set this to false if they go back and change the previous selection
                        //and the frequency is set to the older value.
                        //in this case we have to show the alert again
                        //Convert to int because in some cases, values from selector are strings
                        var isChanged = parseInt(newVal) !== parseInt(oldVal) && parseInt(newVal) !== scope.currentTaxYear;
                        $rootScope.$broadcast(bmppEvents.BMPP_EDIT_PERIODS_TAX_YEAR_CHANGED, isChanged);
                    });

                    //the user has changed the fiscal year end field
                    scope.endDateChanged = function () {
                        bmppEditFiscalYearService.updateEndDate(scope.endDate);
                        //update the periods
                        newPeriods();

                        //Update the tax years to take in any new years
                        scope.taxYears = getTaxYears();

                        //if they have fixed a previously invalid lets turn off the validation message
                        if (bmppEditFiscalYearService.isFiscalYearValid()) {
                            scope.showValidationMessage = false;
                        }
                    };

                    //the user has changed the fiscal year begin field
                    scope.startDateChanged = function () {
                        bmppEditFiscalYearService.updateStartDate(scope.startDate);
                        //update the periods
                        newPeriods();

                        //Update the tax years to take in any new years
                        scope.taxYears = getTaxYears();

                        //if they have fixed a previously invalid lets turn off the validation message
                        if (bmppEditFiscalYearService.isFiscalYearValid()) {
                            scope.showValidationMessage = false;
                        }
                    };

                    //the user has changed the tax year...send it down to the tax year service and remove validation
                    scope.taxYearChanged = function () {
                        bmppTaxYearService.setCurrentTaxYear(scope.selectedTaxYear);
                        scope.showTaxYearWarning = !bmppTaxYearService.isCurrentTaxYearValid();
                    };

                    //returns true if the start date is editable
                    scope.isStartDateEditable = function () {
                        return bmppEditFiscalYearService.isStartDateEditable();
                    };

                    scope.isStartEndDateVisible = function () {
                        var selectedApplication = bmppApplicationTypeService.getSelectedApplication();
                        //only show this for non accounting applications
                        return selectedApplication !== applicationTypes.Accounting;
                    };

                    //returns true if the end date is editable
                    scope.isEndDateEditable = function () {
                        return bmppEditFiscalYearService.isEndDateEditable();
                    };

                    //stripe out the non numbers
                    scope.$watch('customFrequency', function (newVal, oldVal) {
                        if (angular.isUndefined(newVal)) {
                            scope.customFrequency = oldVal;
                        } else {
                            //only run the validation if they've added characters
                            if (angular.isUndefined(oldVal) || newVal.length > oldVal.length) {
                                scope.customFrequency = newVal.replace(/\D/g, '');
                                scope.customFrequency.trim();
                            }
                            if (newVal.length !== 0) {
                                checkFrequencyChanged(newVal, oldVal);
                            }
                        }
                    });
                    //watch the periods if they changed then we need to broadcast the event for frequency changed.
                    scope.$watch('periods', function (newVal, oldVal) {
                        var changed = angular.isDefined(newVal) && newVal !== oldVal && newVal.length !== 0;
                        $rootScope.$broadcast('BMPP_EDIT_PERIOD_CUSTOM_FREQUENCY_CHANGED', changed);
                    });

                    //watch start date for any changes
                    scope.$watch('startDate', function (newVal, oldVal) {
                        //If the start or end date has been changed before the modal has been opened
                        //We want to automatically broadcast true
                        var changed = angular.isDefined(newVal) && newVal !== oldVal ||
                            bmppEditFiscalYearService.isStartDateChanged()  || bmppEditFiscalYearService.isEndDateChanged();
                        $rootScope.$broadcast('BMPP_EDIT_PERIOD_YEAR_BEGIN_YEAR_END_CHANGED', changed);
                    });

                    scope.$watch('endDate', function (newVal, oldVal) {
                        //If the start or end date has been changed before the modal has been opened
                        //We want to automatically broadcast true
                        var changed = angular.isDefined(newVal) && newVal !== oldVal ||
                            bmppEditFiscalYearService.isStartDateChanged() || bmppEditFiscalYearService.isEndDateChanged();
                        $rootScope.$broadcast('BMPP_EDIT_PERIOD_YEAR_BEGIN_YEAR_END_CHANGED', changed);
                    });

                    //watch the start date.  this does not get updated correct if the only
                    //thing they change is the period end date
                    scope.$watch('period.startDate', function () {
                        newPeriods();
                    });

                    //The tax year field is empty when we try to move onto the next step
                    scope.$on(bmppEvents.BMPP_EDIT_PERIOD_TAX_YEAR_INVALID, function() {
                        scope.showTaxYearWarning = !bmppTaxYearService.isCurrentTaxYearValid();
                    });

                    //the frequency combo has changed,
                    //user is changing the frequency and dates. that needs to be saved to the temporary service
                    scope.onFrequencyChanged = function () {
                        var frequency = bmppFrequencyService.getFrequencyByValue(parseInt(scope.selectedFrequency));
                        //call the edit year service to update the frequency
                        bmppEditFiscalYearService.updateFrequency(frequency, scope.useAccountingPeriods);
                        //new edited periods
                        newPeriods();
                    };

                    //the user has entered a new custom frequency
                    scope.customFrequencyChanged = function () {
                        //first we need to make sure the input is valid
                        if (_.isFinite(scope.customFrequency)) {
                            var frequency = {
                                Value: 0,
                                customFrequency: parseInt(scope.customFrequency)
                            };
                            //call the add year service to update the frequency
                            bmppEditFiscalYearService.updateFrequency(frequency);
                            //update the periods
                            newPeriods();
                        }
                    };

                    //If the user is not in AR, they can edit the frequency
                    scope.canEditFrequency = function() {
                        return bmppLocaleService.isArgentina();
                    };

                    init();

                    //get the existing periods for Accounting
                    //we work with a copy
                    function getExistingPeriodsForApplication() {
                        var fiscalYear = angular.copy(bmppEditFiscalYearService.getFiscalYear());
                        //get the periods that are not mark for deleted for accounting
                        return fiscalYear.periods.filter(function (period) {
                            return period.periodType === applicationTypes.Accounting && !period.isDeleted;
                        });
                    }

                    //update the periods that are currently displayed to the user
                    function newPeriods() {
                        //Undefined prevention
                        var getAccountingPeriods = scope.useAccountingPeriods || false;

                        //If we only want to get the accounting periods, get them
                        //Otherwise use selected application
                        scope.periods = getAccountingPeriods ?
                            bmppEditFiscalYearService.getPeriodsForAccounting() : bmppEditFiscalYearService.getPeriodsForCurrentApplication();
                    }
                    //update the frequency based on the number of periods
                    //update the selected frequency based on the number of periods
                    function existingFrequency() {
                        if (scope.periods.length > 0) {
                            var frequency = scope.useAccountingPeriods ?
                                bmppEditFiscalYearService.getFrequencyForAccounting() : bmppEditFiscalYearService.getFrequencyForCurrentApplication();
                            scope.selectedFrequency = frequency.Value.toString();
                            scope.existingFrequency = frequency.Value.toString();
                            //existing period frequency
                            scope.existingPeriodFrequency = frequency.Display.toString();
                            //if we have a custom frequency, then we need to update that value
                            if (bmppFrequencyService.isCustomFrequency(frequency)) {
                                scope.customFrequency = scope.periods.length;
                            }
                        } else { //if we don't have any periods reset the selected frequency, and custom frequency
                            scope.selectedFrequency = '';
                            scope.customFrequency = null;
                        }
                    }

                    //returns the tax years
                    function getTaxYears() {
                        //Gets the fiscal years and unused tax years
                        var fiscalYears = bmppFiscalYearService.getFiscalYears();
                        var years = bmppTaxYearService.getUnusedTaxYears(fiscalYears);
                        var currentFiscalYear = bmppEditFiscalYearService.getFiscalYear();
                        scope.currentTaxYear = currentFiscalYear.taxCodeYear;

                        years.push(currentFiscalYear.taxCodeYear);

                        //check and make sure that the years we're adding are not used
                        var yearBegin = moment(scope.startDate).year();
                        var yearEnd = moment(scope.endDate).year();

                        //Pushes the year begin and year end dates if they're not used
                        if (!bmppTaxYearService.isTaxYearUsed(fiscalYears, yearBegin, currentFiscalYear.id)) {
                            years.push(yearBegin);
                        }

                        if (!bmppTaxYearService.isTaxYearUsed(fiscalYears, yearEnd, currentFiscalYear.id)) {
                            years.push(yearEnd);
                        }

                        years = _.uniq(years);
                        return years.sort(function (left, right) {
                            return left - right;
                        });
                    }

                    //initialization code
                    function init() {
                        //If the user passes the paramater to refresh the year to saved data,
                        //Call loadFiscalYear
                        if (scope.reloadYear()) {
                            bmppEditFiscalYearService.loadFiscalYear();
                        }
                        var fiscalYear = bmppEditFiscalYearService.getFiscalYear();
                        scope.startDate = new Date(fiscalYear.startDate);
                        scope.endDate = new Date(fiscalYear.endDate);
                        //Tax Year Setup
                        scope.taxYears = getTaxYears();
                        scope.selectedTaxYear = fiscalYear.taxCodeYear;
                        bmppTaxYearService.setCurrentTaxYear(scope.selectedTaxYear);
                        //The selector needs the year as a string
                        if (angular.isDefined(scope.selectedTaxYear)) {
                            scope.selectedTaxYear = scope.selectedTaxYear.toString();
                        }
                        //existing fiscal year end label
                        scope.existingFiscalYearEndDate = fiscalYear.yearEndLabel;
                        //load the translation strings for the frequency dropdown
                        bmppFrequencyService.loadFrequencyTranslationStrings().then(function () {
                            //Undefined prevention
                            var getAccountingFrequencies = scope.useAccountingPeriods || false;
                            //If we want to get the accountingFrequencies, call that specific function
                            scope.frequencies = getAccountingFrequencies ?
                                bmppFrequencyService.getFrequenciesForAccounting() : bmppFrequencyService.getFrequencies();
                        });

                        existingPeriods();
                        existingFrequency();

                        //If they've already changed the start/end date, allow them to move on in the modal
                        if (bmppEditFiscalYearService.isStartDateChanged() || bmppEditFiscalYearService.isEndDateChanged()) {
                            $rootScope.$broadcast('BMPP_EDIT_PERIOD_YEAR_BEGIN_YEAR_END_CHANGED', true);
                        }
                    }
                    //update the periods that are currently displayed to the user
                    function existingPeriods() {
                        scope.periods = getExistingPeriodsForApplication();
                    }

                }
            };
        }
    ]);
})(window.angular, window._, window.moment);

(function (angular, _, moment) {
    'use strict';
    angular.module('bluemoon.periods').directive('bmppEditPeriodsMapping', ['$translate', 'bmppFiscalYearService', 'bmppApplicationTypeService', 'bmppEditFiscalYearService', 'bmppDateManipulatorService',
        function ($translate, bmppFiscalYearService, bmppApplicationTypeService, bmppEditFiscalYearService, bmppDateManipulatorService) {
            return {
                restrict: 'AE',
                scope: {
                    useAccountingPeriods: '='
                },
                templateUrl: 'components/edit-periods/bmpp-edit-periods-mapping/bmpp-edit-periods-mapping.2js.html',
                link: function (scope) {
                    var applicationTypes = bmppApplicationTypeService.getApplicationTypes();
                    init();

                    //get the existing periods
                    function getExistingPeriods() {
                        //get the original periods
                        var fiscalYear = angular.copy(bmppFiscalYearService.getSelectedFiscalYear());

                        //Undefined check on useAccountingPeriods.
                        var useAccounting = scope.useAccountingPeriods || false;

                        //If we only want to get the accounting periods, set the application we filter on to that
                        var selectedApplication = useAccounting ?
                            applicationTypes.Accounting : bmppApplicationTypeService.getSelectedApplication();
                        //Existing periods
                        scope.existingPeriods = _.filter(fiscalYear.periods, function (period) {
                            period.mappingId = period.sequenceNumber;
                            return period.periodType === selectedApplication && !period.isDeleted;
                        });

                    }
                    //get the updated periods if they have changed
                    function getUpdatedPeriod() {
                        //Undefined check on useAccountingPeriods.
                        var getAccountingPeriods = scope.useAccountingPeriods || false;

                        //get the edited periods from the edited period service
                        //If we only want to get the accounting periods, call the function that gets them
                        //otherwise use the selected application
                        var periods = getAccountingPeriods ?
                            bmppEditFiscalYearService.getPeriodsForAccounting() : bmppEditFiscalYearService.getPeriodsForCurrentApplication();
                        // set the new period combo
                        scope.newPeriods = _.filter(periods, function (updatedPeriods) {
                            updatedPeriods.endDateLabel = moment(updatedPeriods.endDate).format('L') + '\xa0\xa0' + '(' + scope.periodLabel + '\xa0' + updatedPeriods.sequenceNumber + ')';
                            updatedPeriods.mappingId = updatedPeriods.sequenceNumber;
                            return updatedPeriods;
                        });

                    }
                    //set the mapping id for the existing periods
                    function setMappingIdForExistingPeriods() {
                        var mappingDates = scope.newPeriods;
                        scope.existingPeriods.forEach(function (existingPeriod) {
                            var date = existingPeriod.endDate;
                            var mappingId = -1;
                            var closestDate = Infinity;
                            mappingDates.forEach(function (matchingDate) {
                                var distance;
                                //if we have changed the dates and the newPeriods are before the existing periods
                                //then we need to reverse the condition.
                                var isLaterDate = bmppDateManipulatorService.isAfter(date, matchingDate.endDate);
                                if (isLaterDate) {
                                    distance = Math.abs(date - matchingDate.endDate);
                                    //only do this when the existingPeriod date is equal or lesser date
                                    if (distance < closestDate && matchingDate.endDate <= date) {
                                        closestDate = distance;
                                        mappingId = matchingDate.sequenceNumber;
                                    }
                                } else {
                                    distance = Math.abs(matchingDate.endDate - date);
                                    //only do this when the existingPeriod date is equal or lesser date
                                    if (distance < closestDate && date <= matchingDate.endDate) {
                                        closestDate = distance;
                                        mappingId = matchingDate.sequenceNumber;
                                    }
                                }

                            });
                            //we found the matching now assign it to the existing period date mapping id
                            existingPeriod.mappingId = mappingId;
                        });
                    }

                    //initialization code
                    function init() {
                        //period label
                        scope.periodLabel = $translate.instant('bmpp.common.period');
                        //existing periods
                        getExistingPeriods();
                        //updated period
                        getUpdatedPeriod();
                        //set the mapping id
                        var sameFrequency = (scope.existingPeriods.length === scope.newPeriods.length);
                        //only try to map when the frequency is changed
                        //if not we just use the same periods
                        if (!sameFrequency) {
                            setMappingIdForExistingPeriods();
                        } else {
                            //The back end fails if we don't put a mapping id, so in that event attach a mapping id with the index
                            scope.existingPeriods.forEach(function(period) {
                                period.mappingId = period.sequenceNumber;
                            });
                        }

                    }
                }
            };
        }
    ]);
})(window.angular, window._, window.moment);

(function (angular) {
    'use strict';
    angular.module('bluemoon.periods').directive('bmppEditPeriodMappingRow', ['$translate', 'bmppEditFiscalYearService',
        function ($translate, bmppEditFiscalYearService) {
            return {
                restrict: 'AE',
                scope: {
                    period: '=',
                    nextPeriod: '=',
                    disabled: '=',
                    index: '@',
                    newPeriods: '=',
                    useAccountingPeriods: '=',
                },
                templateUrl: 'components/edit-periods/bmpp-edit-period-mapping-row/bmpp-edit-period-mapping-row.2js.html',
                link: function (scope) {

                    //clear the services when the directive is destroyed
                    scope.$on('$destroy', function () {
                        scope.$destroy();
                    });

                    //update the existing period dates with the mapping
                    scope.$watch('selectedPeriod', function (newVal) {
                        scope.periodChanged(newVal);
                    });

                    //if the user updates the mapping by changing the combo value
                    //we need to update the mapping id for the selected period
                    scope.periodChanged = function (newPeriod) {
                        bmppEditFiscalYearService.updateMappingForEditedPeriods(newPeriod, scope.period, scope.useAccountingPeriods);
                    };

                    init();

                    //with the mapping index select the new period from the combo
                    function mapSelectedPeriodByMappingId() {
                        //set the selected period and the frequency is not changed
                        //if the frequency is changed then we will map to the same period and not try to find
                        //the dates
                        if (angular.isDefined(scope.period.mappingId) && scope.period.mappingId !== -1 && scope.period.mappingId > 0) {
                            scope.selectedPeriod = scope.newPeriods[scope.period.mappingId - 1];
                        }
                    }
                    //get the label for the existing period
                    function getExistingPeriodLabel() {
                        //change the label for each periods
                        scope.existingPeriodLabel = '';
                        $translate('bmpp.common.period').then(function (existingPeriodLabelTranslation) {
                            var label = '(' + existingPeriodLabelTranslation + '\xa0' + scope.period.sequenceNumber + ')';
                            scope.existingPeriodLabel = label;
                        });
                    }

                    //initialize the row
                    function init() {
                        //find the matching period in the updated period and select the closest match
                        mapSelectedPeriodByMappingId();

                        //set the label for existing period
                        getExistingPeriodLabel();
                    }
                }
            };
        }
    ]);
})(window.angular);

(function(angular) {
    'use strict';
    angular.module('bluemoon.periods').directive('bmppEditPeriodsMappingGrid', [function() {
        return {
            restrict: 'AE',
            scope: {
              existingPeriods: '=',
              newPeriods: '=',
              useAccountingPeriods: '=',
            },
            templateUrl: 'components/edit-periods/bmpp-edit-period-mapping-grid/bmpp-edit-period-mapping-grid.2js.html',
            link: function() {

            }
        };
    }]);
})(window.angular);

angular.module('bm.periods.component.templates', ['components/edit-periods/bmpp-edit-period-mapping-grid/bmpp-edit-period-mapping-grid.2js.html', 'components/edit-periods/bmpp-edit-period-mapping-row/bmpp-edit-period-mapping-row.2js.html', 'components/edit-periods/bmpp-edit-periods-mapping/bmpp-edit-periods-mapping.2js.html', 'components/edit-periods/bmpp-edit-periods-new-frequency/bmpp-edit-periods-new-frequency.2js.html', 'components/edit-periods/bmpp-edit-periods/bmpp-edit-periods.2js.html', 'components/periods-refactored/bmpp-add-fiscal-year-modal-with-periods/bmpp-add-fiscal-year-modal-with-periods.2js.html', 'components/periods-refactored/bmpp-add-fiscal-year-modal/bmpp-add-fiscal-year-modal.2js.html', 'components/periods-refactored/bmpp-add-fiscal-year/bmpp-add-fiscal-year.2js.html', 'components/periods-refactored/bmpp-application-periods-tabs/bmpp-application-periods-tabs.2js.html', 'components/periods-refactored/bmpp-application-tabs/bmpp-application-tabs.2js.html', 'components/periods-refactored/bmpp-contact-combo/bmpp-contact-combo.2js.html', 'components/periods-refactored/bmpp-current-period-combo/bmpp-current-period-combo.2js.html', 'components/periods-refactored/bmpp-date-picker/bmpp-date-picker.2js.html', 'components/periods-refactored/bmpp-edit-fiscal-year-modal/bmpp-edit-fiscal-year-modal.2js.html', 'components/periods-refactored/bmpp-edit-fiscal-year/bmpp-edit-fiscal-year.2js.html', 'components/periods-refactored/bmpp-fiscal-year-combo/bmpp-fiscal-year-combo.2js.html', 'components/periods-refactored/bmpp-fiscal-year-only/bmpp-fiscal-year-only.2js.html', 'components/periods-refactored/bmpp-fiscal-year-range-display/bmpp-fiscal-year-range-display.2js.html', 'components/periods-refactored/bmpp-period-grid/bmpp-period-grid.2js.html', 'components/periods-refactored/bmpp-period-main/bmpp-period-main.2js.html', 'components/periods-refactored/bmpp-period-row/bmpp-period-row.2js.html', 'components/periods-refactored/bmpp-translation-templates/bmpp-translation-templates.2js.html']);

angular.module("components/edit-periods/bmpp-edit-period-mapping-grid/bmpp-edit-period-mapping-grid.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/edit-periods/bmpp-edit-period-mapping-grid/bmpp-edit-period-mapping-grid.2js.html",
    "<div bmpp-edit-period-mapping-row\n" +
    "    disabled=\"disabled\"\n" +
    "    class=\"col-3 form-group\"\n" +
    "    ng-repeat=\"period in existingPeriods\"\n" +
    "    period=\"period\"\n" +
    "    next-period=\"existingPeriods[$index + 1]\"\n" +
    "    index = \"{{$index}}\"\n" +
    "    new-periods=\"newPeriods\"\n" +
    "    use-accounting-periods=\"useAccountingPeriods\">\n" +
    "  </div>\n" +
    "");
}]);

angular.module("components/edit-periods/bmpp-edit-period-mapping-row/bmpp-edit-period-mapping-row.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/edit-periods/bmpp-edit-period-mapping-row/bmpp-edit-period-mapping-row.2js.html",
    "<table class=\"table\" style=\"border-top:none; table-layout: auto;\">\n" +
    "        <tr>\n" +
    "            <td style=\"width:10%; font-weight:bold; border-bottom: none; border-top: none\"> {{period.endDateLabel}}</td>\n" +
    "            <td style=\"border-bottom: none; border-top: none; width: 20.5%;\"> {{existingPeriodLabel}}</td>\n" +
    "            <td style=\"border-bottom: none; border-top: none; width: 20.5%\" for=\"selectedPeriod\" translate=\"bmpp.common.period.changing.to\"></td>\n" +
    "            <td style=\"border-bottom: none; border-top: none; font-weight:bold;\" id=\"selectedPeriod\" bento-combobox get-data=\"newPeriods\"\n" +
    "                label-name=\"endDateLabel\" ng-model=\"selectedPeriod\" on-change=\"periodChanged(item)\">\n" +
    "            </td>\n" +
    "        </tr>\n" +
    "    </table>\n" +
    "");
}]);

angular.module("components/edit-periods/bmpp-edit-periods-mapping/bmpp-edit-periods-mapping.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/edit-periods/bmpp-edit-periods-mapping/bmpp-edit-periods-mapping.2js.html",
    "<div class=\"row\">\n" +
    "        <div class=\"form-group bmpp-edit-periods-mapping-text\">\n" +
    "            <p translate=\"bmpp-period-mapping-tab-description\"></p>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "<article class=\"panel panel-default\" style=\"width: 60%\">\n" +
    "    <div class=\"panel-heading\">\n" +
    "        <div class=\"row\" style=\"margin-left:15px\">\n" +
    "            <div class=\"col-sm-6\">\n" +
    "                <label><span translate=\"bmpp.existing.periods\"></span></label>\n" +
    "            </div>\n" +
    "            <div class=\"col-sm-6\">\n" +
    "                <label><span translate=\"bmpp.new.periods\"></span></label>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"panel-body\">\n" +
    "        <div class=\"row\" style=\"margin-left:15px\">\n" +
    "            <bmpp-edit-periods-mapping-grid existing-periods=\"existingPeriods\" new-periods=\"newPeriods\" use-accounting-periods=\"useAccountingPeriods\"></bmpp-edit-periods-mapping-grid>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</article>\n" +
    "");
}]);

angular.module("components/edit-periods/bmpp-edit-periods-new-frequency/bmpp-edit-periods-new-frequency.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/edit-periods/bmpp-edit-periods-new-frequency/bmpp-edit-periods-new-frequency.2js.html",
    "<div class=\"row\">\n" +
    "    <div class=\"form-group bmpp-edit-periods-mapping-text\">\n" +
    "        <p translate=\"bmpp-edit-periods-tab-label\"></p>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-6 col-sm-6 col-lg-6 form-group\">\n" +
    "                <label translate=\"bmpp-edit-periods-for-label\"></label>\n" +
    "                <br />\n" +
    "                <strong for=\"existingFiscalYearEnd\">{{existingFiscalYearEndDate }}</strong>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-6 col-sm-6 col-lg-6 form-group\">\n" +
    "                <label translate=\"bmpp-edit-period-frequency-label\"></label>\n" +
    "                <br />\n" +
    "                <strong for=\"existingPeriodFrequency\">{{existingPeriodFrequency }}</strong>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-6 col-sm-6 col-lg-6 form-group\">\n" +
    "                <label translate=\"bmpp.common.yearBeginDate\"></label>\n" +
    "                <bmpp-date-picker selected-date=\"startDate\" width=\"90%\" on-change=\"startDateChanged()\" disabled=\"!isStartDateEditable()\"></bmpp-date-picker>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-6 col-sm-6 col-lg-6 form-group\">\n" +
    "                <label translate=\"bmpp.common.yearEndDate\"></label>\n" +
    "                <bmpp-date-picker selected-date=\"endDate\" width=\"90%\" on-change=\"endDateChanged()\" disabled=\"!isEndDateEditable()\"></bmpp-date-picker>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-6 col-sm-6 col-lg-6 form-group\">\n" +
    "                <label for=\"frequencySelect\" translate=\"bmpp-new-period-frequency-label\"></label>\n" +
    "                <select id=\"frequencySelect\" name=\"frequencySelect\" class=\"form-control\" ng-model=\"selectedFrequency\" ng-change=\"onFrequencyChanged()\"\n" +
    "                    style=\"width:81%\" ng-disabled=\"canEditFrequency()\">\n" +
    "                    <option ng-repeat=\"frequency in frequencies\" value=\"{{frequency.Value}}\">{{frequency.Display}}</option>\n" +
    "                </select>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-6 form-group\" ng-show=\"selectedFrequency === '0'\">\n" +
    "                <label translate=\"bmpp.common.customFrequency\"></label>\n" +
    "                <input type=\"text\" class=\"form-control\" ng-blur=\"customFrequencyChanged()\" ng-model=\"customFrequency\"\n" +
    "                    style=\"width:81%\">\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-6 col-sm-6 col-lg-6 form-group\" ng-class=\"{'has-error': showTaxYearWarning}\">\n" +
    "                <label translate=\"bmpp.client.taxYear*\" for=\"taxYearSelect\"></label>\n" +
    "                <select id=\"taxYearSelect\" name=\"taxYearSelect\" class=\"form-control\" ng-model=\"selectedTaxYear\"\n" +
    "                    ng-change=\"taxYearChanged()\" style=\"width:81%\">\n" +
    "                    <option ng-repeat=\"year in taxYears track by $index\" value=\"{{year}}\">{{year}}</option>\n" +
    "                </select>\n" +
    "                <div ng-if=\"showTaxYearWarning\" class=\"msg\" translate=\"bmpp.client.taxYearRequired\">\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <hr ng-show=\"periods.length > 0\" />\n" +
    "        <div class=\"row\">\n" +
    "            <bmpp-period-grid periods=\"periods\" fiscal-year-begin=\"startDate\" fiscal-year-end=\"endDate\" adding-fiscal-year=\"false\" use-accounting-periods=\"useAccountingPeriods\">\n" +
    "            </bmpp-period-grid>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/edit-periods/bmpp-edit-periods/bmpp-edit-periods.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/edit-periods/bmpp-edit-periods/bmpp-edit-periods.2js.html",
    "<div class=\"bmpp-failure-alert-pane\">\n" +
    "    <div bento-alert bento-alert-object=\"alerts\" bento-alert-close=\"closeAlert($index)\"></div>\n" +
    "</div>\n" +
    "<div class=\"modal-workspace-content\" form id=\"editPeriodsForm\" name=\"editPeriodsForm\">\n" +
    "    <!-- Header -->\n" +
    "    <div class=\"bmpp-workspace-modal-header bmpp-workspace-padding\" data-role=\"header\" data-position=\"fixed\">\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Title -->\n" +
    "            <div class=\"col-md-4 col-sm-4 hidden-xs\">\n" +
    "                <h3 translate=\"bmpp.edit.periods\" style=\"color:#93939C\"></h3>\n" +
    "            </div>\n" +
    "            <!-- Buttons -->\n" +
    "            <div class=\"col-md-8 col-sm-8 col-xs-12 text-right\">\n" +
    "                <div>\n" +
    "                    <button class=\"btn btn-default\" id=\"close\" ng-click=\"close()\" translate>bmpp.common.close</button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <!-- Body -->\n" +
    "    <div class=\"modal-workspace-body\" data-role=\"main\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <div bento-wizard total-step=\"2\" on-change=\"onWizardChange(step)\" current-step=\"step\" hide-done-button=\"true\">\n" +
    "                    <ol class=\"steps\">\n" +
    "                        <li>\n" +
    "                            <span class=\"title\" translate=\"bmpp.edit.accountingPeriods\"></span>\n" +
    "                            <span class=\"description\" translate=\"bmpp.edit.periods-title\"></span>\n" +
    "                        </li>\n" +
    "                        <li ng-disabled=\"isMappingDisabled()\">\n" +
    "                            <span class=\"title\" translate=\"bmpp.period.mapping\"></span>\n" +
    "                            <span class=\"description\" translate=\"bmpp.period.mapping-title\"></span>\n" +
    "                        </li>\n" +
    "                    </ol>\n" +
    "                    <ul class=\"contents\">\n" +
    "                        <li>\n" +
    "                            <bmpp-edit-periods-new-frequency reload-year=\"reloadYear\" use-accounting-periods=\"useAccountingPeriods\"></bmpp-edit-periods-new-frequency>\n" +
    "                        </li>\n" +
    "                        <li ng-if=\"mappingStepSelected() && isMappingEnable()\">\n" +
    "                            <bmpp-edit-periods-mapping use-accounting-periods=\"useAccountingPeriods\"></bmpp-edit-periods-mapping>\n" +
    "                        </li>\n" +
    "                    </ul>\n" +
    "                    <button ng-show=\"mappingStepSelected()\" class=\"btn btn-default pull-right\" ng-disabled=\"!isMappingEnable()\"\n" +
    "                        ng-click=\"doneClicked()\">\n" +
    "                        <span translate>bmpp.common.done</span>\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("components/periods-refactored/bmpp-add-fiscal-year-modal-with-periods/bmpp-add-fiscal-year-modal-with-periods.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/periods-refactored/bmpp-add-fiscal-year-modal-with-periods/bmpp-add-fiscal-year-modal-with-periods.2js.html",
    "<div class=\"bmpp-failure-alert-pane\">\n" +
    "    <div bento-alert bento-alert-object=\"alerts\" bento-alert-close=\"closeAlert($index)\"></div>\n" +
    "</div>\n" +
    "<div class=\"modal-workspace-content\" form id=\"editPeriodsForm\" name=\"editPeriodsForm\">\n" +
    "    <!-- Header -->\n" +
    "    <div class=\"bmpp-workspace-modal-header bmpp-workspace-padding\" data-role=\"header\" data-position=\"fixed\">\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Title -->\n" +
    "            <div class=\"col-md-4 col-sm-4 hidden-xs\">\n" +
    "                <h3 translate=\"bmpp.common.createNewYear\" style=\"color:#ffffff\"></h3>\n" +
    "            </div>\n" +
    "            <!-- Buttons -->\n" +
    "            <div class=\"col-md-8 col-sm-8 col-xs-12 text-right\">\n" +
    "                <div>\n" +
    "                    <button class=\"btn btn-primary\" id=\"save\" ng-click=\"saveClick()\" translate>bmpp.common.addFiscalYear</button>\n" +
    "                    <button class=\"btn btn-default\" id=\"cancel\" ng-click=\"cancelClick()\" translate>bmpp.common.close</button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <!-- Body -->\n" +
    "    <div class=\"modal-workspace-body\" data-role=\"main\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <bmpp-application-tabs is-firm-client=\"isFirmClient\"></bmpp-application-tabs>\n" +
    "                <bmpp-add-fiscal-year></bmpp-add-fiscal-year>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/periods-refactored/bmpp-add-fiscal-year-modal/bmpp-add-fiscal-year-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/periods-refactored/bmpp-add-fiscal-year-modal/bmpp-add-fiscal-year-modal.2js.html",
    "<div class=\"bento-modal\">\n" +
    "    <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancelClick()\">\n" +
    "        <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"modal-header\" translate=\"bmpp.common.createNewYear\">\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\" ng-show=\"showValidationMessage\">\n" +
    "            <div class=\"col-md-12 col-sm-12 col-lg-12\">\n" +
    "                <div class=\"bento-alert-container\">\n" +
    "                    <div class=\"alert bento-alert alert-danger\" role=\"alert\">\n" +
    "                        <ul>\n" +
    "                            <li translate=\"bmpp.addFiscalYearError.beginBeforeEnd\"></li>\n" +
    "                            <li translate=\"bmpp.addFiscalYearError.noGaps\"></li>\n" +
    "                            <li translate=\"bmpp.addFiscalYearError.noOverlap\"></li>\n" +
    "                        </ul>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"form-group col-lg-12 col-md-12\" ng-class=\"{'has-error': showValidationMessage}\">\n" +
    "                <label translate=\"bmpp.common.yearBeginDate\"></label><br/>\n" +
    "                <bmpp-date-picker selected-date=\"startDate\" width=\"90%\" on-change=\"startDateChanged()\"></bmpp-date-picker>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"form-group col-lg-12 col-md-12\" ng-class=\"{'has-error': showValidationMessage}\">\n" +
    "                <label translate=\"bmpp.common.yearEndDate\"></label><br/>\n" +
    "                <bmpp-date-picker selected-date=\"endDate\" width=\"90%\" on-change=\"endDateChanged()\"></bmpp-date-picker>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <div>\n" +
    "        <button class=\"btn btn-primary\" ng-click=\"saveClick()\">\n" +
    "            <span translate=\"bmpp.common.save\"></span>\n" +
    "        </button>\n" +
    "        <button class=\"btn btn-default\" ng-click=\"cancelClick()\">\n" +
    "            <span translate=\"bmpp.common.cancel\"></span>\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/periods-refactored/bmpp-add-fiscal-year/bmpp-add-fiscal-year.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/periods-refactored/bmpp-add-fiscal-year/bmpp-add-fiscal-year.2js.html",
    "<div class=\"row\" ng-show=\"showValidationMessage\">\n" +
    "    <div class=\"col-md-12 col-sm-12 col-lg-12\">\n" +
    "        <div class=\"bento-alert-container\">\n" +
    "            <div class=\"alert bento-alert alert-danger\" role=\"alert\">\n" +
    "                <ul>\n" +
    "                    <li translate=\"bmpp.addFiscalYearError.beginBeforeEnd\"></li>\n" +
    "                    <li translate=\"bmpp.addFiscalYearError.noGaps\"></li>\n" +
    "                    <li translate=\"bmpp.addFiscalYearError.noOverlap\"></li>\n" +
    "                </ul>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\" ng-show=\"showNeedsAccountingPeriodsMessage && getSelectedApplication() === applicationTypes.FixedAssets && needsAccountingPeriods()\">\n" +
    "    <div class=\"col-md-12 col-sm-12 col-lg-12\">\n" +
    "        <div class=\"bento-alert-container\">\n" +
    "            <div class=\"alert bento-alert alert-danger\" role=\"alert\">\n" +
    "                <ul>\n" +
    "                    <li>\n" +
    "                        <span translate=\"bmpp.common.frequencyError\"></span>\n" +
    "                    </li>\n" +
    "                </ul>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12 col-sm-12 col-lg-12\">\n" +
    "        <div class=\"bento-container\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-6 col-sm-6 col-lg-6 form-group\">\n" +
    "                    <label translate=\"bmpp.common.yearBeginDate\"></label>\n" +
    "                    <bmpp-date-picker selected-date=\"startDate\" width=\"90%\"\n" +
    "                        data-qe-id=\"bmpp-bmppAddFiscalYear-yearBegin-date-picker\" on-change=\"startDateChanged()\"></bmpp-date-picker>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-6 col-sm-6 col-lg-6 form-group\">\n" +
    "                    <label translate=\"bmpp.common.yearEndDate\"></label>\n" +
    "                    <bmpp-date-picker selected-date=\"endDate\" width=\"90%\"\n" +
    "                        data-qe-id=\"bmpp-bmppAddFiscalYear-yearEnd-date-picker\" on-change=\"endDateChanged()\"></bmpp-date-picker>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\" ng-show=\"showTaxYear()\">\n" +
    "                <div class=\"col-md-6 col-sm-6 col-lg-6 form-group\" ng-class=\"{'has-error': showTaxYearWarning}\">\n" +
    "                    <label translate=\"bmpp.client.taxYear*\" for=\"taxYearSelect\"></label>\n" +
    "                    <select id=\"taxYearSelect\" name=\"taxYearSelect\" class=\"form-control\" ng-model=\"selectedTaxYear\" ng-change=\"taxYearChanged()\"\n" +
    "                        data-qe-id=\"bmpp-bmppAddFiscalYear-taxYear-select\" style=\"width:90%\">\n" +
    "                        <option ng-repeat=\"year in taxYears\" value=\"{{year}}\">{{year}}</option>\n" +
    "                    </select>\n" +
    "                    <div ng-if=\"showTaxYearWarning\" class=\"msg\" translate=\"bmpp.client.taxYearRequired\">\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-6 col-sm-6 col-lg-6 form-group\" ng-class=\"{'has-error': showNeedsAccountingPeriodsMessage && getSelectedApplication() === applicationTypes.Accounting && periods.length === 0}\">\n" +
    "                    <label id=\"frequencySelect-label\" translate=\"bmpp.common.periodFrequency\"></label>\n" +
    "                    <select ng-disabled=\"isFrequencyEnabled()\"\n" +
    "                    role=\"combobox\"\n" +
    "                    aria-labelledby=\"frequencySelect-label\" name=\"frequencySelect\" class=\"form-control\" ng-model=\"selectedFrequency\"\n" +
    "                        data-qe-id=\"bmpp-bmppAddFiscalYear-selectedFrequency-select\"\n" +
    "                        ng-change=\"onFrequencyChanged()\" style=\"width:90%\">\n" +
    "                        <option ng-repeat=\"frequency in frequencies\" value=\"{{frequency.Value}}\">{{frequency.Display}}</option>\n" +
    "                    </select>\n" +
    "                    <div ng-if=\"showNeedsAccountingPeriodsMessage && getSelectedApplication() === applicationTypes.Accounting  && periods.length === 0\"\n" +
    "                        class=\"msg\">\n" +
    "                        Please enter Period Frequency.\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-6 form-group\" ng-show=\"selectedFrequency === '0'\">\n" +
    "                    <label translate=\"bmpp.common.customFrequency\"></label>\n" +
    "                    <input class=\"form-control\" ng-blur=\"customFrequencyChanged()\" ng-model=\"customFrequency\"\n" +
    "                        data-qe-id=\"bmpp-bmppAddFiscalYear-customFrequency-text\" style=\"width:90%\">\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <hr ng-show=\"periods.length > 0\" />\n" +
    "            <div class=\"row\">\n" +
    "                <bmpp-period-grid periods=\"periods\" disabled=\"false\" fiscal-year-begin=\"fiscalYear.startDate\"\n" +
    "                    fiscal-year-end=\"fiscalYear.endDate\" adding-fiscal-year=\"true\" use-accounting-periods=\"false\">\n" +
    "                </bmpp-period-grid>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/periods-refactored/bmpp-application-periods-tabs/bmpp-application-periods-tabs.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/periods-refactored/bmpp-application-periods-tabs/bmpp-application-periods-tabs.2js.html",
    "<div class=\"bmpp-tabs\">\n" +
    "    <div ng-if=\"hasVat() || hasUKTax()\">\n" +
    "        <div class=\"col-md-12 col-sm-12 col-lg-12\" bento-busy-loader=\"isLoaderBusy()\">\n" +
    "            <h2 translate=\"bmpp.applicationTabs.ApplicationPeriods\"></h2>\n" +
    "            <uib-tabset class=\"tabs-top\" active=\"activeTab\">\n" +
    "                <uib-tab ng-click=\"financialClick()\" ng-show=\"true\" qe-id=\"financial-periods-tab\">\n" +
    "                    <uib-tab-heading translate=\"bmpp.applicationTabs.FinancialPeriods\">\n" +
    "                    </uib-tab-heading>\n" +
    "                    <div class=\"col-md-12 col-sm-12 col-lg-12\" bento-busy-loader=\"isLoaderBusy()\">\n" +
    "                        <div ng-if=\"fiscalYearsOnly()\">\n" +
    "                            <bmpp-fiscal-year-only></bmpp-fiscal-year-only>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"!fiscalYearsOnly()\">\n" +
    "                            <bmpp-fiscal-year-combo></bmpp-fiscal-year-combo>\n" +
    "                            <bmpp-fiscal-year-range-display></bmpp-fiscal-year-range-display>\n" +
    "                            <bmpp-application-tabs is-firm-client=\"isFirmClient\"></bmpp-application-tabs>\n" +
    "                            <bmpp-edit-fiscal-year></bmpp-edit-fiscal-year>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </uib-tab>\n" +
    "                <uib-tab ng-click=\"vatClick()\" ng-show=\"hasVat()\" qe-id=\"vat-tab\">\n" +
    "                    <uib-tab-heading translate=\"bmpp.applicationTabs.VAT\">\n" +
    "                    </uib-tab-heading>\n" +
    "                    <uk-vat-periods [contact-id]=\"ownerId\">\n" +
    "                        <p>VAT periods are not supported in this application.</p>\n" +
    "                    </uk-vat-periods>\n" +
    "                </uib-tab>\n" +
    "                <uib-tab ng-click=\"taxClick()\" ng-show=\"hasUKTax()\" qe-id=\"tax-tab\">\n" +
    "                    <uib-tab-heading translate=\"bmpp.applicationTabs.Tax\">\n" +
    "                    </uib-tab-heading>\n" +
    "                    <uk-tax-periods [contact-id]=\"ownerId\">\n" +
    "                        <p translate=\"bmpp.applicationTabs.Tax.UnsupportedEntityMessage\"></p>\n" +
    "                    </uk-tax-periods>\n" +
    "                </uib-tab>\n" +
    "            </uib-tabset>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"!hasVat() && !hasUKTax()\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <bmpp-fiscal-year-combo></bmpp-fiscal-year-combo>\n" +
    "            <bmpp-fiscal-year-range-display></bmpp-fiscal-year-range-display>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-9 col-sm-12 col-lg-9\" bento-busy-loader=\"isLoaderBusy()\">\n" +
    "            <h2 translate=\"bmpp.applicationTabs.ApplicationPeriods\"></h2>\n" +
    "            <bmpp-application-tabs is-firm-client=\"isFirmClient\"></bmpp-application-tabs>\n" +
    "            <bmpp-edit-fiscal-year ng-if=\"!fiscalYearsOnly()\"></bmpp-edit-fiscal-year>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/periods-refactored/bmpp-application-tabs/bmpp-application-tabs.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/periods-refactored/bmpp-application-tabs/bmpp-application-tabs.2js.html",
    "<div class=\"bmpp-tabs\">\n" +
    "    <uib-tabset class=\"tabs-top\" active=\"activeTab\">\n" +
    "        <uib-tab ng-click=\"accountingClick()\" ng-show=\"hasAccounting()\" data-qe-id=\"bmpp-bmppApplicationTabs-accounting-tab\">\n" +
    "            <uib-tab-heading translate=\"bmpp.applicationTabs.Accounting\">\n" +
    "            </uib-tab-heading>\n" +
    "        </uib-tab>\n" +
    "        <uib-tab ng-click=\"fixedAssetsClick()\" ng-show=\"hasFixedAssets()\" data-qe-id=\"bmpp-bmppApplicationTabs-fixedAssets-tab\">\n" +
    "            <uib-tab-heading translate=\"bmpp.applicationTabs.FixedAssets\">\n" +
    "            </uib-tab-heading>\n" +
    "        </uib-tab>\n" +
    "        <uib-tab ng-click=\"firmClick()\" ng-show=\"isFirmClient\" data-qe-id=\"bmpp-bmppApplicationTabs-firm-tab\">\n" +
    "            <uib-tab-heading translate=\"bmpp.applicationTabs.Firm\">\n" +
    "            </uib-tab-heading>\n" +
    "        </uib-tab>\n" +
    "    </uib-tabset>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/periods-refactored/bmpp-contact-combo/bmpp-contact-combo.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/periods-refactored/bmpp-contact-combo/bmpp-contact-combo.2js.html",
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-6 col-sm-6 col-lg-6 form-group\">\n" +
    "        <label id=\"editingPeriodsFor-label\" translate=\"bmpp.contactCombo.editingPeriodsFor\"></label>\n" +
    "        <div bento-combobox\n" +
    "        role=\"combobox\"\n" +
    "        aria-labelledby=\"editingPeriodsFor-label\"\n" +
    "         placeholder=\"{{'bmpp.common.selectHere' | translate }}\" ng-model=\"selectedContact\" get-data=\"getContacts()\" label-name=\"displayAs\" on-change=\"onContactChanged(item)\"></div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/periods-refactored/bmpp-current-period-combo/bmpp-current-period-combo.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/periods-refactored/bmpp-current-period-combo/bmpp-current-period-combo.2js.html",
    "<label id=\"endDateLabel-label\" translate=\"bmpp.common.currentPeriod\"></label>\n" +
    "<div  role=\"combobox\"\n" +
    "aria-labelledby=\"endDateLabel-label\"\n" +
    "bento-combobox placeholder=\"{{'bmpp.common.selectHere' | translate }}\" get-data=\"getPeriods()\" ng-disabled=\"periodsComboboxDisabled()\"\n" +
    "    data-qe-id=\"bmpp-currentPeriodCombo-selectedCurrentPeriod-combobox\"\n" +
    "    label-name=\"endDateLabel\" ng-model=\"selectedCurrentPeriod\" controller=\"cbCurrentPeriodController\" on-change=\"currentPeriodChanged(item)\" style=\"width: 90%;\">\n" +
    "</div>\n" +
    "<bmyec-year-end-close-main\n" +
    "  ng-if=\"isYearEndCloseVisible\"\n" +
    "  (modal-close)=\"onYearEndClose()\"\n" +
    "  (modal-cancel)=\"onYearEndCancel()\"\n" +
    "  fiscal-year-id=\"{{initialCurrentPeriod.fiscalYearId}}\"\n" +
    "  fiscal-year=\"{{getYearByFiscalYearId(initialCurrentPeriod.fiscalYearId)}}\"\n" +
    "  owner-id=\"{{ownerId}}\"\n" +
    "  contact-display-name=\"{{getContactName()}}\"></bmyec-year-end-close-main>\n" +
    "");
}]);

angular.module("components/periods-refactored/bmpp-date-picker/bmpp-date-picker.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/periods-refactored/bmpp-date-picker/bmpp-date-picker.2js.html",
    "<div class=\"input-group bento-datepicker\" ng-class=\"{'disabled' : disabled}\" ng-style=\"{width: width}\">\n" +
    "    <input type=\"text\" aria-label=\"Set Date\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"selectedDate\" ng-style=\"{width: width}\" ng-blur=\"datePickerBlur()\"\n" +
    "      is-open=\"datePickerOpened\" datepicker-options=\"dateOptions\" min-date=\"'2001-01-01'\"\n" +
    "      show-button-bar=\"false\" show-weeks=\"false\" ng-required=\"false\" ng-invalid=\"invalid\" ng-click=\"openDatePicker($event)\">\n" +
    "    <span class=\"input-group-btn\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\" aria-label=\"Open Datepicker\" ng-click=\"openDatePicker($event)\">\n" +
    "            <i class=\"bento-icon-calendar\"></i>\n" +
    "        </button>\n" +
    "    </span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/periods-refactored/bmpp-edit-fiscal-year-modal/bmpp-edit-fiscal-year-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/periods-refactored/bmpp-edit-fiscal-year-modal/bmpp-edit-fiscal-year-modal.2js.html",
    "<div class=\"bento-modal\">\n" +
    "    <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancelClick()\">\n" +
    "        <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"modal-header\" translate=\"bmpp.edit.fiscal.year\"></div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\" ng-show=\"showValidationMessage\">\n" +
    "            <div class=\"col-md-12 col-sm-12 col-lg-12\">\n" +
    "                <div class=\"bento-alert-container\">\n" +
    "                    <div class=\"alert bento-alert alert-danger\" role=\"alert\">\n" +
    "                        <ul>\n" +
    "                            <li translate=\"bmpp.addFiscalYearError.beginBeforeEnd\"></li>\n" +
    "                            <li translate=\"bmpp.addFiscalYearError.noGaps\"></li>\n" +
    "                            <li translate=\"bmpp.addFiscalYearError.noOverlap\"></li>\n" +
    "                        </ul>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"form-group col-lg-12 col-md-12\" ng-class=\"{'has-error': showValidationMessage}\">\n" +
    "                <label translate=\"bmpp.common.yearBeginDate\"></label><br/>\n" +
    "                <bmpp-date-picker selected-date=\"startDate\" width=\"90%\" on-change=\"startDateChanged()\" disabled=\"!isStartDateEditable()\"></bmpp-date-picker>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"form-group col-lg-12 col-md-12\" ng-class=\"{'has-error': showValidationMessage}\">\n" +
    "                <label translate=\"bmpp.common.yearEndDate\"></label><br/>\n" +
    "                <bmpp-date-picker selected-date=\"endDate\" width=\"90%\" on-change=\"endDateChanged()\" disabled=\"!isEndDateEditable()\"></bmpp-date-picker>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <div>\n" +
    "        <button class=\"btn btn-primary\" ng-click=\"saveClick()\">\n" +
    "            <span translate=\"bmpp.common.save\"></span>\n" +
    "        </button>\n" +
    "        <button class=\"btn btn-default\" ng-click=\"cancelClick()\">\n" +
    "            <span translate=\"bmpp.common.cancel\"></span>\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/periods-refactored/bmpp-edit-fiscal-year/bmpp-edit-fiscal-year.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/periods-refactored/bmpp-edit-fiscal-year/bmpp-edit-fiscal-year.2js.html",
    "<article class=\"panel panel-default\">\n" +
    "    <div class=\"panel-heading\">\n" +
    "        {{editFiscalYearTitle}}\n" +
    "        <button class=\"btn btn-default btn-sm\" ng-click=\"cancelClick()\"\n" +
    "            data-qe-id=\"bmpp-bmppEditFiscalYear-cancel-button\" style=\"float:right;  margin-left:10px\">\n" +
    "            <span translate=\"bmpp.common.cancel\"></span>\n" +
    "        </button>\n" +
    "        <button class=\"btn btn-primary btn-sm\" ng-click=\"saveClick()\" style=\"float:right;\"\n" +
    "            data-qe-id=\"bmpp-bmppEditFiscalYear-save-button\"\n" +
    "            ng-disabled=\"periods.length === 0\">\n" +
    "            <span translate=\"bmpp.common.save\"></span>\n" +
    "        </button>\n" +
    "    </div>\n" +
    "    <div class=\"panel-body\">\n" +
    "        <div class=\"row\" ng-show=\"showValidationMessage\">\n" +
    "            <div class=\"col-md-12 col-sm-12 col-lg-12\">\n" +
    "                <div class=\"bento-alert-container\">\n" +
    "                    <div class=\"alert bento-alert alert-danger\" role=\"alert\">\n" +
    "                        <ul>\n" +
    "                            <li translate=\"bmpp.addFiscalYearError.beginBeforeEnd\"></li>\n" +
    "                            <li translate=\"bmpp.addFiscalYearError.noGaps\"></li>\n" +
    "                            <li translate=\"bmpp.addFiscalYearError.noOverlap\"></li>\n" +
    "                        </ul>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-12 col-sm-12 col-lg-12\">\n" +
    "                <div class=\"bento-container\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-md-12\">\n" +
    "                            <div class=\"row\" ng-show=\"isStartEndDateVisible()\">\n" +
    "                                <div class=\"col-md-6 col-sm-6 col-lg-6 form-group\">\n" +
    "                                    <label translate=\"bmpp.common.yearBeginDate\"></label>\n" +
    "                                    <bmpp-date-picker selected-date=\"startDate\" width=\"90%\"\n" +
    "                                        data-qe-id=\"bmpp-bmppEditFiscalYear-startDate-date-picker\"\n" +
    "                                        on-change=\"startDateChanged()\" disabled=\"!isStartDateEditable()\">\n" +
    "                                    </bmpp-date-picker>\n" +
    "                                </div>\n" +
    "                                <div class=\"col-md-6 col-sm-6 col-lg-6 form-group\">\n" +
    "                                    <label translate=\"bmpp.common.yearEndDate\"></label>\n" +
    "                                    <bmpp-date-picker selected-date=\"endDate\" width=\"90%\" on-change=\"endDateChanged()\"\n" +
    "                                        data-qe-id=\"bmpp-bmppEditFiscalYear-endDate-date-picker\"\n" +
    "                                        disabled=\"!isEndDateEditable()\"></bmpp-date-picker>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div class=\"row\">\n" +
    "                                <div class=\"col-md-6 col-sm-6 col-lg-6 form-group\">\n" +
    "                                    <bmpp-current-period-combo periods='periods' adding-fiscal-year=\"false\">\n" +
    "                                    </bmpp-current-period-combo>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div class=\"row\">\n" +
    "                                <div class=\"col-md-6 col-sm-6 col-lg-6 form-group\">\n" +
    "                                    <div style=\"width:90%\">\n" +
    "                                        <label id=\"frequencySelect-label\" translate=\"bmpp.common.periodFrequency\"></label>\n" +
    "                                        <select role=\"combobox\"\n" +
    "                                        aria-labelledby=\"frequencySelect-label\" name=\"frequencySelect\" ng-disabled=\"!isFrequencyEnabled()\"\n" +
    "                                            data-qe-id=\"bmpp-bmppEditFiscalYear-selectedFrequency-select\"\n" +
    "                                            class=\"form-control\" ng-model=\"selectedFrequency\"\n" +
    "                                            ng-change=\"onFrequencyChanged()\" ng-disabled=\"!isEditable()\">\n" +
    "                                            <option ng-repeat=\"frequency in frequencies\" value=\"{{frequency.Value}}\">\n" +
    "                                                {{frequency.Display}}</option>\n" +
    "                                        </select>\n" +
    "                                        <a href=\"\" ng-show=\"canEditPeriods()\" ng-click=\"editPeriodsClicked()\"\n" +
    "                                            data-qe-id=\"bmpp-bmppEditFiscalYear-editPeriods-button\"\n" +
    "                                            style=\"float:right; padding-top: 5px\">\n" +
    "                                            <span translate=\"bmpp.edit.periods\"></span>\n" +
    "                                        </a>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                                <div class=\"col-md-6 form-group\" ng-show=\"selectedFrequency === '7'\">\n" +
    "                                    <label translate=\"bmpp.common.customFrequency\"></label>\n" +
    "                                    <input class=\"form-control\" ng-blur=\"customFrequencyChanged()\"\n" +
    "                                        data-qe-id=\"bmpp-bmppEditFiscalYear-customFrequency-text\"\n" +
    "                                        ng-model=\"customFrequency\" style=\"width:90%\" ng-disabled=\"!isEditable()\">\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <hr ng-show=\"periods.length > 0\" />\n" +
    "                    <div class=\"row\">\n" +
    "                        <bmpp-period-grid periods=\"periods\" disabled=\"!isEditable()\" fiscal-year-begin=\"startDate\"\n" +
    "                            fiscal-year-end=\"endDate\" adding-fiscal-year=\"false\" use-accounting-periods=\"false\">\n" +
    "                        </bmpp-period-grid>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <bmyec-year-end-close-main ng-if=\"startYearEndCloseProcess\" (modal-close)=\"onYearEndClose($event)\"\n" +
    "            (modal-cancel)=\"onYearEndCancel()\" fiscal-year-id=\"{{fiscalYearToClose.id}}\"\n" +
    "            fiscal-year=\"{{fiscalYearToCloseString}}\" owner-id=\"{{ownerId}}\"\n" +
    "            contact-display-name=\"{{getContactName()}}\">\n" +
    "        </bmyec-year-end-close-main>\n" +
    "    </div>\n" +
    "</article>\n" +
    "");
}]);

angular.module("components/periods-refactored/bmpp-fiscal-year-combo/bmpp-fiscal-year-combo.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/periods-refactored/bmpp-fiscal-year-combo/bmpp-fiscal-year-combo.2js.html",
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-6 col-sm-6 col-lg-6\">\n" +
    "        <label id=\"yearEndLabel-label\" translate=\"bmpp.common.fiscalYearEnd\"></label>\n" +
    "        <div bento-combobox\n" +
    "        role=\"combobox\"\n" +
    "        aria-labelledby=\"yearEndLabel-label\"\n" +
    "        placeholder=\"{{'bmpp.common.selectHere' | translate }}\" get-data=\"getFiscalYears()\"\n" +
    "            data-qe-id=\"bmpp-bmppFiscalYearCombo-changeFiscalYear-combobox\"\n" +
    "            label-name=\"yearEndLabel\" searchable=\"true\" ng-model=\"selectedFiscalYear\" controller=\"cbCurrentYearController\" on-change=\"fiscalYearChanged(item)\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-6 col-sm-6 col-lg-6\">\n" +
    "        <div class=\"pull-right\" style=\"margin: 5px;\">\n" +
    "            <a ng-click=\"addYearClick()\" data-qe-id=\"bmpp-bmppFiscalYearCombo-createNewYear-button\">\n" +
    "                <span translate=\"bmpp.common.createNewYear\"></span>\n" +
    "            </a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/periods-refactored/bmpp-fiscal-year-only/bmpp-fiscal-year-only.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/periods-refactored/bmpp-fiscal-year-only/bmpp-fiscal-year-only.2js.html",
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-6 col-sm-6 col-lg-6\">\n" +
    "        <table class=\"table\">\n" +
    "            <thead>\n" +
    "                <th translate=\"bmpp.fiscalYearsOnly.action\">\n" +
    "                </th>\n" +
    "                <th translate=\"bmpp.common.yearBeginDate\">\n" +
    "                </th>\n" +
    "                <th translate=\"bmpp.common.yearEndDate\">\n" +
    "                </th>\n" +
    "            </thead>\n" +
    "            <tbody>\n" +
    "                <tr ng-repeat=\"fiscalYear in getFiscalYears() track by fiscalYear.id\">\n" +
    "                    <td>\n" +
    "                        <i class=\"bento-icon-edit\" uib-tooltip=\"{{editTooltip}}\" tooltip-placement=\"top\"\n" +
    "                        data-qe-id=\"bmpp-bmppFiscalYearOnly-editFiscalYearClick-button\"\n" +
    "                        tooltip-append-to-body=\"true\" tooltip-trigger=\"mouseenter\" ng-click=\"editFiscalYearClick(fiscalYear)\" ng-if=\"$first || $last\"></i>\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{fiscalYear.yearBeginLabel}}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{fiscalYear.yearEndLabel}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "            </tbody>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-6 col-sm-6 col-lg-6\">\n" +
    "        <div class=\"pull-right\">\n" +
    "            <a ng-click=\"addYearClick()\" data-qe-id=\"bmpp-bmppFiscalYearOnly-createNewYear-button\"><span translate=\"bmpp.common.createNewYear\"></span></a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/periods-refactored/bmpp-fiscal-year-range-display/bmpp-fiscal-year-range-display.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/periods-refactored/bmpp-fiscal-year-range-display/bmpp-fiscal-year-range-display.2js.html",
    "<div class=\"row\">\n" +
    "    <div class=\"col-sm-3 col-md-3 col-lg-3 form-group\">\n" +
    "        <label><span translate=\"bmpp.common.yearBeginDate\"></span></label>\n" +
    "        <br/>\n" +
    "        <bmpp-date-picker data-qe-id=\"bmpp-bmppFiscalYearRangeDisplay-startDate-date-picker\"\n" +
    "            selected-date=\"startDate\" width=\"93%\" disabled=\"disableRangeOfDates\"></bmpp-date-picker>\n" +
    "    </div>\n" +
    "    <div class=\"col-sm-3 col-md-3 col-lg-3 form-group\">\n" +
    "        <label><span translate=\"bmpp.common.yearEndDate\"></span></label>\n" +
    "        <br/>\n" +
    "        <bmpp-date-picker data-qe-id=\"bmpp-bmppFiscalYearRangeDisplay-endDate-date-picker\"\n" +
    "            selected-date=\"endDate\" width=\"93%\" disabled=\"disableRangeOfDates\"></bmpp-date-picker>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/periods-refactored/bmpp-period-grid/bmpp-period-grid.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/periods-refactored/bmpp-period-grid/bmpp-period-grid.2js.html",
    "<!-- <div class=\"bmpp-flex-container\">\n" +
    "<div class=\"bmpp-flex-box\"> -->\n" +
    "<div bmpp-period-row class=\"col-md-6 col-sm-6 col-lg-6 form-group\" disabled=\"disabled\" datepicker-width=\"90%\" topbar-width=\"80%\"\n" +
    "        ng-repeat=\"period in periods\" period=\"period\" next-period=\"periods[$index + 1]\" fiscal-year-begin=\"fiscalYearBegin\"\n" +
    "        fiscal-year-end=\"fiscalYearEnd\" index=\"{{$index}}\" is-first-period=\"$first\" is-last-period=\"$last\" adding-fiscal-year=\"addingFiscalYear\"\n" +
    "        use-accounting-periods=\"useAccountingPeriods\">\n" +
    " </div>\n" +
    "<!-- </div>\n" +
    "</div> -->");
}]);

angular.module("components/periods-refactored/bmpp-period-main/bmpp-period-main.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/periods-refactored/bmpp-period-main/bmpp-period-main.2js.html",
    "<div class=\"force-desktop\">\n" +
    "    <div class=\"bmpp-failure-alert-pane\">\n" +
    "        <div bento-alert bento-alert-object=\"alerts\" bento-alert-close=\"closeAlert($index)\"></div>\n" +
    "    </div>\n" +
    "    <div class=\"col-md-12\" ng-if=\"showRelatedContacts\">\n" +
    "        <bmpp-contact-combo ng-if=\"contactsLoaded\"></bmpp-contact-combo>\n" +
    "        <div class=\"col-md-6\" bento-busy-loader=\"(!fiscalYearsLoaded || !accountsLoaded) && contactsLoaded\" bento-busy-loader-size=\"small\"></div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"fiscalYearsOnly() && !hasVat() && fiscalYearsLoaded && accountsLoaded\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <bmpp-fiscal-year-only></bmpp-fiscal-year-only>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-show=\"(!fiscalYearsOnly() || hasVat()) && fiscalYearsLoaded && accountsLoaded && transactionCountLoaded\">\n" +
    "        <bmpp-application-periods-tabs is-firm-client=\"isFirmClient\"></bmpp-application-periods-tabs>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/periods-refactored/bmpp-period-row/bmpp-period-row.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/periods-refactored/bmpp-period-row/bmpp-period-row.2js.html",
    "<div class=\"form-group\" ng-class=\"{'has-error': periodHasError}\">\n" +
    "    <div>\n" +
    "        <!-- <div ng-click=\"setCurrentPeriod(period)\" style=\"width:{{topbarWidth}}\"> -->\n" +
    "            <!-- TODO: Trans: Instead, replace bmpp.common.period with bmp.common.periodX -->\n" +
    "            <label><span translate=\"bmpp.common.period\"></span>&nbsp;{{period.sequenceNumber}}</label>\n" +
    "            <!-- <a href=\"\" ng-show=\"isCurrenLinkVisible() && !isCurrentPeriod()\" style=\"float:right;\"><span translate=\"bmpp.common.setAsCurrentPeriod\"></span></a> -->\n" +
    "        <!-- <div ng-show=\"isCurrentPeriod()\" style=\"float: right;\"><span translate=\"bmpp.common.currentPeriod\"></span></div> -->\n" +
    "        <!-- </div> -->\n" +
    "    </div>\n" +
    "    <bmpp-date-picker disabled=\"disabled || isLastPeriod\" selected-date=\"period.endDate\" invalid=\"periodHasError\"\n" +
    "        width=\"{{datepickerWidth}}\"\n" +
    "        data-qe-id=\"bmpp-bmppPeriodRow-period-{{period.sequenceNumber}}-date-picker\"\n" +
    "        ng-class=\"{'has-error': periodHasError}\"></bmpp-date-picker>\n" +
    "    <div ng-if=\"periodErrors.yearBeginError\" class=\"msg\" translate=\"bmpp.periodError.yearBegin\"></div>\n" +
    "    <div ng-if=\"periodErrors.yearEndError\" class=\"msg\" translate=\"bmpp.periodError.yearEnd\"></div>\n" +
    "    <div ng-if=\"periodErrors.overlapError\" class=\"msg\" translate=\"bmpp.periodError.overlap\"></div>\n" +
    "</div>\n" +
    "<!-- <div class=\"bento-alert-container\" ng-show=\"periodHasError\" ng-style=\"{width: datepickerWidth}\">\n" +
    "    <div class=\"alert bento-alert alert-danger\">\n" +
    "        <span style=\"text-color:red\" ng-if=\"periodErrors.yearBeginError\" translate=\"bmpp.periodError.yearBegin\"></span>\n" +
    "        <span style=\"text-color:red\" ng-if=\"periodErrors.yearEndError\" translate=\"bmpp.periodError.yearEnd\"></span>\n" +
    "        <span style=\"text-color:red\" ng-if=\"periodErrors.overlapError\" translate=\"bmpp.periodError.overlap\"></span>\n" +
    "    </div>\n" +
    "</div> -->\n" +
    "");
}]);

angular.module("components/periods-refactored/bmpp-translation-templates/bmpp-translation-templates.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/periods-refactored/bmpp-translation-templates/bmpp-translation-templates.2js.html",
    "<!-- This file holds keys to tranlations that were being over written by grunt -->\n" +
    "<div translate=\"bmpp.bmppPeriodEditYear.xToYPeriods\">\n" +
    "</div>\n" +
    "<div translate=\"bmpp.commonFrequency.annual\">\n" +
    "</div>\n" +
    "<div translate=\"bmpp.commonFrequency.monthly\">\n" +
    "</div>\n" +
    "<div translate=\"bmpp.commonFrequency.quarterly\">\n" +
    "</div>\n" +
    "<div translate=\"bmpp.commonFrequency.weekly\">\n" +
    "</div>\n" +
    "<div translate=\"bmpp.commonFrequency.thirteen\">\n" +
    "</div>\n" +
    "<div translate=\"bmpp.commonFrequency.semiAnnual\">\n" +
    "</div>\n" +
    "<div translate=\"bmpp.commonFrequency.custom\">\n" +
    "</div>\n" +
    "");
}]);
